import { useState, useEffect, useRef } from "react";
import {
  LineChart, Line, BarChart, Bar, XAxis, YAxis,
  CartesianGrid, Tooltip, ResponsiveContainer, Cell, Legend
} from "recharts";
import supabase from "./services/supabaseClient";
import { signIn, signUp, getSession, onAuthStateChange, resetPassword, updatePassword } from "./services/authService";

// 
// SVG ICONS — clean line style matching reference images
// 
const IconHome=({size=20,color="currentColor",strokeWidth=1.8})=>(
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z"/>
    <path d="M9 21V12h6v9"/>
  </svg>
);
const IconResults=({size=20,color="currentColor",strokeWidth=1.8})=>(
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="2" width="14" height="20" rx="2"/>
    <path d="M9 7h6M9 11h6M9 15h4"/>
  </svg>
);
const IconTrends=({size=20,color="currentColor",strokeWidth=1.8})=>(
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/>
    <polyline points="16 7 22 7 22 13"/>
  </svg>
);
const IconBell=({size=20,color="currentColor",strokeWidth=1.8})=>(
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
  </svg>
);
const IconUser=({size=20,color="currentColor",strokeWidth=1.8})=>(
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);
const IconDashboard=({size=20,color="currentColor",strokeWidth=1.8})=>(
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1"/>
    <rect x="14" y="3" width="7" height="7" rx="1"/>
    <rect x="3" y="14" width="7" height="7" rx="1"/>
    <rect x="14" y="14" width="7" height="7" rx="1"/>
  </svg>
);
const IconUpload=({size=20,color="currentColor",strokeWidth=1.8})=>(
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="17 8 12 3 7 8"/>
    <line x1="12" y1="3" x2="12" y2="15"/>
  </svg>
);
const IconStudents=({size=20,color="currentColor",strokeWidth=1.8})=>(
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const IconClasses=({size=20,color="currentColor",strokeWidth=1.8})=>(
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
  </svg>
);
const IconAnalytics=({size=20,color="currentColor",strokeWidth=1.8})=>(
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10"/>
    <line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/>
  </svg>
);
const IconSettings=({size=20,color="currentColor",strokeWidth=1.8})=>(
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);

// EduGrade Logo — clean monogram badge (swap this SVG for your own logo asset)
const EduGradeLogo=({size=36})=>{
  const r=Math.round(size*0.22);
  const font=Math.round(size*0.44);
  return(
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="egGrad" x1="0" y1="0" x2={size} y2={size} gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#3b82f6"/>
          <stop offset="100%" stopColor="#1a3a8c"/>
        </linearGradient>
      </defs>
      <rect x="0" y="0" width={size} height={size} rx={r} fill="url(#egGrad)"/>
      <text x={size/2} y={size/2+font*0.36} textAnchor="middle"
        fontFamily="'Inter','Segoe UI',sans-serif" fontWeight="800"
        fontSize={font} fill="#ffffff" letterSpacing="-1">EG</text>
    </svg>
  );
};

// 
const T = {
  bg:"#f4f6f9", surface:"#fff", surfaceAlt:"#f8f9fb",
  border:"#e8ecf1", borderLight:"#f0f3f7",
  primary:"#3b82f6", primaryLight:"#eff6ff", primaryMid:"#bfdbfe",
  secondary:"#6366f1", secondaryLight:"#eef2ff",
  teal:"#14b8a6", tealLight:"#f0fdfa",
  green:"#10b981", greenLight:"#ecfdf5",
  amber:"#f59e0b", amberLight:"#fffbeb",
  red:"#ef4444", redLight:"#fef2f2",
  purple:"#8b5cf6", purpleLight:"#f5f3ff",
  text:"#111827", textMid:"#374151", textMuted:"#6b7280", textFaint:"#9ca3af",
  shadow:"0 1px 4px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.04)",
  shadowMd:"0 2px 8px rgba(0,0,0,0.08),0 8px 24px rgba(0,0,0,0.05)",
  shadowLg:"0 8px 32px rgba(0,0,0,0.12)",
};

// 
// CBC DATA & HELPERS
// 
const CBC_GRADES = [
  {min:90,max:100,level:"EE1",points:8,label:"Exceeding Expectation",short:"EE",color:"#10b981",bg:"#ecfdf5"},
  {min:75,max:89, level:"EE2",points:7,label:"Exceeding Expectation",short:"EE",color:"#14b8a6",bg:"#f0fdfa"},
  {min:58,max:74, level:"ME1",points:6,label:"Meeting Expectation",  short:"ME",color:"#3b82f6",bg:"#eff6ff"},
  {min:41,max:57, level:"ME2",points:5,label:"Meeting Expectation",  short:"ME",color:"#6366f1",bg:"#eef2ff"},
  {min:31,max:40, level:"AE1",points:4,label:"Approaching Expectation",short:"AE",color:"#f59e0b",bg:"#fffbeb"},
  {min:21,max:30, level:"AE2",points:3,label:"Approaching Expectation",short:"AE",color:"#f97316",bg:"#fff7ed"},
  {min:11,max:20, level:"BE1",points:2,label:"Below Expectation",    short:"BE",color:"#ef4444",bg:"#fef2f2"},
  {min:1, max:10, level:"BE2",points:1,label:"Below Expectation",    short:"BE",color:"#dc2626",bg:"#fef2f2"},
];
const getCBC = s => CBC_GRADES.find(g=>s>=g.min&&s<=g.max)||CBC_GRADES[7];

// CBC Subjects by curriculum level
const CBC_SUBJECTS = {
  "Early Years": ["Literacy","English Language Activities","Kiswahili Language Activities","Mathematical Activities","Environmental Activities","Hygiene and Nutrition","Creative Activities","Religious Education","Movement and Creative Activities"],
  "Upper Primary": ["English","Kiswahili","Mathematics","Science and Technology","Social Studies","Agriculture","Creative Arts","Religious Education","Physical and Health Education","Life Skills Education"],
  "Junior Secondary": ["English","Kiswahili","Mathematics","Integrated Science","Social Studies","Pre-Technical Studies","Agriculture","Business Studies","Creative Arts","Religious Education","Life Skills Education"],
  "Senior Secondary STEM": ["Mathematics","Physics","Chemistry","Biology","Computer Science","Engineering Technology"],
  "Senior Secondary Arts": ["History","Geography","Business Studies","Economics","Music","Fine Arts"],
};

const SUBJECT_ABBR = {
  "English":"ENG","Kiswahili":"KSW","Mathematics":"MATH","Integrated Science":"I.SCI",
  "Science and Technology":"S&T","Social Studies":"SOC","Agriculture":"AGRI",
  "Business Studies":"BST","Creative Arts":"C.ART","Religious Education":"CRE",
  "Life Skills Education":"LSK","Pre-Technical Studies":"PTS","Physical and Health Education":"PHE",
  "Literacy":"LIT","Mathematical Activities":"MATH-A","Environmental Activities":"ENV",
  "Hygiene and Nutrition":"H&N","Creative Activities":"CREAT","Physics":"PHY",
  "Chemistry":"CHEM","Biology":"BIO","Computer Science":"CS","Engineering Technology":"ENG-T",
  "History":"HIST","Geography":"GEO","Economics":"ECON","Music":"MUS","Fine Arts":"F.ART",
};

const getCurriculumLevel = (cls) => {
  if (!cls) return "Junior Secondary";
  const lower = cls.toLowerCase();
  if (lower.includes("grade 1")||lower.includes("grade 2")||lower.includes("grade 3")||lower.includes("pp")) return "Early Years";
  if (lower.includes("grade 4")||lower.includes("grade 5")||lower.includes("grade 6")) return "Upper Primary";
  if (lower.includes("grade 7")||lower.includes("grade 8")||lower.includes("grade 9")) return "Junior Secondary";
  return "Junior Secondary";
};

// 
// PASSWORD STRENGTH HELPER
// 
function checkPasswordStrength(pw){
  const checks={
    length:   pw.length>=8,
    upper:    /[A-Z]/.test(pw),
    lower:    /[a-z]/.test(pw),
    number:   /[0-9]/.test(pw),
    special:  /[!@#$%^&*()_+\-=\[\]{};':"\|,.<>\/?`~]/.test(pw),
  };
  const score=Object.values(checks).filter(Boolean).length;
  const labels={1:"Very Weak",2:"Weak",3:"Fair",4:"Strong",5:"Very Strong"};
  const colors={1:T.red,2:"#f97316",3:T.amber,4:"#84cc16",5:T.green};
  return{checks,score,label:labels[score]||"Very Weak",color:colors[score]||T.red,valid:checks.length&&checks.upper&&checks.lower&&checks.number&&checks.special};
}

function PasswordStrengthBar({password}){
  if(!password)return null;
  const {checks,score,label,color,valid}=checkPasswordStrength(password);
  const rules=[
    {key:"length",  text:"At least 8 characters"},
    {key:"upper",   text:"Uppercase letter (A–Z)"},
    {key:"lower",   text:"Lowercase letter (a–z)"},
    {key:"number",  text:"Number (0–9)"},
    {key:"special", text:"Special character (!@#$…)"},
  ];
  return(
    <div style={{marginTop:8,marginBottom:4}}>
      <div style={{display:"flex",gap:4,marginBottom:6}}>
        {[1,2,3,4,5].map(i=>(
          <div key={i} style={{flex:1,height:4,borderRadius:99,background:i<=score?color:T.borderLight,transition:"background 0.3s"}}/>
        ))}
      </div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
        <span style={{fontSize:11,color:T.textFaint}}>Password strength</span>
        <span style={{fontSize:11,fontWeight:700,color}}>{label}</span>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"2px 8px"}}>
        {rules.map(r=>(
          <div key={r.key} style={{display:"flex",alignItems:"center",gap:5,fontSize:11,color:checks[r.key]?T.green:T.textFaint}}>
            <span style={{fontSize:10}}>{checks[r.key]?"":""}</span>{r.text}
          </div>
        ))}
      </div>
    </div>
  );
}


const computeTerm = td => {
  const subjects = td.subjects.map(s=>({...s,cbc:getCBC(s.marks)}));
  const total = subjects.reduce((a,b)=>a+b.marks,0);
  const mean = total/subjects.length;
  const points = subjects.reduce((a,b)=>a+b.cbc.points,0);
  return {...td,subjects,total,mean:mean.toFixed(1),points,meanCBC:getCBC(Math.round(mean))};
};

const getAcc = async id => { const {data}=await supabase.from("accounts").select("*").eq("id",id).single(); return data; };
const getStudent = async id => { const {data}=await supabase.from("students").select("*").eq("id",id).single(); return data; };

function timeAgo(ts){
  // Accept timestamp number, ISO string, or date string — always parse as UTC
  const ms = typeof ts === "number" ? ts : new Date(String(ts).includes("Z")||String(ts).includes("+") ? ts : ts+"Z").getTime();
  const d=Date.now()-ms,m=Math.floor(d/60000),h=Math.floor(m/60),dy=Math.floor(h/24),wk=Math.floor(dy/7);
  if(m<1)return"Just now";if(m<60)return`${m}m ago`;if(h<24)return`${h}h ago`;if(dy<7)return`${dy}d ago`;if(wk<5)return`${wk}w ago`;
  return new Date(ms).toLocaleDateString("en-KE",{day:"numeric",month:"short",year:"numeric"});
}
function formatDate(ts){return new Date(ts).toLocaleDateString("en-KE",{day:"numeric",month:"long",year:"numeric"});}

// 
// SHARED UI PRIMITIVES
// 
const Card = ({children,style={}}) => <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:18,boxShadow:T.shadow,...style}}>{children}</div>;

const CBCBadge = ({level,size="sm"}) => {
  const g=CBC_GRADES.find(g=>g.level===level); if(!g)return null;
  const lg=size==="lg";
  return <span style={{background:g.bg,color:g.color,fontWeight:700,border:`1.5px solid ${g.color}33`,fontSize:lg?13:11,padding:lg?"4px 12px":"2px 8px",borderRadius:99,letterSpacing:0.3,display:"inline-block"}}>{g.level}</span>;
};

const PBar = ({value,max=100,color,height=6}) => (
  <div style={{background:T.borderLight,borderRadius:99,height,overflow:"hidden"}}>
    <div style={{height:"100%",width:`${Math.min(100,(value/max)*100)}%`,background:color,borderRadius:99,transition:"width 0.8s ease"}}/>
  </div>
);

const SLabel = ({children,style={}}) => <div style={{color:T.textMuted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:10,...style}}>{children}</div>;
const Divider = ({my=16}) => <div style={{height:1,background:T.border,margin:`${my}px 0`}}/>;

const Field = ({label,value,onChange,type="text",placeholder="",error="",note=""}) => (
  <div style={{marginBottom:14}}>
    {label&&<label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>{label}</label>}
    <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
      style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${error?T.red:T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:14,outline:"none",boxSizing:"border-box",fontFamily:"inherit"}}/>
    {error&&<div style={{color:T.red,fontSize:11,marginTop:4}}>{error}</div>}
    {note&&<div style={{color:T.textFaint,fontSize:11,marginTop:4}}>{note}</div>}
  </div>
);

const Select = ({label,value,onChange,options}) => (
  <div style={{marginBottom:14}}>
    {label&&<label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>{label}</label>}
    <select value={value} onChange={e=>onChange(e.target.value)}
      style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}>
      {options.map(o=><option key={o.value||o} value={o.value||o}>{o.label||o}</option>)}
    </select>
  </div>
);

const Btn = ({children,onClick,variant="primary",size="md",disabled=false,full=false,style={}}) => {
  const sz={sm:{padding:"6px 13px",fontSize:12},md:{padding:"10px 18px",fontSize:14},lg:{padding:"13px",fontSize:15}};
  const va={
    primary:{background:disabled?"#93c5fd":T.primary,color:"#fff",boxShadow:`0 2px 8px ${T.primary}44`,border:"none"},
    secondary:{background:T.surfaceAlt,color:T.textMid,border:`1px solid ${T.border}`},
    danger:{background:T.redLight,color:T.red,border:`1px solid ${T.red}33`},
    ghost:{background:"none",color:T.primary,border:"none"},
    teal:{background:T.tealLight,color:T.teal,border:`1px solid ${T.teal}33`},
  };
  return <button onClick={disabled?undefined:onClick} style={{...sz[size],...va[variant],borderRadius:10,fontFamily:"inherit",fontWeight:700,cursor:disabled?"not-allowed":"pointer",transition:"opacity 0.15s",width:full?"100%":"auto",...style}}>{children}</button>;
};

const Toast = ({msg,type="info",onClose}) => {
  useEffect(()=>{const t=setTimeout(onClose,5000);return()=>clearTimeout(t);},[]);
  const c={info:T.primary,success:T.green,error:T.red,warning:T.amber};
  const icons={info:"ℹ",success:"",error:"",warning:""};
  return(
    <div style={{position:"fixed",top:16,right:16,zIndex:9999,background:T.surface,border:`1px solid ${T.border}`,borderLeft:`4px solid ${c[type]}`,borderRadius:12,padding:"13px 16px",display:"flex",gap:10,boxShadow:T.shadowLg,maxWidth:320,animation:"slideIn 0.3s ease"}}>
      <span>{icons[type]}</span>
      <div style={{flex:1,color:T.textMid,fontSize:13,lineHeight:1.5}}>{msg}</div>
      <button onClick={onClose} style={{background:"none",border:"none",color:T.textFaint,cursor:"pointer",fontSize:16,padding:0,lineHeight:1}}>×</button>
    </div>
  );
};

const Modal = ({title,children,onClose,width=440}) => (
  <div style={{position:"fixed",inset:0,zIndex:9000,background:"rgba(0,0,0,0.4)",display:"flex",alignItems:"center",justifyContent:"center",padding:20}} onClick={e=>e.target===e.currentTarget&&onClose()}>
    <div style={{background:T.surface,borderRadius:20,width:"100%",maxWidth:width,boxShadow:T.shadowLg,animation:"scaleIn 0.2s ease",maxHeight:"90vh",overflow:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"20px 24px 0",position:"sticky",top:0,background:T.surface,zIndex:1}}>
        <h3 style={{margin:0,fontSize:17,fontWeight:800,color:T.text}}>{title}</h3>
        <button onClick={onClose} style={{background:T.surfaceAlt,border:`1px solid ${T.border}`,borderRadius:8,width:30,height:30,cursor:"pointer",color:T.textMuted,fontSize:18,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
      </div>
      <div style={{padding:"14px 24px 24px"}}>{children}</div>
    </div>
  </div>
);

const Badge = ({children,color=T.primary,bg=T.primaryLight,style={}}) => (
  <span style={{background:bg,color,fontSize:11,fontWeight:700,padding:"2px 9px",borderRadius:99,border:`1px solid ${color}22`,...style}}>{children}</span>
);

const StatCard = ({icon,label,value,color,bg,sub}) => (
  <div style={{background:bg,border:`1px solid ${color}22`,borderRadius:14,padding:"14px 10px",textAlign:"center"}}>
    <div style={{display:"flex",justifyContent:"center",marginBottom:6}}>{icon}</div>
    <div style={{color,fontWeight:800,fontSize:22}}>{value}</div>
    <div style={{color:T.textMuted,fontSize:11,marginTop:1}}>{label}</div>
    {sub&&<div style={{color:T.textFaint,fontSize:10,marginTop:1}}>{sub}</div>}
  </div>
);

// 
// AUTH SCREENS
// 
function LoginScreen({onLogin,onRegister,onSchoolRegister}){
  const [email,setEmail]=useState("");
  const [pass,setPass]=useState("");
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState("");
  const [showForgot,setShowForgot]=useState(false);
  const [fpEmail,setFpEmail]=useState("");
  const [fpMsg,setFpMsg]=useState("");
  const [fpLoading,setFpLoading]=useState(false);

  async function submit(){
    setError("");
    if(!email||!pass){setError("Please fill all fields.");return;}
    setLoading(true);
    try{
      const {user}=await signIn(email,pass);
      const {data:acc,error:profileError}=await supabase.from("accounts").select("*").eq("id",user.id).single();
      setLoading(false);
      if(profileError||!acc){
        setError("Account not found. If you just registered, please verify your email first.");
        return;
      }
      onLogin(acc);
    }catch(err){
      setLoading(false);
      if(err.message?.includes("Email not confirmed")){
        setError("Please verify your email before signing in.");
      } else if(err.message?.includes("Invalid login credentials")){
        setError("Invalid email or password. Please check and try again.");
      } else {
        setError(err.message||"Sign in failed. Please try again.");
      }
    }
  }

  async function submitForgot(){
    setFpMsg("");
    if(!fpEmail.includes("@")){setFpMsg("error:Please enter a valid email address.");return;}
    setFpLoading(true);
    try{
      await supabase.auth.resetPasswordForEmail(fpEmail.trim(), {
        redirectTo: 'https://edu-grade-rho.vercel.app'
      });
      setFpMsg("success:Reset link sent! Check your email inbox.");
    }catch(err){
      setFpMsg("error:"+(err.message||"Failed to send reset email. Please try again."));
    }
    setFpLoading(false);
  }

  return(
    <div style={{minHeight:"100vh",background:T.bg,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Inter',sans-serif",padding:24}}>
      <div style={{width:"100%",maxWidth:400}}>
        <div style={{textAlign:"center",marginBottom:32}}>
          <div style={{marginBottom:10}}>
              <div style={{fontSize:30,fontWeight:800,color:T.text,letterSpacing:"-0.5px",lineHeight:1}}>EduGrade</div>
              <div style={{fontSize:11,color:T.textFaint,letterSpacing:0.5,marginTop:4}}>CBC ACADEMIC PORTAL</div>
          </div>
          <p style={{color:T.textMuted,fontSize:13,margin:0}}>Kenya Competency Based Curriculum · Student Performance Tracker</p>
        </div>

        <Card style={{padding:32}}>
          <h2 style={{margin:"0 0 4px",fontSize:20,fontWeight:800,color:T.text}}>Sign In</h2>
          <p style={{margin:"0 0 22px",color:T.textMuted,fontSize:13}}>Access your parent or school admin account</p>
          {error&&<div style={{background:T.redLight,border:`1px solid ${T.red}33`,borderRadius:10,padding:"10px 14px",color:T.red,fontSize:13,marginBottom:16}}>{error}</div>}
          <Field label="Email Address" value={email} onChange={setEmail} type="email"/>
          <Field label="Password" value={pass} onChange={setPass} type="password"/>
          <div style={{textAlign:"right",marginTop:-8,marginBottom:14}}>
            <span onClick={()=>{setShowForgot(true);setFpEmail(email);setFpMsg("");}}
              style={{color:T.primary,fontSize:13,fontWeight:600,cursor:"pointer"}}>Forgot Password?</span>
          </div>
          <Btn onClick={submit} disabled={loading} full size="lg">{loading?"Signing in…":"Sign In"}</Btn>
          <div style={{textAlign:"center",marginTop:14}}>
            <span style={{color:T.textMuted,fontSize:13}}>New parent? </span>
            <span style={{color:T.primary,cursor:"pointer",fontWeight:600,fontSize:13}} onClick={onRegister}>Create account →</span>
          </div>
          <Divider my={14}/>
          <div style={{background:T.surfaceAlt,border:`1px solid ${T.border}`,borderRadius:12,padding:"14px 16px",textAlign:"center"}}>
            <div style={{fontSize:13,color:T.textMid,fontWeight:600,marginBottom:4}}>Are you a school administrator?</div>
            <div style={{fontSize:12,color:T.textMuted,marginBottom:10}}>Register your school on EduGrade to upload results and connect with parents.</div>
            <Btn variant="teal" full onClick={onSchoolRegister}>Register School on EduGrade →</Btn>
          </div>
        </Card>
        <p style={{textAlign:"center",color:T.textFaint,fontSize:11,marginTop:20}}>© 2024 EduGrade · Kenya CBC Platform · All rights reserved</p>
      </div>

      {showForgot&&(
        <Modal title="Reset Password" onClose={()=>setShowForgot(false)}>
          <p style={{color:T.textMuted,fontSize:13,margin:"0 0 16px",lineHeight:1.6}}>
            Enter your email address and we'll send you a link to reset your password.
          </p>
          {fpMsg&&(
            <div style={{
              background:fpMsg.startsWith("success:")?T.greenLight:T.redLight,
              border:`1px solid ${fpMsg.startsWith("success:")?T.green:T.red}33`,
              borderRadius:10,padding:"10px 14px",
              color:fpMsg.startsWith("success:")?T.green:T.red,
              fontSize:13,marginBottom:14
            }}>{fpMsg.replace(/^(success|error):/,"")}</div>
          )}
          <Field label="Email Address" value={fpEmail} onChange={setFpEmail} type="email" placeholder="jane@example.com"/>
          <div style={{display:"flex",gap:8}}>
            <Btn variant="secondary" onClick={()=>setShowForgot(false)}>Cancel</Btn>
            <Btn onClick={submitForgot} disabled={fpLoading} style={{flex:1}}>
              {fpLoading?"Sending…":"Send Reset Link"}
            </Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}

function RegisterScreen({onLogin,onBack}){
  const [step,setStep]=useState(1); // 1=form, 2=otp input
  const [form,setForm]=useState({name:"",email:"",phone:"",password:"",confirm:""});
  const [otp,setOtp]=useState("");
  const [errors,setErrors]=useState({});
  const [loading,setLoading]=useState(false);
  const [userId,setUserId]=useState(null);
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));

  function validate(){
    const e={};
    if(!form.name.trim())e.name="Full name is required";
    if(!form.email.includes("@"))e.email="Enter a valid email address";
    if(!form.phone.startsWith("+"))e.phone="Include country code e.g. +254…";
    const pwStrength=checkPasswordStrength(form.password);
    if(!pwStrength.valid)e.password="Password must have uppercase, lowercase, number and special character (min 8 chars)";
    if(form.password!==form.confirm)e.confirm="Passwords do not match";
    setErrors(e);
    return Object.keys(e).length===0;
  }

  async function handleRegister(){
    if(!validate())return;
    setLoading(true);
    try{
      const {user}=await signUp(form.email,form.password,{name:form.name.trim(),phone:form.phone,role:"parent"});
      setUserId(user.id);
      setLoading(false);
      setStep(2);
    }catch(err){
      setLoading(false);
      setErrors({general:err.message||"Registration failed. Please try again."});
    }
  }

  async function handleVerifyOtp(){
    if(!otp||otp.length<6){setErrors({otp:"Enter the 6-digit code sent to your email"});return;}
    setLoading(true);
    try{
      const {data,error}=await supabase.auth.verifyOtp({
        email: form.email,
        token: otp.trim(),
        type:  "signup",
      });
      if(error)throw error;
      // Insert account row after successful verification
      const {data:acc,error:insertError}=await supabase.from("accounts").insert([{
        id:              data.user.id,
        name:            form.name.trim(),
        email:           form.email.toLowerCase(),
        phone:           form.phone,
        role:            "parent",
        verified:        true,
        linked_students: [],
      }]).select().single();
      if(insertError&&insertError.code!=="23505") throw insertError; // ignore duplicate
      // Fetch account if already exists
      const finalAcc = acc || (await supabase.from("accounts").select("*").eq("id",data.user.id).single()).data;
      await supabase.from("notifications").insert([{
        parent_id:  data.user.id,
        student_id: null,
        title:      "Welcome to EduGrade!",
        body:       "Your account is ready. Link your child's admission number to start tracking results.",
        type:       "system",
        read:       false,
      }]);
      setLoading(false);
      onLogin(finalAcc);
    }catch(err){
      setLoading(false);
      setErrors({otp:err.message||"Invalid code. Please try again."});
    }
  }

  return(
    <div style={{minHeight:"100vh",background:T.bg,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Inter',sans-serif",padding:24}}>
      <div style={{width:"100%",maxWidth:420}}>
        <div style={{textAlign:"center",marginBottom:28}}>
          <div style={{marginBottom:8}}>
            <div style={{fontSize:28,fontWeight:800,color:T.text,letterSpacing:"-0.5px",lineHeight:1}}>EduGrade</div>
            <div style={{fontSize:11,color:T.textFaint,letterSpacing:0.5,marginTop:3}}>CBC ACADEMIC PORTAL</div>
          </div>
        </div>
        <Card style={{padding:32}}>
          {step===1?(
            <>
              <h2 style={{margin:"0 0 4px",fontSize:20,fontWeight:800,color:T.text}}>Create Parent Account</h2>
              <p style={{margin:"0 0 20px",color:T.textMuted,fontSize:13}}>Monitor your child's CBC academic performance</p>
              {errors.general&&<div style={{background:T.redLight,border:`1px solid ${T.red}33`,borderRadius:10,padding:"10px 14px",color:T.red,fontSize:13,marginBottom:14}}>{errors.general}</div>}
              <Field label="Full Name" value={form.name} onChange={v=>set("name",v)} placeholder="Jane Kamau" error={errors.name}/>
              <Field label="Email Address" value={form.email} onChange={v=>set("email",v)} type="email" placeholder="jane@example.com" error={errors.email}/>
              <Field label="Phone Number" value={form.phone} onChange={v=>set("phone",v)} placeholder="+254712345678" error={errors.phone} note="Used for account recovery"/>
              <Field label="Password" value={form.password} onChange={v=>set("password",v)} type="password" error={errors.password}/>
              <PasswordStrengthBar password={form.password}/>
              <Field label="Confirm Password" value={form.confirm} onChange={v=>set("confirm",v)} type="password" error={errors.confirm}/>
              <Btn onClick={handleRegister} disabled={loading} full size="lg">{loading?"Creating account…":"Create Account →"}</Btn>
              <div style={{textAlign:"center",marginTop:14}}>
                <span style={{color:T.textMuted,fontSize:13}}>Have an account? </span>
                <span style={{color:T.primary,cursor:"pointer",fontWeight:600,fontSize:13}} onClick={onBack}>Sign in</span>
              </div>
            </>
          ):(
            <>
              <div style={{textAlign:"center",marginBottom:20}}>
                <div style={{fontSize:48,marginBottom:12}}></div>
                <h2 style={{margin:"0 0 8px",fontSize:20,fontWeight:800,color:T.text}}>Check Your Email</h2>
                <p style={{margin:0,color:T.textMuted,fontSize:13,lineHeight:1.6}}>
                  We sent a 6-digit code to<br/>
                  <strong style={{color:T.text}}>{form.email}</strong>
                </p>
              </div>
              {errors.otp&&<div style={{background:T.redLight,border:`1px solid ${T.red}33`,borderRadius:10,padding:"10px 14px",color:T.red,fontSize:13,marginBottom:14}}>{errors.otp}</div>}
              <div style={{marginBottom:12}}>
                <div style={{fontSize:12,fontWeight:600,color:"#374151",marginBottom:6}}>Verification Code</div>
                <input
                  value={otp}
                  onChange={e=>setOtp(e.target.value.replace(/\D/g,'').slice(0,6))}
                  placeholder="Enter 6-digit code"
                  maxLength={6}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  style={{width:"100%",textAlign:"center",fontSize:28,letterSpacing:12,fontWeight:800,
                    padding:"12px",borderRadius:10,border:"1.5px solid #e8ecf1",
                    background:"#f9fafb",outline:"none",boxSizing:"border-box"}}
                />
              </div>
              <Btn onClick={handleVerifyOtp} disabled={loading} full size="lg">{loading?"Verifying…":"Verify & Activate Account"}</Btn>
              <div style={{textAlign:"center",marginTop:12,color:T.textMuted,fontSize:12}}>
                Didn't receive it? Check your spam folder or{" "}
                <span style={{color:T.primary,cursor:"pointer"}} onClick={()=>setStep(1)}>go back</span>
              </div>
            </>
          )}
        </Card>
      </div>
    </div>
  );
}
// 
// SCHOOL REGISTRATION SCREEN
// 
const KENYA_COUNTIES = [
  "Baringo","Bomet","Bungoma","Busia","Elgeyo-Marakwet","Embu","Garissa","Homa Bay",
  "Isiolo","Kajiado","Kakamega","Kericho","Kiambu","Kilifi","Kirinyaga","Kisii","Kisumu",
  "Kitui","Kwale","Laikipia","Lamu","Machakos","Makueni","Mandera","Marsabit","Meru",
  "Migori","Mombasa","Murang'a","Nairobi","Nakuru","Nandi","Narok","Nyamira","Nyandarua",
  "Nyeri","Samburu","Siaya","Taita-Taveta","Tana River","Tharaka-Nithi","Trans Nzoia",
  "Turkana","Uasin Gishu","Vihiga","Wajir","West Pokot"
];

const SCHOOL_LEVELS = [
  {value:"Early Years",     label:"Early Years",          desc:"PP1, PP2, Grade 1–3",  icon:""},
  {value:"Upper Primary",   label:"Upper Primary",        desc:"Grade 4–6",             icon:""},
  {value:"Junior Secondary",label:"Junior Secondary",     desc:"Grade 7–9",             icon:""},
  {value:"Senior Secondary",label:"Senior Secondary",     desc:"Grade 10–12",           icon:""},
];

function SchoolRegisterScreen({onLogin,onBack}){
  const [step,setStep]=useState(1);
  const [otp,setOtp]=useState("");
  const [generatedOtp,setGeneratedOtp]=useState("");
  const [loading,setLoading]=useState(false);
  const [errors,setErrors]=useState({});
  const [form,setForm]=useState({
    // School details
    nemis:"", name:"", county:"", subCounty:"", level:"",
    phone:"", email:"",
    // Admin account
    adminName:"", adminEmail:"", adminPhone:"", password:"", confirm:"",
  });
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));

  const STEPS=["School Details","Administrator Account","Verify Email"];

  // Step 1 validation
  function validateStep1(){
    const e={};
    if(!form.nemis.trim())e.nemis="NEMIS code is required";
    if(!form.name.trim())e.name="School name is required";
    if(!form.county)e.county="County is required";
    if(!form.subCounty.trim())e.subCounty="Sub-county is required";
    if(!form.level)e.level="Select the school curriculum level";
    if(form.phone&&!form.phone.startsWith("+"))e.phone="Include country code e.g. +254…";
    setErrors(e);
    return Object.keys(e).length===0;
  }

  // Step 2 validation
  function validateStep2(){
    const e={};
    if(!form.adminName.trim())e.adminName="Your full name is required";
    if(!form.adminEmail.includes("@"))e.adminEmail="Enter a valid email address";
    if(!form.adminPhone.startsWith("+"))e.adminPhone="Include country code e.g. +254…";
    const pwCheck=checkPasswordStrength(form.password);
    if(!pwCheck.valid)e.password="Password must include uppercase, lowercase, number and special character (min 8 chars)";
    if(form.password!==form.confirm)e.confirm="Passwords do not match";
    setErrors(e);
    return Object.keys(e).length===0;
  }

  function goToStep2(){if(validateStep1()){setErrors({});setStep(2);}}

  function sendOtp(){
    if(!validateStep2())return;
    setLoading(true);
    setTimeout(()=>{setLoading(false);setStep(3);},600);
  }

  async function verifyAndCreate(){
    setLoading(true);
    try{
      // 1. Create admin user in Supabase Auth
      const {user}=await signUp(form.adminEmail,form.password,{
        name: form.adminName.trim(),
        role: "admin",
      });

      // 2. Insert school row first (account needs school UUID as foreign key)
      const {data:school,error:schoolError}=await supabase.from("schools").insert([{
        name:        form.name.trim(),
        nemis:       form.nemis.trim().toUpperCase(),
        county:      form.county,
        sub_county:  form.subCounty.trim(),
        location:    form.subCounty.trim(),
        level:       form.level,
        phone:       form.phone||null,
        admin_email: form.adminEmail.toLowerCase(),
        established: new Date().getFullYear(),
      }]).select().single();
      if(schoolError) throw schoolError;

      // 3. Insert admin account row using Supabase Auth UUID as id
      const {data:acc,error:accError}=await supabase.from("accounts").insert([{
        id:        user.id,
        name:      form.adminName.trim(),
        email:     form.adminEmail.toLowerCase(),
        phone:     form.adminPhone,
        role:      "admin",
        school_id: school.id,
        verified:  true,
      }]).select().single();
      if(accError) throw accError;

      setLoading(false);
      onLogin(acc);
    }catch(err){
      setLoading(false);
      setErrors({otp: err.message||"Registration failed. Please try again."});
    }
  }

  const levelInfo=SCHOOL_LEVELS.find(l=>l.value===form.level);

  return(
    <div style={{minHeight:"100vh",background:T.bg,fontFamily:"'Inter',sans-serif",padding:"24px 16px",overflowY:"auto"}}>
      <div style={{maxWidth:540,margin:"0 auto"}}>

        {/* Header */}
        <div style={{textAlign:"center",marginBottom:28}}>
          <div style={{display:"inline-flex",alignItems:"center",gap:10,marginBottom:8}}>
            <div style={{width:44,height:44,borderRadius:12,background:T.teal,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,boxShadow:`0 4px 16px ${T.teal}44`}}></div>
            <div style={{textAlign:"left"}}>
              <div style={{fontSize:22,fontWeight:800,color:T.text,letterSpacing:"-0.5px",lineHeight:1}}>EduGrade</div>
              <div style={{fontSize:10,color:T.textFaint,letterSpacing:0.5}}>SCHOOL REGISTRATION</div>
            </div>
          </div>
          <p style={{color:T.textMuted,fontSize:13,margin:"8px 0 0"}}>Register your school to manage results and connect with parents</p>
        </div>

        {/* Step progress */}
        <div style={{display:"flex",alignItems:"flex-start",marginBottom:28}}>
          {STEPS.map((label,i)=>(
            <div key={i} style={{display:"flex",alignItems:"flex-start",flex:i<STEPS.length-1?1:"auto"}}>
              <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:5,flexShrink:0}}>
                <div style={{
                  width:32,height:32,borderRadius:99,fontSize:13,fontWeight:800,
                  display:"flex",alignItems:"center",justifyContent:"center",
                  background:step>i+1?T.green:step===i+1?T.teal:T.borderLight,
                  color:step>=i+1?"#fff":T.textFaint,
                  boxShadow:step===i+1?`0 0 0 4px ${T.tealLight}`:undefined,
                  transition:"all 0.3s"
                }}>
                  {step>i+1?"":i+1}
                </div>
                <span style={{fontSize:10,color:step===i+1?T.teal:T.textFaint,fontWeight:step===i+1?700:400,whiteSpace:"nowrap",textAlign:"center"}}>{label}</span>
              </div>
              {i<STEPS.length-1&&(
                <div style={{flex:1,height:2,background:step>i+1?T.green:T.borderLight,margin:"15px 8px 0",transition:"background 0.4s"}}/>
              )}
            </div>
          ))}
        </div>

        <Card style={{padding:28}}>

          {/*  STEP 1: School Details  */}
          {step===1&&(
            <div>
              <h2 style={{margin:"0 0 4px",fontSize:20,fontWeight:800,color:T.text}}>School Information</h2>
              <p style={{margin:"0 0 20px",color:T.textMuted,fontSize:13}}>Enter your school's official details as registered with the Ministry of Education.</p>

              {/* NEMIS */}
              <div style={{marginBottom:14}}>
                <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>
                  NEMIS Code <span style={{color:T.red}}>*</span>
                </label>
                <input value={form.nemis} onChange={e=>set("nemis",e.target.value.toUpperCase())} placeholder="e.g. NBI-0012345"
                  style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${errors.nemis?T.red:T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit",boxSizing:"border-box",letterSpacing:1,fontWeight:600}}/>
                {errors.nemis?<div style={{color:T.red,fontSize:11,marginTop:4}}>{errors.nemis}</div>
                  :<div style={{color:T.textFaint,fontSize:11,marginTop:4}}>Unique government-issued code — found on MoE correspondence or your school's official registration certificate.</div>}
              </div>

              {/* School Name */}
              <div style={{marginBottom:14}}>
                <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>School Name <span style={{color:T.red}}>*</span></label>
                <input value={form.name} onChange={e=>set("name",e.target.value)} placeholder="e.g. Greenhill Junior Academy"
                  style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${errors.name?T.red:T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
                {errors.name&&<div style={{color:T.red,fontSize:11,marginTop:4}}>{errors.name}</div>}
              </div>

              {/* County + Sub-County */}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                <div>
                  <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>County <span style={{color:T.red}}>*</span></label>
                  <select value={form.county} onChange={e=>set("county",e.target.value)}
                    style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${errors.county?T.red:T.border}`,borderRadius:10,padding:"11px 14px",color:form.county?T.text:T.textFaint,fontSize:13,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}>
                    <option value="">Select county…</option>
                    {KENYA_COUNTIES.map(c=><option key={c} value={c+" County"}>{c}</option>)}
                  </select>
                  {errors.county&&<div style={{color:T.red,fontSize:11,marginTop:4}}>{errors.county}</div>}
                </div>
                <div>
                  <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>Sub-County <span style={{color:T.red}}>*</span></label>
                  <input value={form.subCounty} onChange={e=>set("subCounty",e.target.value)} placeholder="e.g. Westlands"
                    style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${errors.subCounty?T.red:T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:13,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
                  {errors.subCounty&&<div style={{color:T.red,fontSize:11,marginTop:4}}>{errors.subCounty}</div>}
                </div>
              </div>

              {/* School Phone */}
              <div style={{marginBottom:16}}>
                <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>School Phone <span style={{color:T.textFaint,fontWeight:400}}>(optional)</span></label>
                <input value={form.phone} onChange={e=>set("phone",e.target.value)} placeholder="+254700111222"
                  style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${errors.phone?T.red:T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
                {errors.phone&&<div style={{color:T.red,fontSize:11,marginTop:4}}>{errors.phone}</div>}
              </div>

              {/* Curriculum Level */}
              <div style={{marginBottom:20}}>
                <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:8}}>Curriculum Level <span style={{color:T.red}}>*</span></label>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                  {SCHOOL_LEVELS.map(l=>(
                    <div key={l.value} onClick={()=>set("level",l.value)}
                      style={{
                        background:form.level===l.value?T.tealLight:T.surfaceAlt,
                        border:`2px solid ${form.level===l.value?T.teal:T.border}`,
                        borderRadius:12,padding:"12px 14px",cursor:"pointer",transition:"all 0.2s"
                      }}>
                      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                        <span style={{fontSize:18}}>{l.icon}</span>
                        <span style={{fontWeight:700,fontSize:13,color:form.level===l.value?T.teal:T.text}}>{l.label}</span>
                        {form.level===l.value&&<span style={{marginLeft:"auto",color:T.teal,fontSize:14}}></span>}
                      </div>
                      <div style={{color:T.textFaint,fontSize:11}}>{l.desc}</div>
                    </div>
                  ))}
                </div>
                {errors.level&&<div style={{color:T.red,fontSize:11,marginTop:6}}>{errors.level}</div>}
              </div>

              <Btn full size="lg" onClick={goToStep2} style={{background:T.teal,boxShadow:`0 2px 8px ${T.teal}44`}}>
                Continue to Administrator Details →
              </Btn>
              <div style={{textAlign:"center",marginTop:14}}>
                <span style={{color:T.textMuted,fontSize:13}}>Already registered? </span>
                <span style={{color:T.teal,cursor:"pointer",fontWeight:600,fontSize:13}} onClick={onBack}>Sign in →</span>
              </div>
            </div>
          )}

          {/*  STEP 2: Admin Account Details  */}
          {step===2&&(
            <div>
              {/* School summary chip */}
              <div style={{background:T.tealLight,border:`1px solid ${T.teal}44`,borderRadius:12,padding:"10px 14px",marginBottom:18,display:"flex",gap:10,alignItems:"center"}}>
                <span style={{fontSize:20}}></span>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,fontSize:13,color:T.text}}>{form.name}</div>
                  <div style={{color:T.textMuted,fontSize:11}}>NEMIS: {form.nemis} · {form.county} · {form.subCounty}</div>
                  {levelInfo&&<div style={{marginTop:3}}><Badge color={T.teal} bg={T.tealLight}>{levelInfo.icon} {levelInfo.label}</Badge></div>}
                </div>
                <button onClick={()=>{setStep(1);setErrors({});}} style={{background:"none",border:"none",color:T.teal,cursor:"pointer",fontSize:12,fontWeight:600}}>Edit</button>
              </div>

              <h2 style={{margin:"0 0 4px",fontSize:20,fontWeight:800,color:T.text}}>Administrator Account</h2>
              <p style={{margin:"0 0 18px",color:T.textMuted,fontSize:13}}>This account will have full admin access to manage results and students.</p>

              <div style={{marginBottom:14}}>
                <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>Your Full Name <span style={{color:T.red}}>*</span></label>
                <input value={form.adminName} onChange={e=>set("adminName",e.target.value)} placeholder="e.g. David Mwangi"
                  style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${errors.adminName?T.red:T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
                {errors.adminName&&<div style={{color:T.red,fontSize:11,marginTop:4}}>{errors.adminName}</div>}
              </div>

              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                <div>
                  <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>Admin Email <span style={{color:T.red}}>*</span></label>
                  <input value={form.adminEmail} onChange={e=>set("adminEmail",e.target.value)} type="email" placeholder="admin@school.ac.ke"
                    style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${errors.adminEmail?T.red:T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:13,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
                  {errors.adminEmail&&<div style={{color:T.red,fontSize:11,marginTop:4}}>{errors.adminEmail}</div>}
                </div>
                <div>
                  <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>Phone <span style={{color:T.red}}>*</span></label>
                  <input value={form.adminPhone} onChange={e=>set("adminPhone",e.target.value)} placeholder="+254712345678"
                    style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${errors.adminPhone?T.red:T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:13,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
                  {errors.adminPhone&&<div style={{color:T.red,fontSize:11,marginTop:4}}>{errors.adminPhone}</div>}
                </div>
              </div>

              {/* Password with strength meter */}
              <div style={{marginBottom:14}}>
                <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>Password <span style={{color:T.red}}>*</span></label>
                <input value={form.password} onChange={e=>set("password",e.target.value)} type="password" placeholder="Create a strong password"
                  style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${errors.password?T.red:T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
                <PasswordStrengthBar password={form.password}/>
                {errors.password&&<div style={{color:T.red,fontSize:11,marginTop:4}}>{errors.password}</div>}
              </div>
              <div style={{marginBottom:18}}>
                <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>Confirm Password <span style={{color:T.red}}>*</span></label>
                <input value={form.confirm} onChange={e=>set("confirm",e.target.value)} type="password" placeholder="Re-enter password"
                  style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${errors.confirm?T.red:T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
                {errors.confirm&&<div style={{color:T.red,fontSize:11,marginTop:4}}>{errors.confirm}</div>}
              </div>

              <div style={{display:"flex",gap:8}}>
                <Btn variant="secondary" onClick={()=>{setStep(1);setErrors({});}}>← Back</Btn>
                <Btn onClick={sendOtp} disabled={loading} style={{flex:1,background:T.teal,boxShadow:`0 2px 8px ${T.teal}44`,color:"#fff",border:"none"}}>
                  {loading?"Sending verification…":"Send Verification Code →"}
                </Btn>
              </div>
            </div>
          )}

          {/*  STEP 3: Verify Email  */}
          {step===3&&(
            <div>
              <div style={{textAlign:"center",marginBottom:24}}>
                <div style={{width:64,height:64,borderRadius:99,background:T.tealLight,border:`2px solid ${T.teal}44`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,margin:"0 auto 12px"}}></div>
                <h2 style={{margin:"0 0 6px",fontSize:20,fontWeight:800,color:T.text}}>Verify Admin Email</h2>
                <p style={{margin:0,color:T.textMuted,fontSize:13}}>We sent a 6-digit code to <strong>{form.adminEmail}</strong></p>
              </div>



              {errors.otp&&<div style={{background:T.redLight,border:`1px solid ${T.red}33`,borderRadius:10,padding:"10px 14px",color:T.red,fontSize:13,marginBottom:14}}>{errors.otp}</div>}

              <div style={{marginBottom:18}}>
                <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>Verification Code</label>
                <input value={otp} onChange={e=>setOtp(e.target.value.replace(/[^0-9]/g,'').slice(0,6))} placeholder="Enter 6-digit code" maxLength={6} inputMode="numeric" pattern="[0-9]*"
                  style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"13px 14px",color:T.text,fontSize:20,outline:"none",fontFamily:"inherit",boxSizing:"border-box",textAlign:"center",letterSpacing:6,fontWeight:700}}/>
              </div>

              {/* Final school summary before creation */}
              <div style={{background:T.surfaceAlt,border:`1px solid ${T.border}`,borderRadius:12,padding:14,marginBottom:18}}>
                <div style={{color:T.textMuted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:0.8,marginBottom:8}}>Registering School</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
                  {[
                    [" NEMIS",   form.nemis],
                    [" School",  form.name],
                    [" County",  form.county],
                    [" Sub-County",form.subCounty],
                    [" Level",   levelInfo?`${levelInfo.icon} ${levelInfo.label}`:"—"],
                    [" Admin",   form.adminName],
                  ].map(([l,v])=>(
                    <div key={l} style={{background:T.surface,borderRadius:8,padding:"7px 10px"}}>
                      <div style={{color:T.textFaint,fontSize:10,marginBottom:1}}>{l}</div>
                      <div style={{color:T.text,fontSize:12,fontWeight:600}}>{v}</div>
                    </div>
                  ))}
                </div>
              </div>

              <Btn full size="lg" onClick={verifyAndCreate} disabled={loading}
                style={{background:T.teal,boxShadow:`0 2px 8px ${T.teal}44`,color:"#fff",border:"none"}}>
                {loading?"Creating account…":" Verify & Register School"}
              </Btn>
              <div style={{textAlign:"center",marginTop:10}}>
                <span style={{color:T.teal,cursor:"pointer",fontSize:13}} onClick={()=>setStep(2)}>← Back</span>
              </div>
            </div>
          )}
        </Card>

        <p style={{textAlign:"center",color:T.textFaint,fontSize:11,marginTop:20}}>
          © {new Date().getFullYear()} EduGrade · Kenya CBC Platform · School Registration
        </p>
      </div>
    </div>
  );
}


// 
// PARENT APP SHELL
// 
function ParentApp({user,onLogout}){
  const [tab,setTab]=useState("home");
  const [toast,setToast]=useState(null);
  const [tick,setTick]=useState(0);
  const [currentUser,setCurrentUser]=useState(user);
  const [linkedStudents,setLinkedStudents]=useState([]);
  const [unread,setUnread]=useState(0);
  const refresh=()=>setTick(n=>n+1);
  const showToast=(msg,type="info")=>setToast({msg,type,id:Date.now()});

  useEffect(()=>{
    // Fetch all parent data in parallel for faster loading
    Promise.all([
      supabase.from("accounts").select("*").eq("id",user.id).single(),
      supabase.from("students").select("*").eq("parent_id",user.id),
      supabase.from("notifications").select("id",{count:"exact"}).eq("parent_id",user.id).eq("read",false),
    ]).then(([{data:acc},{data:students},{count}])=>{
      if(acc) setCurrentUser(acc);
      if(students) setLinkedStudents(students);
      setUnread(count||0);
    });
  },[user.id,tick]);

  const nav=[
    {id:"home",   icon:<IconHome/>,    label:"Home"},
    {id:"results",icon:<IconResults/>, label:"Results"},
    {id:"analytics",icon:<IconTrends/>,label:"Trends"},
    {id:"notifs", icon:<IconBell/>,    label:"Alerts",badge:unread},
    {id:"profile",icon:<IconUser/>,    label:"Profile"},
  ];

  return(
    <div style={{minHeight:"100vh",background:T.bg,fontFamily:"'Inter',sans-serif",color:T.text,maxWidth:480,margin:"0 auto",position:"relative"}}>
      {toast&&<Toast key={toast.id} msg={toast.msg} type={toast.type} onClose={()=>setToast(null)}/>}
      {/* Sticky header */}
      <div style={{background:T.surface,borderBottom:`1px solid ${T.border}`,padding:"12px 18px",position:"sticky",top:0,zIndex:100,boxShadow:T.shadow}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <div>
              <div style={{fontWeight:800,fontSize:18,letterSpacing:"-0.5px",lineHeight:1,color:T.primary}}>EduGrade</div>
              <div style={{fontSize:9,color:T.textFaint,letterSpacing:0.5}}>PARENT PORTAL</div>
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <div style={{width:32,height:32,borderRadius:99,background:`linear-gradient(135deg,${T.primary},${T.secondary})`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer"}} onClick={()=>setTab("profile")}>
              {currentUser.name.charAt(0)}
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={{paddingBottom:80}}>
        {tab==="home"      &&<HomeTab      user={currentUser} students={linkedStudents} setTab={setTab} showToast={showToast} refresh={refresh}/>}
        {tab==="results"   &&<ResultsTab   user={currentUser} students={linkedStudents} showToast={showToast} refresh={refresh}/>}
        {tab==="analytics" &&<AnalyticsTab user={currentUser} students={linkedStudents}/>}
        {tab==="notifs"    &&<NotifsTab    user={currentUser} refresh={refresh}/>}
        {tab==="profile"   &&<ProfileTab   user={currentUser} refresh={refresh} showToast={showToast} onLogout={onLogout}/>}
      </div>

      {/* Bottom Nav */}
      <div style={{position:"fixed",bottom:0,left:"50%",transform:"translateX(-50%)",width:"100%",maxWidth:480,background:T.surface,borderTop:`1px solid ${T.border}`,display:"flex",padding:"8px 0 16px",boxShadow:"0 -2px 12px rgba(0,0,0,0.06)",zIndex:100}}>
        {nav.map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)} style={{flex:1,background:"none",border:"none",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:3,padding:"6px 0",fontFamily:"inherit",position:"relative"}}>
            <div style={{position:"relative",display:"flex",color:tab===t.id?T.primary:T.textFaint}}>
              {t.icon}
              {(t.badge||0)>0&&<div style={{position:"absolute",top:-5,right:-7,minWidth:16,height:16,borderRadius:99,background:T.red,color:"#fff",fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",padding:"0 3px"}}>{t.badge}</div>}
            </div>
            <span style={{fontSize:10,color:tab===t.id?T.primary:T.textFaint,fontWeight:tab===t.id?700:400}}>{t.label}</span>
            {tab===t.id&&<div style={{position:"absolute",top:0,left:"50%",transform:"translateX(-50%)",width:20,height:2,borderRadius:99,background:T.primary}}/>}
          </button>
        ))}
      </div>
    </div>
  );
}

//  HOME TAB 
function HomeTab({user,students,setTab,showToast,refresh}){
  const [showLink,setShowLink]=useState(false);
  const [latestUnread,setLatestUnread]=useState(null);
  useEffect(()=>{
    supabase.from("notifications").select("*").eq("parent_id",user.id).eq("read",false)
      .order("created_at",{ascending:false}).limit(1)
      .then(({data})=>setLatestUnread(data?.[0]||null));
  },[user.id]);

  return(
    <div style={{padding:"16px 18px"}}>
      <div style={{marginBottom:20}}>
        <h2 style={{margin:"0 0 3px",fontSize:22,fontWeight:800}}>Hello, {user.name.split(" ")[0]}</h2>
        <p style={{margin:0,color:T.textMuted,fontSize:13}}>Here's your children's performance overview</p>
      </div>

      {latestUnread&&(
        <div style={{background:T.primaryLight,border:`1px solid ${T.primaryMid}`,borderRadius:14,padding:"12px 14px",marginBottom:16,cursor:"pointer",display:"flex",gap:10,alignItems:"center"}} onClick={()=>setTab("notifs")}>
          <span style={{fontSize:20}}></span>
          <div style={{flex:1}}>
            <div style={{color:T.primary,fontWeight:700,fontSize:13}}>{latestUnread.title}</div>
            <div style={{color:T.textMuted,fontSize:12,marginTop:1}}>{latestUnread.body}</div>
          </div>
          <span style={{color:T.primary,fontSize:14}}>→</span>
        </div>
      )}

      {students.length===0?(
        <Card style={{textAlign:"center",padding:44}}>
          <div style={{fontSize:52,marginBottom:12}}>‍‍</div>
          <h3 style={{margin:"0 0 8px",fontSize:17,fontWeight:700}}>No students linked</h3>
          <p style={{color:T.textMuted,fontSize:13,margin:"0 0 20px"}}>Enter your child's admission number to start monitoring their CBC results.</p>
          <Btn onClick={()=>setShowLink(true)}>+ Link Student</Btn>
        </Card>
      ):(
        <>
          <SLabel>My Children ({students.length})</SLabel>
          {students.map(s=>{
            const latest=s.terms?.[s.terms?.length-1]||s.results?.[s.results?.length-1]||null;
            const comp=latest?computeTerm(latest):{mean:"—",points:"—",meanCBC:{level:"ME1"}};
            const prevLatest=latest?(s.terms?.[s.terms?.length-2]||s.results?.[s.results?.length-2]||null):null;
            const trend=prevLatest?parseFloat(computeTerm(latest).mean)-parseFloat(computeTerm(prevLatest).mean):null;
            const posLabel=latest?.position?`#${latest.position}/${latest.outOf||"?"}`:"-/-";
            return(
              <Card key={s.id} style={{marginBottom:12,cursor:"pointer"}} onClick={()=>setTab("results")}>
                <div style={{display:"flex",gap:12,alignItems:"center",marginBottom:12}}>
                  <div style={{width:48,height:48,borderRadius:99,background:`linear-gradient(135deg,${T.primary},${T.secondary})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,color:"#fff",fontWeight:800,flexShrink:0}}>{s.name.charAt(0)}</div>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:700,fontSize:14,marginBottom:1}}>{s.name}</div>
                    <div style={{color:T.textMuted,fontSize:12}}>{s.adm_no} · {s.class} {s.stream}</div>
                    <div style={{color:T.textFaint,fontSize:11}}>{s.school_name||""}</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <CBCBadge level={comp.meanCBC.level} size="lg"/>
                    {trend!==null&&<div style={{color:trend>=0?T.green:T.red,fontSize:11,marginTop:4,fontWeight:600}}>{trend>=0?"↑":"↓"} {Math.abs(trend).toFixed(1)}</div>}
                  </div>
                </div>
                {!latest?(
                  <div style={{background:T.surfaceAlt,borderRadius:10,padding:"10px 14px",textAlign:"center",color:T.textMuted,fontSize:12}}>
                    No results uploaded yet — check back after the school uploads term results.
                  </div>
                ):(
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
                    {[
                      {l:"Mean Score",v:comp.mean,c:T.primary,bg:T.primaryLight},
                      {l:"Points",v:comp.points,c:T.secondary,bg:T.secondaryLight},
                      {l:posLabel,v:"Position",c:T.teal,bg:T.tealLight},
                    ].map(c=>(
                      <div key={c.l} style={{background:c.bg,borderRadius:10,padding:"8px 6px",textAlign:"center"}}>
                        <div style={{color:c.c,fontWeight:800,fontSize:16}}>{c.v}</div>
                        <div style={{color:T.textMuted,fontSize:10,marginTop:1}}>{c.l}</div>
                      </div>
                    ))}
                  </div>
                )}
              </Card>
            );
          })}
          <Btn variant="secondary" size="sm" onClick={()=>setShowLink(true)}>+ Link Another Student</Btn>
        </>
      )}

      <Divider my={20}/>
      <SLabel>CBC Grading Scale</SLabel>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
        {CBC_GRADES.map(g=>(
          <div key={g.level} style={{background:g.bg,border:`1px solid ${g.color}22`,borderRadius:10,padding:"7px 11px",display:"flex",alignItems:"center",gap:8}}>
            <CBCBadge level={g.level}/><div><div style={{color:T.textMid,fontSize:11,fontWeight:600}}>{g.min}–{g.max}%</div><div style={{color:T.textFaint,fontSize:10}}>{g.points} pts · {g.short}</div></div>
          </div>
        ))}
      </div>

      {showLink&&<LinkModal user={user} onClose={()=>{setShowLink(false);refresh();}} showToast={showToast}/>}
    </div>
  );
}

//  LINK STUDENT MODAL 
function LinkModal({user,onClose,showToast}){
  // 3-step flow: 1) Find school by NEMIS code  2) Enter student details  3) Confirm & link
  const [step,setStep]=useState(1);
  const [nemisInput,setNemisInput]=useState("");
  const [selectedSchool,setSelectedSchool]=useState(null);
  const [nemisErr,setNemisErr]=useState("");
  const [nemisBusy,setNemisBusy]=useState(false);
  const [form,setForm]=useState({admNo:"",name:"",level:"",class:"",stream:""});
  const [found,setFound]=useState(null);
  const [verifyErr,setVerifyErr]=useState("");
  const [verifyBusy,setVerifyBusy]=useState(false);
  const setF=(k,v)=>setForm(f=>({...f,[k]:v}));

  //  Step 1: Look up school by NEMIS code 
  async function findSchool(){
    setNemisErr(""); setSelectedSchool(null);
    const q=nemisInput.trim();
    if(!q){setNemisErr("Enter the school NEMIS code.");return;}
    setNemisBusy(true);
    const {data:s,error}=await supabase.from("schools").select("*").ilike("nemis",q).single();
    setNemisBusy(false);
    if(error||!s){setNemisErr("No school found with that NEMIS code. Check with the school office.");return;}
    setSelectedSchool(s);
  }

  //  Step 2: Verify student at the selected school 
  async function verifyStudent(){
    setVerifyErr("");
    if(!form.admNo.trim()){setVerifyErr("Admission number is required.");return;}
    if(!form.name.trim()){setVerifyErr("Student name is required.");return;}
    if(!form.level){setVerifyErr("Please select the curriculum level.");return;}
    if(!form.class.trim()){setVerifyErr("Class is required.");return;}
    setVerifyBusy(true);

    // Fetch all students at this school that are unlinked OR already linked to this user
    // We need to search without RLS blocking unlinked students
    const {data:allStudents,error}=await supabase.from("students").select("*")
      .eq("school_id",selectedSchool.id);

    setVerifyBusy(false);

    if(error){setVerifyErr("Could not connect to the school database. Please try again.");return;}

    // Find by admission number (case-insensitive)
    const s=(allStudents||[]).find(st=>
      st.adm_no.toLowerCase().trim()===form.admNo.toLowerCase().trim()
    );

    if(!s){setVerifyErr(`No student with admission number "${form.admNo}" found at ${selectedSchool.name}.`);return;}
    if(s.parent_id===user.id){setVerifyErr("This student is already linked to your account.");return;}
    if(s.parent_id&&s.parent_id!==user.id){setVerifyErr("This student is already linked to another parent account.");return;}

    // Name check — at least one name part must match
    const entered=form.name.trim().toLowerCase();
    const stored=s.name.toLowerCase();
    const parts=entered.split(" ").filter(Boolean);
    if(!parts.some(p=>stored.includes(p))){
      setVerifyErr("Student name does not match records at "+selectedSchool.name+". Please check the spelling.");return;
    }
    // Class check
    if(s.class.toLowerCase()!==form.class.trim().toLowerCase()){
      setVerifyErr(`Class mismatch — student is enrolled in ${s.class}, not "${form.class}".`);return;
    }
    setFound(s); setStep(3);
  }

  //  Step 3: Confirm link 
  async function confirmLink(){
    try{
      // 1. Update student row to set parent_id
      const {error:stuErr}=await supabase
        .from("students")
        .update({parent_id: user.id})
        .eq("id", found.id);
      if(stuErr) throw stuErr;

      // 2. Fetch linked_students fresh from DB to avoid race condition
      const {data:acc,error:fetchErr}=await supabase
        .from("accounts").select("linked_students").eq("id",user.id).single();
      if(fetchErr) throw fetchErr;
      const currentLinked=acc?.linked_students||[];
      if(!currentLinked.includes(found.id)){
        const {error:accErr}=await supabase
          .from("accounts")
          .update({linked_students:[...currentLinked,found.id]})
          .eq("id",user.id);
        if(accErr) throw accErr;
      }

      // 3. Push a confirmation notification
      await supabase.from("notifications").insert([{
        parent_id:  user.id,
        student_id: found.id,
        title:      "Student Linked Successfully",
        body:       `${found.name} (${found.adm_no}) from ${selectedSchool.name} has been linked to your account.`,
        type:       "system",
        read:       false,
      }]);

      showToast(`${found.name} linked successfully!`,"success");
      onClose();
    }catch(err){
      showToast("Failed to link student: "+err.message,"error");
    }
  }

  const STEPS=["Find School","Student Details","Confirm & Link"];

  return(
    <Modal title="Link Child to Your Account" onClose={onClose} width={500}>

      {/*  Step progress bar  */}
      <div style={{display:"flex",alignItems:"flex-start",marginBottom:22}}>
        {STEPS.map((label,i)=>(
          <div key={i} style={{display:"flex",alignItems:"flex-start",flex:i<STEPS.length-1?1:"auto"}}>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:5,flexShrink:0}}>
              <div style={{
                width:30,height:30,borderRadius:99,fontSize:12,fontWeight:800,
                display:"flex",alignItems:"center",justifyContent:"center",
                background:step>i+1?T.green:step===i+1?T.primary:T.borderLight,
                color:step>=i+1?"#fff":T.textFaint,
                boxShadow:step===i+1?`0 0 0 4px ${T.primaryMid}`:undefined,
                transition:"all 0.3s"
              }}>
                {step>i+1?"":i+1}
              </div>
              <span style={{fontSize:10,color:step===i+1?T.primary:T.textFaint,fontWeight:step===i+1?700:400,whiteSpace:"nowrap",textAlign:"center"}}>{label}</span>
            </div>
            {i<STEPS.length-1&&(
              <div style={{flex:1,height:2,background:step>i+1?T.green:T.borderLight,margin:"14px 6px 0",transition:"background 0.4s"}}/>
            )}
          </div>
        ))}
      </div>

      {/* 
          STEP 1 — Find School via NEMIS Code
       */}
      {step===1&&(
        <div>
          <div style={{background:T.primaryLight,border:`1px solid ${T.primaryMid}`,borderRadius:12,padding:"12px 16px",marginBottom:18}}>
            <div style={{color:T.primary,fontWeight:700,fontSize:13,marginBottom:4}}> What is a NEMIS Code?</div>
            <div style={{color:T.textMid,fontSize:12,lineHeight:1.7}}>
              NEMIS (National Education Management Information System) is a unique code assigned to every registered school in Kenya by the Ministry of Education.
              Ask your child's school for their NEMIS code, or find it on the school's gate sign or letter heading.
            </div>
          </div>

          <label style={{display:"block",color:T.textMid,fontWeight:700,fontSize:13,marginBottom:6}}>School NEMIS Code <span style={{color:T.red}}>*</span></label>
          <div style={{display:"flex",gap:8,marginBottom:nemisErr?10:0,paddingRight:2}}>
            <input
              value={nemisInput}
              onChange={e=>{setNemisInput(e.target.value);setNemisErr("");setSelectedSchool(null);}}
              onKeyDown={e=>e.key==="Enter"&&findSchool()}
              placeholder="e.g. NBI-0012345"
              style={{flex:1,minWidth:0,background:T.surfaceAlt,border:`1.5px solid ${nemisErr?T.red:T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit"}}
            />
            <Btn onClick={findSchool} disabled={nemisBusy} style={{flexShrink:0,whiteSpace:"nowrap"}}>{nemisBusy?"…":"Find School"}</Btn>
          </div>

          {nemisErr&&(
            <div style={{background:T.redLight,border:`1px solid ${T.red}33`,borderRadius:10,padding:"10px 14px",color:T.red,fontSize:13,marginBottom:14,display:"flex",gap:8,alignItems:"flex-start"}}>
              <span></span><span>{nemisErr}</span>
            </div>
          )}

          {/* School result card */}
          {selectedSchool&&(
            <div style={{background:T.greenLight,border:`1.5px solid ${T.green}`,borderRadius:14,padding:18,marginTop:12,marginBottom:16}}>
              <div style={{display:"flex",gap:12,alignItems:"flex-start",marginBottom:14}}>
                <div style={{width:46,height:46,borderRadius:12,background:T.primary,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}></div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:800,fontSize:16,color:T.text,marginBottom:2}}>{selectedSchool.name}</div>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:4}}>
                    <span style={{background:"#fff",border:`1px solid ${T.border}`,borderRadius:6,padding:"3px 10px",fontSize:11,color:T.textMid,fontWeight:600}}> Verified School</span>
                  </div>
                </div>
              </div>

              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                {[
                  [" NEMIS Code", selectedSchool.nemis],
                  [" Location", selectedSchool.location],
                  [" County", selectedSchool.county],
                  [" Phone", selectedSchool.phone],
                  [" Established", selectedSchool.established],
                  [" Admin Email", selectedSchool.admin_email],
                ].map(([label,val])=>(
                  <div key={label} style={{background:"rgba(255,255,255,0.7)",borderRadius:10,padding:"8px 12px"}}>
                    <div style={{color:T.textFaint,fontSize:10,marginBottom:2}}>{label}</div>
                    <div style={{color:T.textMid,fontSize:12,fontWeight:600,wordBreak:"break-all"}}>{val}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <Btn full disabled={!selectedSchool} onClick={()=>{if(selectedSchool){setVerifyErr("");setStep(2);}}}>
            This is my child's school — Continue →
          </Btn>

        </div>
      )}

      {/* 
          STEP 2 — Enter Student Details
       */}
      {step===2&&(
        <div>
          {/* Selected school pill */}
          <div style={{background:T.surfaceAlt,border:`1px solid ${T.border}`,borderRadius:12,padding:"10px 14px",marginBottom:16,display:"flex",gap:10,alignItems:"center"}}>
            <span style={{fontSize:20}}></span>
            <div style={{flex:1}}>
              <div style={{fontWeight:700,fontSize:13,color:T.text}}>{selectedSchool.name}</div>
              <div style={{color:T.textMuted,fontSize:11}}>NEMIS: {selectedSchool.nemis} · {selectedSchool.county}</div>
            </div>
            <button onClick={()=>{setStep(1);setSelectedSchool(null);setNemisInput("");setVerifyErr("");}}
              style={{background:"none",border:"none",color:T.primary,cursor:"pointer",fontSize:12,fontWeight:600,whiteSpace:"nowrap"}}>
               Change
            </button>
          </div>

          <p style={{color:T.textMuted,fontSize:13,margin:"0 0 16px",lineHeight:1.6}}>
            Enter your child's details <strong>exactly as registered</strong> at the school. All fields marked <span style={{color:T.red}}>*</span> are required.
          </p>

          {verifyErr&&(
            <div style={{background:T.redLight,border:`1px solid ${T.red}33`,borderRadius:10,padding:"10px 14px",color:T.red,fontSize:13,marginBottom:14,display:"flex",gap:8,alignItems:"flex-start"}}>
              <span></span><span>{verifyErr}</span>
            </div>
          )}

          <div style={{display:"grid",gap:14}}>

            {/*  Curriculum Level  */}
            <div>
              <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:8}}>
                Curriculum Level <span style={{color:T.red}}>*</span>
              </label>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                {[
                  {value:"Early Years",      label:"Early Years",      desc:"PP1, PP2, Gr 1–3", icon:""},
                  {value:"Upper Primary",    label:"Upper Primary",    desc:"Grade 4–6",         icon:""},
                  {value:"Junior Secondary", label:"Junior Secondary", desc:"Grade 7–9",         icon:""},
                  {value:"Senior Secondary", label:"Senior Secondary", desc:"Grade 10–12",       icon:""},
                ].map(l=>(
                  <div key={l.value} onClick={()=>setF("level",l.value)}
                    style={{
                      background:form.level===l.value?T.primaryLight:T.surfaceAlt,
                      border:`2px solid ${form.level===l.value?T.primary:T.border}`,
                      borderRadius:10,padding:"10px 12px",cursor:"pointer",transition:"all 0.2s"
                    }}>
                    <div style={{display:"flex",alignItems:"center",gap:6}}>
                      <span style={{fontSize:16}}>{l.icon}</span>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:700,fontSize:12,color:form.level===l.value?T.primary:T.text}}>{l.label}</div>
                        <div style={{color:T.textFaint,fontSize:10}}>{l.desc}</div>
                      </div>
                      {form.level===l.value&&<span style={{color:T.primary,fontSize:13,flexShrink:0}}></span>}
                    </div>
                  </div>
                ))}
              </div>
              <div style={{color:T.textFaint,fontSize:11,marginTop:5}}>Select the level your child is enrolled in — this helps us find their record faster.</div>
            </div>

            {/* Admission Number */}
            <div>
              <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>
                Admission Number <span style={{color:T.red}}>*</span>
              </label>
              <input value={form.admNo} onChange={e=>setF("admNo",e.target.value)}
                placeholder="e.g. GHS/2024/0047"
                style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
              <div style={{color:T.textFaint,fontSize:11,marginTop:3}}>Found on the school fee receipt or student ID card.</div>
            </div>

            {/* Full Name */}
            <div>
              <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>
                Student Full Name <span style={{color:T.red}}>*</span>
              </label>
              <input value={form.name} onChange={e=>setF("name",e.target.value)}
                placeholder="e.g. Amara Wanjiku Kamau"
                style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
              <div style={{color:T.textFaint,fontSize:11,marginTop:3}}>Use the name registered at the school — include at least two names.</div>
            </div>

            {/* Class & Stream */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div>
                <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>
                  Class <span style={{color:T.red}}>*</span>
                </label>
                <input value={form.class} onChange={e=>setF("class",e.target.value)}
                  placeholder={form.level==="Early Years"?"e.g. Grade 2":form.level==="Upper Primary"?"e.g. Grade 5":form.level==="Senior Secondary"?"e.g. Grade 11":"e.g. Grade 8"}
                  style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
              </div>
              <div>
                <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>
                  Stream <span style={{color:T.textFaint,fontWeight:400}}>(optional)</span>
                </label>
                <input value={form.stream} onChange={e=>setF("stream",e.target.value)}
                  placeholder="e.g. Blue, Red, North"
                  style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
              </div>
            </div>
          </div>

          <div style={{display:"flex",gap:8,marginTop:18}}>
            <Btn variant="secondary" onClick={()=>{setStep(1);setVerifyErr("");}}>← Back</Btn>
            <Btn onClick={verifyStudent} disabled={verifyBusy} style={{flex:1}}>
              {verifyBusy?"Verifying details…":"Verify & Continue →"}
            </Btn>
          </div>
        </div>
      )}

      {/* 
          STEP 3 — Confirm & Link
       */}
      {step===3&&found&&(()=>{
        const comp=found.terms?.length?computeTerm(found.terms[found.terms.length-1]):{mean:"—",points:"—",meanCBC:{level:"ME1"}};
        return(
          <div>
            <p style={{color:T.textMuted,fontSize:13,margin:"0 0 14px",lineHeight:1.6}}>
              We found the following student record. Please confirm all details are correct before linking.
            </p>

            {/* Student identity card */}
            <div style={{background:T.primaryLight,border:`1.5px solid ${T.primary}`,borderRadius:16,padding:20,marginBottom:16}}>
              {/* Header */}
              <div style={{display:"flex",gap:14,alignItems:"center",marginBottom:16,paddingBottom:14,borderBottom:`1px solid ${T.primaryMid}`}}>
                <div style={{width:56,height:56,borderRadius:99,background:`linear-gradient(135deg,${T.primary},${T.secondary})`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,fontSize:24,flexShrink:0,boxShadow:`0 4px 16px ${T.primary}44`}}>
                  {found.name.charAt(0)}
                </div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:800,fontSize:18,color:T.text,lineHeight:1.2}}>{found.name}</div>
                  <div style={{color:T.textMuted,fontSize:12,marginTop:4}}>
                    <CBCBadge level={comp.meanCBC.level} size="lg"/>
                    <span style={{marginLeft:8,verticalAlign:"middle"}}>Latest term mean: {comp.mean}</span>
                  </div>
                </div>
              </div>

              {/* Details grid */}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                {[
                  [" Adm. Number",  found.adm_no],
                  [" Class",         `${found.class} — ${found.stream||"N/A"} Stream`],
                  [" Level Selected", form.level],
                  [" CBC Curriculum", getCurriculumLevel(found.class)],
                  [" Gender",        found.gender||"—"],
                  [" School",        selectedSchool?.name],
                  [" School NEMIS",  selectedSchool?.nemis],
                  [" Location",      `${selectedSchool?.sub_county}, ${selectedSchool?.county}`],
                  [" Est.",          selectedSchool?.established],
                ].map(([label,val])=>(
                  <div key={label} style={{background:"rgba(255,255,255,0.65)",borderRadius:10,padding:"9px 12px"}}>
                    <div style={{color:T.textFaint,fontSize:10,marginBottom:2}}>{label}</div>
                    <div style={{color:T.text,fontSize:12,fontWeight:600}}>{val}</div>
                  </div>
                ))}
              </div>
            </div>

            <div style={{background:T.amberLight,border:`1px solid ${T.amber}44`,borderRadius:10,padding:"10px 14px",color:"#92400e",fontSize:12,marginBottom:18,display:"flex",gap:8,lineHeight:1.6}}>
              <span></span>
              <span>By confirming, you declare that you are the <strong>legal parent or guardian</strong> of this student. Misrepresentation may result in account suspension.</span>
            </div>

            <div style={{display:"flex",gap:8}}>
              <Btn variant="secondary" onClick={()=>{setStep(2);setFound(null);}}>← Back</Btn>
              <Btn onClick={confirmLink} style={{flex:1}}> Confirm & Link Student</Btn>
            </div>
          </div>
        );
      })()}
    </Modal>
  );
}


//  RESULTS TAB 
function ResultsTab({user,students,showToast,refresh}){
  const [activeId,setActiveId]=useState(null);
  const [showLink,setShowLink]=useState(false);
  useEffect(()=>{if(students.length>0&&!activeId)setActiveId(students[0].id);},[students]);
  const active=students.find(s=>s.id===activeId);

  if(students.length===0)return(
    <div style={{padding:"50px 18px",textAlign:"center"}}>
      <div style={{fontSize:48,marginBottom:12}}></div>
      <h3 style={{margin:"0 0 8px",fontSize:17,fontWeight:700}}>No students linked</h3>
      <p style={{color:T.textMuted,fontSize:13,marginBottom:20}}>Link a student to view their CBC results</p>
      <Btn onClick={()=>setShowLink(true)}>+ Link Student</Btn>
      {showLink&&<LinkModal user={user} onClose={()=>{setShowLink(false);refresh();}} showToast={showToast}/>}
    </div>
  );

  return(
    <div>
      {students.length>1&&(
        <div style={{padding:"12px 18px 0",display:"flex",gap:8,overflowX:"auto"}}>
          {students.map(s=>(
            <button key={s.id} onClick={()=>setActiveId(s.id)}
              style={{flexShrink:0,background:activeId===s.id?T.primary:T.surface,border:`1px solid ${activeId===s.id?T.primary:T.border}`,borderRadius:20,padding:"6px 14px",color:activeId===s.id?"#fff":T.textMuted,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap"}}>
              {s.name.split(" ")[0]}
            </button>
          ))}
        </div>
      )}
      {active&&<StudentResultsView student={active} showToast={showToast}/>}
    </div>
  );
}

function StudentResultsView({student,showToast}){
  const [subTab,setSubTab]=useState("results");
  const [yearFilter,setYearFilter]=useState("all");
  const [showPrintModal,setShowPrintModal]=useState(false);
  const [school,setSchool]=useState(null);
  const [terms,setTerms]=useState([]);
  const [loadingResults,setLoadingResults]=useState(true);

  useEffect(()=>{
    // Fetch school and results in parallel
    const queries=[
      supabase.from("results").select("*").eq("student_id",student.id)
        .order("year",{ascending:false}).order("term",{ascending:false}),
    ];
    if(student.school_id){
      queries.push(supabase.from("schools").select("*").eq("id",student.school_id).single());
    }
    Promise.all(queries).then(([{data:resultsData},{data:schoolData}={data:null}])=>{
      if(schoolData) setSchool(schoolData);
      const converted=(resultsData||[]).map(r=>({
        term:     r.term,
        year:     r.year,
        position: r.position,
        outOf:    r.out_of,
        subjects: (r.subjects||[]).map(s=>({
          name:  s.name,
          marks: s.marks,
          cbc:   getCBC(s.marks),
        })),
      }));
      setTerms(converted);
      setLoadingResults(false);
    });
  },[student.id,student.school_id]);

  const currLevel=getCurriculumLevel(student.class);
  const years=[...new Set(terms.map(t=>t.year))].sort((a,b)=>b-a);
  const filteredTerms=yearFilter==="all"?terms:terms.filter(t=>t.year===parseInt(yearFilter));
  const termIdx=filteredTerms.length-1;
  const displayTermIdx=Math.max(0,termIdx);

  return(
    <div>
      <div style={{background:T.surface,borderBottom:`1px solid ${T.border}`,padding:"12px 18px",marginTop:10}}>
        <div style={{background:T.primaryLight,border:`1px solid ${T.primaryMid}`,borderRadius:14,padding:"12px 16px",display:"flex",gap:12,alignItems:"center"}}>
          <div style={{width:46,height:46,borderRadius:99,background:`linear-gradient(135deg,${T.primary},${T.secondary})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,color:"#fff",fontWeight:800,flexShrink:0}}>{student.name.charAt(0)}</div>
          <div style={{flex:1}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:1}}>{student.name}</div>
            <div style={{color:T.textMuted,fontSize:12}}>{student.adm_no} · {student.class} {student.stream}</div>
            <div style={{color:T.textFaint,fontSize:11}}>{school?.name} · <Badge color={T.teal} bg={T.tealLight} style={{fontSize:10}}>{currLevel}</Badge></div>
          </div>
          <button onClick={()=>setShowPrintModal(true)} style={{background:T.surfaceAlt,border:`1px solid ${T.border}`,borderRadius:10,padding:"7px 10px",cursor:"pointer",color:T.textMuted,fontSize:13,display:"flex",alignItems:"center",gap:4}} title="Download / Print">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          </button>
        </div>
      </div>

      {/* Sub tabs */}
      <div style={{display:"flex",background:T.surface,borderBottom:`1px solid ${T.border}`}}>
        {[
          ["results", <><IconResults size={14}/> Results</>],
          ["subjects", <><IconClasses size={14}/> Subjects</>]
        ].map(([id,label])=>(
          <button key={id} onClick={()=>setSubTab(id)} style={{flex:1,background:"none",border:"none",borderBottom:`2px solid ${subTab===id?T.primary:"transparent"}`,padding:"10px 0",color:subTab===id?T.primary:T.textMuted,fontSize:13,fontWeight:subTab===id?700:500,cursor:"pointer",fontFamily:"inherit"}}>
            {label}
          </button>
        ))}
      </div>

      {/* Filters */}
      <div style={{padding:"10px 18px",background:T.surface,borderBottom:`1px solid ${T.border}`,display:"flex",gap:8,alignItems:"center"}}>
        <div style={{flex:1,display:"flex",gap:6}}>
          <select value={yearFilter} onChange={e=>setYearFilter(e.target.value)} style={{background:T.surfaceAlt,border:`1px solid ${T.border}`,borderRadius:8,padding:"5px 10px",color:T.textMid,fontSize:12,fontFamily:"inherit"}}>
            <option value="all">All Years</option>
            {years.map(y=><option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>

      <div style={{padding:"14px 18px 20px"}}>
        {loadingResults&&<div style={{textAlign:"center",padding:"30px 0",color:T.textMuted}}>Loading results…</div>}
        {!loadingResults&&subTab==="results"&&filteredTerms.length===0&&<div style={{textAlign:"center",padding:"30px 0",color:T.textMuted}}>No results uploaded yet for this student.</div>}
        {!loadingResults&&subTab==="results"&&filteredTerms.map((termData,i)=>(
          <div key={i} style={{marginBottom:20}}>
            <div style={{fontWeight:700,fontSize:14,color:T.text,marginBottom:8,paddingBottom:6,borderBottom:`1px solid ${T.border}`}}>{_termName(termData.term)} — {termData.year}</div>
            <ResultsView termData={termData}/>
          </div>
        ))}
        {!loadingResults&&subTab==="subjects"&&<SubjectsView student={{...student,terms}} currLevel={currLevel}/>}
      </div>

      {showPrintModal&&<PrintModal student={{...student,terms}} school={school} onClose={()=>setShowPrintModal(false)} showToast={showToast}/>}
    </div>
  );
}

function ResultsView({termData}){
  const c=computeTerm(termData);
  return(
    <div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:14}}>
        <StatCard icon={<IconAnalytics size={22} color={T.primary}/>} label="Mean Score" value={c.mean} sub="/100" color={T.primary} bg={T.primaryLight}/>
        <StatCard icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={T.secondary} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>} label="Points" value={c.points} sub="total" color={T.secondary} bg={T.secondaryLight}/>
        <StatCard icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={T.teal} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2z"/></svg>} label="Position" value={`#${termData.position}`} sub={`of ${termData.outOf}`} color={T.teal} bg={T.tealLight}/>
      </div>
      <div style={{background:c.meanCBC.bg,border:`1px solid ${c.meanCBC.color}33`,borderRadius:12,padding:"11px 16px",marginBottom:14,display:"flex",alignItems:"center",gap:12}}>
        <CBCBadge level={c.meanCBC.level} size="lg"/>
        <div>
          <div style={{color:T.textMid,fontWeight:700,fontSize:13}}>{c.meanCBC.label}</div>
          <div style={{color:T.textMuted,fontSize:12}}>{_termName(termData.term)} · {termData.year} · {c.subjects.length} subjects</div>
        </div>
      </div>
      <SLabel>Subject Breakdown</SLabel>
      {c.subjects.map((s,i)=>(
        <div key={s.name} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:"11px 14px",marginBottom:8,boxShadow:T.shadow}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
            <div>
              <span style={{color:T.textMid,fontWeight:600,fontSize:13}}>{s.name}</span>
              <span style={{color:T.textFaint,fontSize:11,marginLeft:8}}>#{i+1}</span>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <CBCBadge level={s.cbc.level}/>
              <span style={{color:T.text,fontWeight:800,fontSize:15,minWidth:28,textAlign:"right"}}>{s.marks}</span>
            </div>
          </div>
          <PBar value={s.marks} color={s.cbc.color}/>
        </div>
      ))}
    </div>
  );
}

function SubjectsView({student,currLevel}){
  const expectedSubjects=CBC_SUBJECTS[currLevel]||CBC_SUBJECTS["Junior Secondary"];
  const terms=student.terms||[];
  const allSubjectsInData=[...new Set(terms.flatMap(t=>t.subjects?.map(s=>s.name)||[]))];

  return(
    <div>
      <Card style={{marginBottom:14,background:T.primaryLight,border:`1px solid ${T.primaryMid}`}}>
        <div style={{color:T.primary,fontWeight:700,fontSize:13,marginBottom:4}}>Curriculum Level: {currLevel}</div>
        <div style={{color:T.textMid,fontSize:13,lineHeight:1.6}}>{expectedSubjects.length} subjects in this curriculum level.</div>
      </Card>
      <SLabel>Subject Performance (Latest Term)</SLabel>
      {(()=>{
        if(!terms.length) return <div style={{color:T.textMuted,fontSize:13,padding:"20px 0",textAlign:"center"}}>No results available yet.</div>;
        const latest=computeTerm(terms[terms.length-1]);
        return latest.subjects.map(s=>{
          const history=terms.map(t=>({term:t.term,year:t.year,marks:t.subjects?.find(sub=>sub.name===s.name)?.marks||0}));
          const trend=history.length>1?history[history.length-1].marks-history[history.length-2].marks:0;
          return(
            <Card key={s.name} style={{marginBottom:8}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                <div style={{fontWeight:700,fontSize:13,color:T.text}}>{s.name}</div>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  {trend!==0&&<span style={{color:trend>0?T.green:T.red,fontSize:11,fontWeight:600}}>{trend>0?"↑":"↓"}{Math.abs(trend)}</span>}
                  <CBCBadge level={s.cbc.level}/>
                  <span style={{color:T.text,fontWeight:800,fontSize:15}}>{s.marks}</span>
                </div>
              </div>
              <PBar value={s.marks} color={s.cbc.color}/>
              <div style={{display:"flex",gap:4,marginTop:8}}>
                {history.map((h,i)=>(
                  <div key={i} style={{flex:1,textAlign:"center"}}>
                    <div style={{background:getCBC(h.marks).color,borderRadius:4,height:4,width:"100%",marginBottom:3}}/>
                    <div style={{color:T.textFaint,fontSize:9}}>{_termName(h.term)}</div>
                  </div>
                ))}
              </div>
            </Card>
          );
        });
      })()}
    </div>
  );
}

//  ANALYTICS TAB 
function AnalyticsTab({students}){
  const [activeId,setActiveId]=useState(null);
  const [terms,setTerms]=useState([]);
  const [loading,setLoading]=useState(false);
  useEffect(()=>{if(students.length>0&&!activeId)setActiveId(students[0].id);},[students]);

  useEffect(()=>{
    if(!activeId) return;
    setLoading(true);
    supabase.from("results").select("*").eq("student_id",activeId)
      .order("year",{ascending:true}).order("term",{ascending:true})
      .then(({data})=>{
        const converted=(data||[]).map(r=>({
          term:     r.term,
          year:     r.year,
          position: r.position,
          outOf:    r.out_of,
          subjects: (r.subjects||[]).map(s=>({name:s.name,marks:s.marks,cbc:getCBC(s.marks)})),
        }));
        setTerms(converted);
        setLoading(false);
      });
  },[activeId]);

  const student=students.find(s=>s.id===activeId);
  if(students.length===0)return<div style={{padding:"50px 18px",textAlign:"center",color:T.textMuted}}><div style={{fontSize:48,marginBottom:12}}></div><div style={{fontWeight:600,fontSize:16}}>No students linked yet</div></div>;

  const computed=terms.map(computeTerm);
  const termShort={1:'M1',2:'T1',3:'M2',4:'T2',5:'M3',6:'T3'};
  const lineData=computed.map(t=>({name:`${termShort[t.term]||('T'+t.term)} '${String(t.year).slice(2)}`,mean:parseFloat(t.mean),points:t.points}));
  const latest=computed[computed.length-1];
  const barData=latest?.subjects.map(s=>({name:SUBJECT_ABBR[s.name]||s.name.slice(0,5).toUpperCase(),marks:s.marks,color:s.cbc.color}))||[];
  const tt={background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,fontSize:12,boxShadow:T.shadowMd};
  const best=latest?.subjects.reduce((a,b)=>a.marks>b.marks?a:b,latest.subjects[0]);
  const worst=latest?.subjects.reduce((a,b)=>a.marks<b.marks?a:b,latest.subjects[0]);

  return(
    <div style={{padding:"16px 18px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <h2 style={{margin:0,fontSize:20,fontWeight:800}}>Performance Trends</h2>
        {students.length>1&&(
          <select value={activeId||""} onChange={e=>setActiveId(e.target.value)} style={{background:T.surfaceAlt,border:`1px solid ${T.border}`,borderRadius:8,padding:"5px 10px",color:T.textMid,fontSize:12,fontFamily:"inherit"}}>
            {students.map(s=><option key={s.id} value={s.id}>{s.name.split(" ")[0]}</option>)}
          </select>
        )}
      </div>

      {loading&&<div style={{textAlign:"center",padding:"40px 0",color:T.textMuted}}>Loading results…</div>}
      {!loading&&terms.length===0&&<Card style={{textAlign:"center",padding:32,color:T.textMuted}}>No results uploaded yet for this student.</Card>}

      {/* Highlights */}
      {!loading&&latest&&(
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
          <Card style={{background:T.greenLight,border:`1px solid ${T.green}22`,padding:14}}>
            <div style={{fontSize:10,color:T.green,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:4}}>Best Subject</div>
            <div style={{fontWeight:800,fontSize:15,color:T.text}}>{best?.name}</div>
            <div style={{color:T.textMuted,fontSize:13}}>{best?.marks} marks</div>
          </Card>
          <Card style={{background:T.amberLight,border:`1px solid ${T.amber}22`,padding:14}}>
            <div style={{fontSize:10,color:T.amber,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:4}}>Needs Attention</div>
            <div style={{fontWeight:800,fontSize:15,color:T.text}}>{worst?.name}</div>
            <div style={{color:T.textMuted,fontSize:13}}>{worst?.marks} marks</div>
          </Card>
        </div>
      )}

      {!loading&&terms.length>0&&(<>
      <SLabel>Mean Score Trend</SLabel>
      <Card style={{marginBottom:14,padding:"18px 8px 10px"}}>
        <ResponsiveContainer width="100%" height={155}>
          <LineChart data={lineData}>
            <CartesianGrid strokeDasharray="3 3" stroke={T.borderLight}/>
            <XAxis dataKey="name" tick={{fill:T.textMuted,fontSize:11}} axisLine={false} tickLine={false}/>
            <YAxis domain={[40,100]} tick={{fill:T.textMuted,fontSize:11}} axisLine={false} tickLine={false}/>
            <Tooltip contentStyle={tt}/>
            <Line type="monotone" dataKey="mean" stroke={T.primary} strokeWidth={2.5} dot={{fill:T.primary,r:5,strokeWidth:2,stroke:"#fff"}} name="Mean Score"/>
          </LineChart>
        </ResponsiveContainer>
      </Card>

      <SLabel>Subject Performance (Latest Term)</SLabel>     
      <Card style={{marginBottom:14,padding:"18px 4px 10px"}}>
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={barData} barCategoryGap="20%" margin={{left:0,right:0,top:0,bottom:20}}>
            <CartesianGrid strokeDasharray="3 3" stroke={T.borderLight} vertical={false}/>
            <XAxis dataKey="name" tick={{fill:T.textMuted,fontSize:9}} axisLine={false} tickLine={false} interval={0} angle={-35} textAnchor="end" height={50}/>
            <YAxis domain={[0,100]} tick={{fill:T.textMuted,fontSize:10}} axisLine={false} tickLine={false}/>
            <Tooltip contentStyle={tt}/>
            <Bar dataKey="marks" radius={[6,6,0,0]} name="Marks">{barData.map((e,i)=><Cell key={i} fill={e.color}/>)}</Bar>
          </BarChart>
        </ResponsiveContainer>
      </Card>

      <SLabel>Term History</SLabel>
      {computed.map(t=>(
        <Card key={`${t.term}-${t.year}`} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"14px 18px",marginBottom:8}}>
          <div>
            <div style={{color:T.text,fontWeight:700,fontSize:14}}>{_termName(t.term)}, {t.year}</div>
            <div style={{color:T.textMuted,fontSize:12,marginTop:2}}>Position #{t.position} of {t.outOf} · {t.subjects.length} subjects</div>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{color:T.text,fontWeight:800,fontSize:20,marginBottom:4}}>{t.mean}</div>
            <CBCBadge level={t.meanCBC.level}/>
          </div>
        </Card>
      ))}
      </>)}
    </div>
  );
}

//  NOTIFICATIONS TAB 
function NotifsTab({user,refresh}){
  const [notifs,setNotifs]=useState([]);

  async function load(){
    const {data}=await supabase.from("notifications").select("*")
      .eq("parent_id",user.id).order("created_at",{ascending:false});
    setNotifs(data||[]);
  }
  useEffect(()=>{load();},[user.id]);

  async function markRead(id){
    await supabase.from("notifications").update({read:true}).eq("id",id);
    setNotifs(n=>n.map(x=>x.id===id?{...x,read:true}:x));
    refresh();
  }
  async function markAll(){
    await supabase.from("notifications").update({read:true}).eq("parent_id",user.id).eq("read",false);
    setNotifs(n=>n.map(x=>({...x,read:true})));
    refresh();
  }
  async function deleteNotif(id){
    await supabase.from("notifications").delete().eq("id",id);
    setNotifs(n=>n.filter(x=>x.id!==id));
  }

  const unread=notifs.filter(n=>!n.read).length;
  const icons={
    results: <IconResults size={16} color={T.primary}/>,
    system:  <IconBell size={16} color={T.primary}/>,
    info:    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={T.primary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  };

  return(
    <div style={{padding:"16px 18px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div>
          <h2 style={{margin:"0 0 2px",fontSize:20,fontWeight:800}}>Notifications</h2>
          {unread>0&&<span style={{color:T.textMuted,fontSize:13}}>{unread} unread</span>}
        </div>
        {unread>0&&<Btn variant="ghost" size="sm" onClick={markAll}>Mark all read</Btn>}
      </div>
      {notifs.length===0?(
        <div style={{textAlign:"center",padding:"50px 0",color:T.textMuted}}>
          <div style={{display:"flex",justifyContent:"center",marginBottom:12,opacity:0.3}}><IconBell size={44} color={T.textMuted}/></div>
          <div style={{fontWeight:600,fontSize:15}}>No notifications yet</div>
          <div style={{fontSize:13,marginTop:4}}>You'll be notified when results are uploaded.</div>
        </div>
      ):notifs.map(n=>(
        <div key={n.id} onClick={()=>markRead(n.id)} style={{background:n.read?T.surface:T.primaryLight,border:`1px solid ${n.read?T.border:T.primaryMid}`,borderRadius:14,padding:"13px 14px",marginBottom:10,cursor:"pointer",transition:"background 0.2s"}}>
          <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
            <div style={{width:36,height:36,borderRadius:99,background:n.read?T.surfaceAlt:T.primaryLight,border:`1px solid ${n.read?T.border:T.primaryMid}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              {icons[n.type||"system"]}
            </div>
            <div style={{flex:1}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
                <div style={{color:T.text,fontWeight:n.read?600:700,fontSize:13}}>{n.title}</div>
                {!n.read&&<div style={{width:8,height:8,borderRadius:99,background:T.primary,flexShrink:0,marginTop:3}}/>}
              </div>
              <div style={{color:T.textMuted,fontSize:12,marginTop:3,lineHeight:1.5}}>{n.body}</div>
              <div style={{color:T.textFaint,fontSize:11,marginTop:4}}>{timeAgo(new Date(n.created_at).getTime())}</div>
            </div>
            <button onClick={e=>{e.stopPropagation();deleteNotif(n.id);}} style={{background:"none",border:"none",color:T.textFaint,cursor:"pointer",fontSize:15,padding:"0 2px",flexShrink:0}}>×</button>
          </div>
        </div>
      ))}
    </div>
  );
}

//  PROFILE TAB 
function ProfileTab({user,refresh,showToast,onLogout}){
  const [section,setSection]=useState("main");
  const [form,setForm]=useState({name:user.name,phone:user.phone||""});
  const [editing,setEditing]=useState(false);
  const [showUnlink,setShowUnlink]=useState(null);
  const [showCPModal,setShowCPModal]=useState(false);
  const [linked,setLinked]=useState([]);
  useEffect(()=>{
    supabase.from("students").select("*").eq("parent_id",user.id)
      .then(({data})=>setLinked(data||[]));
  },[user.id]);

  const sections=[
    {id:"main",label:"Account"},
    {id:"help",label:"Help & Support"},
  ];

  async function saveProfile(){
    await supabase.from("accounts").update({name:form.name.trim()||user.name, phone:form.phone}).eq("id",user.id);
    setEditing(false);refresh();showToast("Profile updated","success");
  }
  async function unlinkStudent(sid){
    try{
      // Update student record to remove parent link
      await supabase.from("students").update({parent_id:null}).eq("id",sid);
      // Fetch current linked_students fresh from DB to avoid race condition
      const {data:acc}=await supabase.from("accounts").select("linked_students").eq("id",user.id).single();
      const currentLinked=(acc?.linked_students||[]).filter(id=>id!==sid);
      await supabase.from("accounts").update({linked_students:currentLinked}).eq("id",user.id);
      setLinked(l=>l.filter(s=>s.id!==sid));
      setShowUnlink(null);refresh();showToast("Student unlinked","info");
    }catch(err){
      showToast("Failed to unlink student. Please try again.","error");
    }
  }

  return(
    <div style={{padding:"16px 18px"}}>
      <h2 style={{margin:"0 0 16px",fontSize:20,fontWeight:800}}>Profile</h2>

      <div style={{display:"flex",gap:8,marginBottom:20}}>
        {sections.map(s=>(
          <button key={s.id} onClick={()=>setSection(s.id)}
            style={{flex:1,background:section===s.id?T.primary:T.surface,border:`1px solid ${section===s.id?T.primary:T.border}`,borderRadius:10,padding:"9px 0",color:section===s.id?"#fff":T.textMuted,fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>
            {s.label}
          </button>
        ))}
      </div>

      {section==="main"&&(
        <>
          <Card style={{marginBottom:16}}>
            <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:14}}>
              <div style={{width:56,height:56,borderRadius:99,background:`linear-gradient(135deg,${T.primary},${T.secondary})`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,fontSize:22}}>{user.name.charAt(0)}</div>
              <div>
                <div style={{fontWeight:700,fontSize:16}}>{user.name}</div>
                <div style={{color:T.textMuted,fontSize:13}}>{user.email}</div>
                <div style={{display:"flex",gap:6,marginTop:4}}>
                  <Badge>Parent Account</Badge>
                  {user.verified&&<Badge color={T.green} bg={T.greenLight}>Verified </Badge>}
                </div>
              </div>
            </div>
            {!editing?(
              <>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:14}}>
                  {[
                    {l:"Email",      v:user.email,                                                                                    icon:<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={T.textFaint} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>},
                    {l:"Phone",      v:user.phone||"Not set",                                                                         icon:<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={T.textFaint} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.99 15a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.92 4h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 11.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 18z"/></svg>},
                    {l:"Member since",v:formatDate(user.created_at?new Date(user.created_at).getTime():Date.now()-86400000*30),        icon:<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={T.textFaint} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>},
                    {l:"Students linked",v:linked.length,                                                          icon:<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={T.textFaint} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>},
                  ].map(({l,v,icon})=>(
                    <div key={l} style={{background:T.surfaceAlt,borderRadius:10,padding:"10px 12px"}}>
                      <div style={{color:T.textFaint,fontSize:10,marginBottom:2,display:"flex",alignItems:"center",gap:4}}>{icon} {l}</div>
                      <div style={{color:T.textMid,fontSize:12,fontWeight:600}}>{v}</div>
                    </div>
                  ))}
                </div>
                <div style={{display:"flex",gap:8}}>
                  <Btn variant="secondary" size="sm" onClick={()=>setEditing(true)}>Edit Profile</Btn>
                  <Btn variant="secondary" size="sm" onClick={()=>setShowCPModal(true)}>Change Password</Btn>
                </div>
              </>
            ):(
              <>
                <Field label="Full Name" value={form.name} onChange={v=>setForm(f=>({...f,name:v}))}/>
                <Field label="Phone Number" value={form.phone} onChange={v=>setForm(f=>({...f,phone:v}))} placeholder="+254712345678"/>
                <div style={{display:"flex",gap:8}}>
                  <Btn size="sm" onClick={saveProfile}>Save</Btn>
                  <Btn variant="secondary" size="sm" onClick={()=>setEditing(false)}>Cancel</Btn>
                </div>
              </>
            )}
          </Card>

          <SLabel>Linked Students ({linked.length})</SLabel>
          {linked.length===0?<Card style={{textAlign:"center",padding:24,color:T.textMuted,fontSize:13}}>No students linked</Card>
          :linked.map(s=>{
            const comp=s.terms?.length?computeTerm(s.terms[s.terms.length-1]):{mean:"—",meanCBC:{level:"ME1"}};
            return(
              <Card key={s.id} style={{marginBottom:10,display:"flex",alignItems:"center",gap:12}}>
                <div style={{width:40,height:40,borderRadius:99,background:`linear-gradient(135deg,${T.primary},${T.secondary})`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:16}}>{s.name.charAt(0)}</div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,fontSize:13}}>{s.name}</div>
                  <div style={{color:T.textMuted,fontSize:12}}>{s.class}</div>
                  <div style={{display:"flex",alignItems:"center",gap:6,marginTop:3}}><CBCBadge level={comp.meanCBC.level}/><span style={{color:T.textFaint,fontSize:11}}>Mean: {comp.mean}</span></div>
                </div>
                <Btn variant="danger" size="sm" onClick={()=>setShowUnlink(s.id)}>Unlink</Btn>
              </Card>
            );
          })}

          <Divider my={16}/>
          <Btn variant="danger" full onClick={onLogout}>Sign Out</Btn>
        </>
      )}

      {section==="help"&&<HelpSection user={user}/>}

      {showUnlink&&(
        <Modal title="Unlink Student" onClose={()=>setShowUnlink(null)}>
          <p style={{color:T.textMuted,fontSize:14,margin:"0 0 20px"}}>Are you sure you want to unlink this student? You can re-link them later using their admission number.</p>
          <div style={{display:"flex",gap:8}}>
            <Btn variant="danger" onClick={()=>unlinkStudent(showUnlink)} style={{flex:1}}>Yes, Unlink</Btn>
            <Btn variant="secondary" onClick={()=>setShowUnlink(null)} style={{flex:1}}>Cancel</Btn>
          </div>
        </Modal>
      )}
      {showCPModal&&<ChangePassModal user={user} onClose={()=>setShowCPModal(false)} showToast={showToast}/>}
    </div>
  );
}

function HelpSection({user}){
  const [open,setOpen]=useState(null);
  const faqs=[
    {q:"How do I link my child's results?",a:"Go to the Home tab and tap '+ Link Student'. Enter the admission number exactly as shown on the school card. The system will find your child and prompt you to confirm."},
    {q:"What is the CBC grading system?",a:"The CBC uses 8 performance levels from EE1 (Exceeding Expectation, 90–100%) down to BE2 (Below Expectation, 1–10%). Each level carries points from 1 to 8."},
    {q:"Why can't I see my child's results?",a:"Results are only available once the school has uploaded them. You'll receive a push notification when new results are posted."},
    {q:"Can I link more than one child?",a:"Yes. Tap '+ Link Another Student' on the Home tab. Each child will have a separate profile and results page."},
    {q:"How do I download or print results?",a:"Open the Results tab, select a student and tap the  button on the student card. You can generate a PDF report card."},
    {q:"How do I contact support?",a:"Use the contact form below or email support@edu-grade.com. We respond within 24 hours on business days."},
  ];
  return(
    <div>
      <SLabel>Frequently Asked Questions</SLabel>
      {faqs.map((f,i)=>(
        <Card key={i} style={{marginBottom:8,padding:0,overflow:"hidden"}}>
          <button onClick={()=>setOpen(open===i?null:i)} style={{width:"100%",background:"none",border:"none",padding:"14px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",fontFamily:"inherit"}}>
            <span style={{fontWeight:600,fontSize:13,color:T.text,textAlign:"left"}}>{f.q}</span>
            <span style={{color:T.primary,fontSize:16,flexShrink:0,marginLeft:8}}>{open===i?"−":"+"}</span>
          </button>
          {open===i&&<div style={{padding:"0 16px 14px",color:T.textMuted,fontSize:13,lineHeight:1.6,borderTop:`1px solid ${T.borderLight}`}}><div style={{paddingTop:12}}>{f.a}</div></div>}
        </Card>
      ))}
      <Divider my={16}/>
      <SLabel>Contact Support</SLabel>
      <Card>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
          {[[" Email","support@edu-grade.com"],[" Phone","+254 700 000 123"],[" Hours","Mon–Fri 8am–5pm"],[" Response","Within 24 hours"]].map(([l,v])=>(
            <div key={l} style={{background:T.surfaceAlt,borderRadius:10,padding:"10px 12px"}}>
              <div style={{color:T.textFaint,fontSize:10,marginBottom:2}}>{l}</div>
              <div style={{color:T.textMid,fontSize:12,fontWeight:600}}>{v}</div>
            </div>
          ))}
        </div>
        <ContactForm user={user}/>
      </Card>
    </div>
  );
}

function ContactForm({user}){
  const [msg,setMsg]=useState("");
  const [sent,setSent]=useState(false);
  const [loading,setLoading]=useState(false);
  const [err,setErr]=useState("");

  async function submit(){
    if(!msg.trim()){setErr("Please enter a message before sending.");return;}
    setErr("");setLoading(true);
    try{
      await supabase.from("support_messages").insert([{
        parent_id:  user?.id||null,
        email:      user?.email||null,
        name:       user?.name||null,
        message:    msg.trim(),
        status:     "open",
      }]);
      setSent(true);
    }catch(e){
      setErr("Failed to send message. Please email us directly at support@edu-grade.com");
    }
    setLoading(false);
  }

  if(sent)return(
    <div style={{background:T.greenLight,border:`1px solid ${T.green}33`,borderRadius:10,padding:"12px 16px",color:T.green,fontWeight:600,fontSize:13}}>
       Message sent! We'll respond within 24 hours.
    </div>
  );
  return(
    <div>
      <label style={{display:"block",color:T.textMid,fontSize:13,fontWeight:600,marginBottom:6}}>Send a message</label>
      {err&&<div style={{background:T.redLight,border:`1px solid ${T.red}33`,borderRadius:10,padding:"10px 14px",color:T.red,fontSize:13,marginBottom:10}}>{err}</div>}
      <textarea value={msg} onChange={e=>setMsg(e.target.value)} rows={3} placeholder="Describe your issue or question…"
        style={{width:"100%",background:T.surfaceAlt,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"11px 14px",color:T.text,fontSize:13,outline:"none",fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/>
      <Btn onClick={submit} disabled={loading} style={{marginTop:10}}>{loading?"Sending…":"Send Message"}</Btn>
    </div>
  );
}

function ChangePassModal({user,onClose,showToast}){
  const [f,setF]=useState({cur:"",next:"",confirm:""});
  const [err,setErr]=useState("");
  const [loading,setLoading]=useState(false);

  async function submit(){
    setErr("");
    if(!f.cur){setErr("Please enter your current password.");return;}
    if(f.next.length<8){setErr("New password must be at least 8 characters.");return;}
    if(f.next!==f.confirm){setErr("New passwords don't match.");return;}
    setLoading(true);
    try{
      // Re-authenticate with current password first
      const {error:signInErr}=await supabase.auth.signInWithPassword({email:user.email,password:f.cur});
      if(signInErr)throw new Error("Current password is incorrect.");
      // Now update to new password
      const {error:updateErr}=await supabase.auth.updateUser({password:f.next});
      if(updateErr)throw updateErr;
      showToast("Password updated successfully","success");
      onClose();
    }catch(e){
      setErr(e.message||"Failed to update password. Please try again.");
    }
    setLoading(false);
  }

  return(
    <Modal title="Change Password" onClose={onClose}>
      {err&&<div style={{background:T.redLight,border:`1px solid ${T.red}33`,borderRadius:10,padding:"10px 14px",color:T.red,fontSize:13,marginBottom:14}}>{err}</div>}
      <Field label="Current Password" value={f.cur} onChange={v=>setF(p=>({...p,cur:v}))} type="password"/>
      <Field label="New Password" value={f.next} onChange={v=>setF(p=>({...p,next:v}))} type="password"/>
      <Field label="Confirm New Password" value={f.confirm} onChange={v=>setF(p=>({...p,confirm:v}))} type="password"/>
      <Btn full size="lg" onClick={submit} disabled={loading}>{loading?"Updating…":"Update Password"}</Btn>
    </Modal>
  );
}

//  PRINT/DOWNLOAD MODAL 
function PrintModal({student,school,onClose,showToast}){
  const [generating,setGenerating]=useState(false);
  const [done,setDone]=useState(false);
  const terms=student.terms||[];
  const [termSel,setTermSel]=useState(Math.max(0,terms.length-1));
  const comp=terms.length?computeTerm(terms[termSel]):{mean:"—",points:"—",meanCBC:{level:"ME1"},subjects:[]};
  const currLevel=getCurriculumLevel(student.class);

  function generate(){
    setGenerating(true);
    try{
      const t=terms[termSel];
      if(!t){setGenerating(false);return;}
      const termComp=computeTerm(t);
      const termName=_termName(t.term);
      const currLevel=getCurriculumLevel(student.class);

      // CBC grade colour map
      const gradeColors={
        EE1:"#10b981",EE2:"#14b8a6",ME1:"#3b82f6",ME2:"#6366f1",
        AE1:"#f59e0b",AE2:"#f97316",BE1:"#ef4444",BE2:"#dc2626",
      };
      const gradeBg={
        EE1:"#ecfdf5",EE2:"#f0fdfa",ME1:"#eff6ff",ME2:"#eef2ff",
        AE1:"#fffbeb",AE2:"#fff7ed",BE1:"#fef2f2",BE2:"#fef2f2",
      };

      // Helper: render a filled progress bar as SVG rect within the PDF SVG
      // We'll build an HTML page and use the browser's print-to-PDF / html-to-blob approach via a hidden iframe

      const subjectRows=termComp.subjects.map(s=>{
        const pct=Math.min(100,Math.max(0,s.marks));
        const col=gradeColors[s.cbc.level]||"#6b7280";
        const bg=gradeBg[s.cbc.level]||"#f3f4f6";
        return `
        <tr>
          <td style="padding:7px 10px;color:#374151;font-size:13px;font-weight:600;border-bottom:1px solid #f0f3f7;">${s.name}</td>
          <td style="padding:7px 10px;border-bottom:1px solid #f0f3f7;">
            <div style="background:#f0f3f7;border-radius:99px;height:8px;overflow:hidden;width:100%;">
              <div style="height:8px;width:${pct}%;background:${col};border-radius:99px;"></div>
            </div>
          </td>
          <td style="padding:7px 10px;text-align:center;border-bottom:1px solid #f0f3f7;">
            <span style="background:${bg};color:${col};font-weight:700;font-size:11px;padding:3px 10px;border-radius:99px;border:1.5px solid ${col}33;">${s.cbc.level}</span>
          </td>
          <td style="padding:7px 10px;text-align:right;font-weight:800;font-size:15px;color:#111827;border-bottom:1px solid #f0f3f7;">${s.marks}</td>
        </tr>`;
      }).join("");

      const meanColor=gradeColors[termComp.meanCBC.level]||"#3b82f6";
      const meanBg=gradeBg[termComp.meanCBC.level]||"#eff6ff";

      const html=`<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8"/>
<title>Report Card</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
  *{box-sizing:border-box;margin:0;padding:0;}
  body{font-family:'Inter',sans-serif;background:#f4f6f9;display:flex;justify-content:center;padding:24px;}
  .page{background:#fff;width:794px;min-height:1123px;border-radius:0;padding:0;box-shadow:0 4px 32px rgba(0,0,0,0.12);}
  @media print{body{background:#fff;padding:0;}  .page{box-shadow:none;width:100%;}}
</style>
</head>
<body>
<div class="page">

  <!-- Header Banner -->
  <div style="background:linear-gradient(135deg,#1a3a8c 0%,#3b82f6 100%);padding:32px 40px 28px;position:relative;overflow:hidden;">
    <!-- Decorative circles -->
    <div style="position:absolute;top:-40px;right:-40px;width:180px;height:180px;border-radius:50%;background:rgba(255,255,255,0.06);"></div>
    <div style="position:absolute;bottom:-60px;left:-30px;width:200px;height:200px;border-radius:50%;background:rgba(255,255,255,0.04);"></div>
    <div style="display:flex;justify-content:space-between;align-items:flex-start;position:relative;z-index:1;">
      <div>
        <div style="color:rgba(255,255,255,0.7);font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;margin-bottom:6px;">Kenya CBC Academic Portal</div>
        <div style="color:#fff;font-size:28px;font-weight:800;letter-spacing:-0.5px;line-height:1;">EduGrade</div>
        <div style="color:rgba(255,255,255,0.8);font-size:13px;margin-top:4px;">Official Student Report Card</div>
      </div>
      <div style="text-align:right;">
        <div style="background:rgba(255,255,255,0.12);border:1px solid rgba(255,255,255,0.25);border-radius:12px;padding:12px 18px;backdrop-filter:blur(4px);">
          <div style="color:rgba(255,255,255,0.7);font-size:10px;font-weight:700;letter-spacing:1px;text-transform:uppercase;margin-bottom:4px;">School</div>
          <div style="color:#fff;font-size:14px;font-weight:800;">${school?.name||"School"}</div>
          <div style="color:rgba(255,255,255,0.7);font-size:11px;margin-top:2px;">${school?.location||""} · CBC</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Student Identity Strip -->
  <div style="background:#eff6ff;border-bottom:2px solid #bfdbfe;padding:20px 40px;display:flex;align-items:center;gap:18;">
    <div style="width:56px;height:56px;border-radius:50%;background:linear-gradient(135deg,#3b82f6,#6366f1);display:flex;align-items:center;justify-content:center;color:#fff;font-weight:800;font-size:24px;flex-shrink:0;box-shadow:0 4px 16px rgba(59,130,246,0.35);">
      ${student.name.charAt(0)}
    </div>
    <div style="flex:1;">
      <div style="font-size:20px;font-weight:800;color:#111827;line-height:1.2;">${student.name}</div>
      <div style="color:#6b7280;font-size:12px;margin-top:4px;">Adm No: <strong style="color:#374151">${student.adm_no}</strong> &nbsp;·&nbsp; ${student.class} ${student.stream||""} &nbsp;·&nbsp; ${currLevel}</div>
    </div>
    <div style="text-align:right;">
      <div style="background:${meanBg};border:1.5px solid ${meanColor}33;border-radius:12px;padding:10px 18px;display:inline-block;">
        <div style="color:${meanColor};font-weight:800;font-size:22px;line-height:1;">${termComp.mean}</div>
        <div style="color:#9ca3af;font-size:10px;margin-top:2px;font-weight:600;">MEAN SCORE</div>
      </div>
    </div>
  </div>

  <!-- Term & Stats Row -->
  <div style="padding:20px 40px 0;">
    <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:12px;margin-bottom:20px;">
      <div style="background:#f8f9fb;border:1px solid #e8ecf1;border-radius:12px;padding:14px;text-align:center;">
        <div style="color:#9ca3af;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:1px;margin-bottom:4px;">Term</div>
        <div style="color:#111827;font-weight:800;font-size:14px;">${termName}</div>
        <div style="color:#6b7280;font-size:11px;">${t.year}</div>
      </div>
      <div style="background:#f8f9fb;border:1px solid #e8ecf1;border-radius:12px;padding:14px;text-align:center;">
        <div style="color:#9ca3af;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:1px;margin-bottom:4px;">Position</div>
        <div style="color:#111827;font-weight:800;font-size:14px;">#${t.position}</div>
        <div style="color:#6b7280;font-size:11px;">of ${t.outOf} students</div>
      </div>
      <div style="background:#f8f9fb;border:1px solid #e8ecf1;border-radius:12px;padding:14px;text-align:center;">
        <div style="color:#9ca3af;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:1px;margin-bottom:4px;">Total Points</div>
        <div style="color:#111827;font-weight:800;font-size:14px;">${termComp.points}</div>
        <div style="color:#6b7280;font-size:11px;">${termComp.subjects.length} subjects</div>
      </div>
      <div style="background:${meanBg};border:1.5px solid ${meanColor}33;border-radius:12px;padding:14px;text-align:center;">
        <div style="color:#9ca3af;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:1px;margin-bottom:4px;">CBC Grade</div>
        <div style="color:${meanColor};font-weight:800;font-size:14px;">${termComp.meanCBC.level}</div>
        <div style="color:#6b7280;font-size:11px;">${termComp.meanCBC.label}</div>
      </div>
    </div>

    <!-- Subject table -->
    <div style="font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:1px;margin-bottom:8px;">Subject Breakdown</div>
    <table style="width:100%;border-collapse:collapse;background:#fff;border:1px solid #e8ecf1;border-radius:12px;overflow:hidden;">
      <thead>
        <tr style="background:#f8f9fb;">
          <th style="padding:10px 10px;text-align:left;font-size:11px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.5px;border-bottom:1.5px solid #e8ecf1;">Subject</th>
          <th style="padding:10px 10px;text-align:left;font-size:11px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.5px;border-bottom:1.5px solid #e8ecf1;width:35%;">Performance</th>
          <th style="padding:10px 10px;text-align:center;font-size:11px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.5px;border-bottom:1.5px solid #e8ecf1;">Grade</th>
          <th style="padding:10px 10px;text-align:right;font-size:11px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.5px;border-bottom:1.5px solid #e8ecf1;">Marks</th>
        </tr>
      </thead>
      <tbody>
        ${subjectRows}
      </tbody>
    </table>

    <!-- CBC Grade Key -->
    <div style="margin-top:20px;padding:14px 18px;background:#f8f9fb;border:1px solid #e8ecf1;border-radius:12px;">
      <div style="font-size:10px;font-weight:700;color:#9ca3af;text-transform:uppercase;letter-spacing:1px;margin-bottom:10px;">CBC Grading Scale</div>
      <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:6px;">
        <div style="display:flex;align-items:center;gap:6px;"><span style="background:#ecfdf5;color:#10b981;font-size:10px;font-weight:700;padding:2px 8px;border-radius:99px;border:1px solid #10b98133;">EE1</span><span style="font-size:10px;color:#6b7280;">90–100</span></div>
        <div style="display:flex;align-items:center;gap:6px;"><span style="background:#f0fdfa;color:#14b8a6;font-size:10px;font-weight:700;padding:2px 8px;border-radius:99px;border:1px solid #14b8a633;">EE2</span><span style="font-size:10px;color:#6b7280;">75–89</span></div>
        <div style="display:flex;align-items:center;gap:6px;"><span style="background:#eff6ff;color:#3b82f6;font-size:10px;font-weight:700;padding:2px 8px;border-radius:99px;border:1px solid #3b82f633;">ME1</span><span style="font-size:10px;color:#6b7280;">58–74</span></div>
        <div style="display:flex;align-items:center;gap:6px;"><span style="background:#eef2ff;color:#6366f1;font-size:10px;font-weight:700;padding:2px 8px;border-radius:99px;border:1px solid #6366f133;">ME2</span><span style="font-size:10px;color:#6b7280;">41–57</span></div>
        <div style="display:flex;align-items:center;gap:6px;"><span style="background:#fffbeb;color:#f59e0b;font-size:10px;font-weight:700;padding:2px 8px;border-radius:99px;border:1px solid #f59e0b33;">AE1</span><span style="font-size:10px;color:#6b7280;">31–40</span></div>
        <div style="display:flex;align-items:center;gap:6px;"><span style="background:#fff7ed;color:#f97316;font-size:10px;font-weight:700;padding:2px 8px;border-radius:99px;border:1px solid #f9731633;">AE2</span><span style="font-size:10px;color:#6b7280;">21–30</span></div>
        <div style="display:flex;align-items:center;gap:6px;"><span style="background:#fef2f2;color:#ef4444;font-size:10px;font-weight:700;padding:2px 8px;border-radius:99px;border:1px solid #ef444433;">BE1</span><span style="font-size:10px;color:#6b7280;">11–20</span></div>
        <div style="display:flex;align-items:center;gap:6px;"><span style="background:#fef2f2;color:#dc2626;font-size:10px;font-weight:700;padding:2px 8px;border-radius:99px;border:1px solid #dc262633;">BE2</span><span style="font-size:10px;color:#6b7280;">1–10</span></div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div style="margin-top:28px;padding:16px 40px;background:#f8f9fb;border-top:1px solid #e8ecf1;display:flex;justify-content:space-between;align-items:center;">
    <div style="color:#9ca3af;font-size:11px;">Generated by EduGrade · Kenya CBC Platform</div>
    <div style="color:#9ca3af;font-size:11px;">${new Date().toLocaleDateString("en-KE",{day:"numeric",month:"long",year:"numeric"})}</div>
  </div>

</div>
<script>window.onload=function(){window.print();window.onafterprint=function(){window.close();};};</script>
</body>
</html>`;

      const blob=new Blob([html],{type:"text/html"});
      const url=URL.createObjectURL(blob);
      const win=window.open(url,"_blank","width=900,height=1100");
      if(!win){
        // Fallback: direct download
        const a=document.createElement("a");
        a.href=url;
        a.download=`${student.name.replace(/ /g,"_")}_${termName.replace(/ /g,"_")}_${t.year}_ReportCard.html`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
      setGenerating(false);setDone(true);
    }catch(e){setGenerating(false);}
  }

  return(
    <Modal title="Download / Print Report" onClose={onClose} width={520}>
      <p style={{color:T.textMuted,fontSize:13,margin:"0 0 16px"}}>Generate a PDF report card for {student.name}.</p>
      <Select label="Select Term" value={termSel} onChange={v=>setTermSel(parseInt(v))}
        options={terms.map((t,i)=>({value:i,label:`${_termName(t.term)} ${t.year}`}))}/>
      {/* Preview */}
      <div style={{background:T.surfaceAlt,border:`1px solid ${T.border}`,borderRadius:14,padding:20,marginBottom:16}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14}}>
          <div>
            <div style={{fontWeight:800,fontSize:16,color:T.text}}>{school?.name}</div>
            <div style={{color:T.textMuted,fontSize:12}}>{school?.location} · CBC Report Card</div>
          </div>
          <EduGradeLogo size={44}/>
        </div>
        <div style={{background:T.surface,borderRadius:10,padding:"10px 14px",marginBottom:10}}>
          <div style={{fontWeight:700,fontSize:14}}>{student.name}</div>
          <div style={{color:T.textMuted,fontSize:12}}>{student.adm_no} · {student.class} {student.stream} · {currLevel}</div>
          <div style={{color:T.textMuted,fontSize:12}}>{_termName(terms[termSel]?.term)}, {terms[termSel]?.year} · Position #{terms[termSel]?.position} of {terms[termSel]?.outOf}</div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:6,marginBottom:10}}>
          {[["Mean",comp.mean],["Points",comp.points],["CBC",comp.meanCBC.level]].map(([l,v])=>(
            <div key={l} style={{background:T.surfaceAlt,borderRadius:8,padding:"6px",textAlign:"center"}}>
              <div style={{fontWeight:800,fontSize:15,color:T.primary}}>{v}</div>
              <div style={{color:T.textFaint,fontSize:10}}>{l}</div>
            </div>
          ))}
        </div>
        {comp.subjects.slice(0,4).map(s=>(
          <div key={s.name} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:`1px solid ${T.borderLight}`,fontSize:12}}>
            <span style={{color:T.textMid}}>{s.name}</span>
            <div style={{display:"flex",gap:8}}>
              <CBCBadge level={s.cbc.level}/>
              <span style={{fontWeight:700,color:T.text}}>{s.marks}</span>
            </div>
          </div>
        ))}
        <div style={{color:T.textFaint,fontSize:11,marginTop:6}}>+ {comp.subjects.length-4} more subjects…</div>
      </div>

      {done?(
        <div style={{background:T.greenLight,border:`1px solid ${T.green}33`,borderRadius:10,padding:"12px 16px",marginBottom:14,display:"flex",gap:10,alignItems:"center"}}>
          <span></span>
          <div style={{color:T.green,fontWeight:700,fontSize:13}}> Report card opened — use your browser's Print → Save as PDF.</div>
        </div>
      ):(
        <Btn full size="lg" onClick={generate} disabled={generating}>{generating?"Generating PDF…":" Generate PDF Report Card"}</Btn>
      )}
      {done&&<Btn variant="secondary" full onClick={onClose} style={{marginTop:8}}>Close</Btn>}
    </Modal>
  );
}

// 
// ADMIN APP
// 
function AdminApp({user,onLogout}){
  const [tab,setTab]=useState("dashboard");
  const [toast,setToast]=useState(null);
  const showToast=(msg,type="info")=>setToast({msg,type,id:Date.now()});
  const [tick,setTick]=useState(0);
  const [school,setSchool]=useState(null);
  const refresh=()=>setTick(n=>n+1);
  useEffect(()=>{
    if(user.school_id){
      supabase.from("schools").select("*").eq("id",user.school_id).single()
        .then(({data})=>{ if(data) setSchool(data); });
    }
  },[user.school_id,tick]);

  const navTabs=[
    {id:"dashboard", icon:<IconDashboard size={18}/>, label:"Dashboard"},
    {id:"upload",    icon:<IconUpload size={18}/>,    label:"Upload"},
    {id:"students",  icon:<IconStudents size={18}/>,  label:"Students"},
    {id:"classes",   icon:<IconClasses size={18}/>,   label:"Classes"},
    {id:"analytics", icon:<IconAnalytics size={18}/>, label:"Analytics"},
    {id:"settings",  icon:<IconSettings size={18}/>,  label:"Settings"},
  ];

  return(
    <div style={{minHeight:"100vh",background:T.bg,fontFamily:"'Inter',sans-serif",color:T.text}}>
      {toast&&<Toast key={toast.id} msg={toast.msg} type={toast.type} onClose={()=>setToast(null)}/>}
      {/* Header */}
      <div style={{background:T.surface,borderBottom:`1px solid ${T.border}`,padding:"12px 24px",display:"flex",alignItems:"center",gap:14,boxShadow:T.shadow,position:"sticky",top:0,zIndex:100}}>
        <div>
          <div style={{fontWeight:800,fontSize:18,letterSpacing:"-0.5px",lineHeight:1,color:T.primary}}>EduGrade</div>
          <div style={{color:T.textMuted,fontSize:12}}>{school?.name}</div>
        </div>
        <div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:10}}>
          <div style={{display:"none"}}>
            <Badge color={T.green} bg={T.greenLight}> Online</Badge>
          </div>
          <span style={{color:T.textMuted,fontSize:13,fontWeight:600}}>{user.name}</span>
          <Btn variant="secondary" size="sm" onClick={onLogout}>Sign Out</Btn>
        </div>
      </div>

      {/* Tab bar */}
      <div style={{display:"flex",background:T.surface,borderBottom:`1px solid ${T.border}`,overflowX:"auto"}}>
        {navTabs.map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)}
            style={{flexShrink:0,background:"none",border:"none",borderBottom:`2px solid ${tab===t.id?T.primary:"transparent"}`,padding:"13px 20px",color:tab===t.id?T.primary:T.textMuted,fontSize:13,fontWeight:tab===t.id?700:500,cursor:"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",gap:6}}>
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      <div style={{padding:24,maxWidth:960,margin:"0 auto"}}>
        {tab==="dashboard"&&<AdminDashboard school={school}/>}
        {tab==="upload"   &&<AdminUpload school={school} showToast={showToast} refresh={refresh}/>}
        {tab==="students" &&<AdminStudents school={school} showToast={showToast} refresh={refresh}/>}
        {tab==="classes"  &&<AdminClasses school={school}/>}
        {tab==="analytics"&&<AdminAnalytics school={school}/>}
        {tab==="settings" &&<AdminSettings user={user} school={school} showToast={showToast}/>}
      </div>
    </div>
  );
}

function AdminDashboard({school}){
  const [students,setStudents]=useState([]);
  const [uploads,setUploads]=useState([]);
  const [results,setResults]=useState([]);
  useEffect(()=>{
    if(!school) return;
    // Fetch all admin dashboard data in parallel
    Promise.all([
      supabase.from("students").select("*").eq("school_id",school.id),
      supabase.from("uploads").select("*").eq("school_id",school.id).order("created_at",{ascending:false}),
      supabase.from("results").select("*").eq("school_id",school.id),
    ]).then(([{data:s},{data:u},{data:r}])=>{
      setStudents(s||[]);
      setUploads(u||[]);
      setResults(r||[]);
    });
  },[school?.id]);
  if(!school) return <div style={{color:T.textMuted,padding:40,textAlign:"center"}}>Loading…</div>;
  const linked=students.filter(s=>s.parent_id);

  // Compute grade distribution from real results
  const allSubjects=results.flatMap(r=>(r.subjects||[]).map(s=>({...s,cbc:getCBC(s.marks)})));
  const gradeDist=CBC_GRADES.map(g=>({
    level:g.level,
    count:allSubjects.filter(s=>s.cbc.level===g.level).length,
    color:g.color,
  }));

  // Compute school average from real results
  const allMeans=results.map(r=>{
    const subs=r.subjects||[];
    if(!subs.length) return null;
    return subs.reduce((a,s)=>a+s.marks,0)/subs.length;
  }).filter(m=>m!==null);
  const avgMean=allMeans.length?(allMeans.reduce((a,b)=>a+b,0)/allMeans.length).toFixed(1):"—";

  const tt={background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,fontSize:12,boxShadow:T.shadowMd};
  const classes=[...new Set(students.map(s=>s.class))];

  return(
    <div>
      <h2 style={{margin:"0 0 20px",fontSize:22,fontWeight:800}}>Dashboard</h2>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:24}}>
        <StatCard icon={<IconStudents size={22} color={T.primary}/>} label="Total Students" value={students.length} color={T.primary} bg={T.primaryLight}/>
        <StatCard icon={<IconUser size={22} color={T.teal}/>} label="Linked Parents" value={linked.length} color={T.teal} bg={T.tealLight} sub={`${Math.round(linked.length/Math.max(1,students.length)*100)}% coverage`}/>
        <StatCard icon={<IconUpload size={22} color={T.secondary}/>} label="Uploads" value={uploads.length} color={T.secondary} bg={T.secondaryLight}/>
        <StatCard icon={<IconAnalytics size={22} color={T.green}/>} label="School Average" value={avgMean} color={T.green} bg={T.greenLight} sub="all terms"/>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20,marginBottom:24}}>
        {/* Grade distribution */}
        <Card>
          <SLabel>CBC Grade Distribution</SLabel>
          <ResponsiveContainer width="100%" height={180}>
            <BarChart data={gradeDist} barCategoryGap="25%">
              <CartesianGrid strokeDasharray="3 3" stroke={T.borderLight} vertical={false}/>
              <XAxis dataKey="level" tick={{fill:T.textMuted,fontSize:10}} axisLine={false} tickLine={false}/>
              <YAxis tick={{fill:T.textMuted,fontSize:10}} axisLine={false} tickLine={false}/>
              <Tooltip contentStyle={tt}/>
              <Bar dataKey="count" radius={[4,4,0,0]} name="Count">{gradeDist.map((e,i)=><Cell key={i} fill={e.color}/>)}</Bar>
            </BarChart>
          </ResponsiveContainer>
        </Card>

        {/* Recent uploads */}
        <Card>
          <SLabel>Recent Uploads</SLabel>
          {uploads.length===0?<div style={{color:T.textMuted,fontSize:13,textAlign:"center",padding:"20px 0"}}>No uploads yet</div>
          :uploads.slice(0,4).map(u=>(
            <div key={u.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:`1px solid ${T.borderLight}`}}>
              <div>
                <div style={{fontWeight:600,fontSize:13,color:T.text}}>{u.class} {u.stream}</div>
                <div style={{color:T.textMuted,fontSize:11}}>{_termName(u.term)} {u.year} · {u.students_count} students</div>
              </div>
              <div style={{textAlign:"right"}}>
                <Badge color={T.green} bg={T.greenLight}>{u.notified} notified</Badge>
                <div style={{color:T.textFaint,fontSize:10,marginTop:3}}>{timeAgo(new Date(u.created_at).getTime())}</div>
              </div>
            </div>
          ))}
        </Card>
      </div>

      {/* Classes overview */}
      <SLabel>Classes at a Glance</SLabel>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:10}}>
        {classes.map(cls=>{
          const cs=students.filter(s=>s.class===cls);
          const streams=[...new Set(cs.map(s=>s.stream))];
          return(
            <Card key={cls}>
              <div style={{fontWeight:800,fontSize:15,marginBottom:4}}>{cls}</div>
              <div style={{color:T.textMuted,fontSize:12,marginBottom:8}}>{cs.length} students · {streams.length} stream{streams.length!==1?"s":""}</div>
              <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                {streams.map(s=><span key={s} style={{fontSize:11,color:T.textMuted,fontWeight:500}}>{s}</span>)}
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}

function AdminUpload({school,showToast,refresh}){
  const [form,setForm]=useState({term:"1",year:new Date().getFullYear().toString(),class:"",stream:""});
  const [step,setStep]=useState(-1);
  const [done,setDone]=useState(false);
  const [stats,setStats]=useState(null);
  const [fileData,setFileData]=useState(null);
  const [fileName,setFileName]=useState("");
  const [errors,setErrors]=useState([]);
  const [schoolStats,setSchoolStats]=useState({total:0,linked:0,unlinked:0});
  const [students,setStudents]=useState([]);
  const fileInputRef=useRef(null);
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));

  const pipeline=["Validate file format","Read header row","Map subject columns","Iterate student rows","Apply CBC grading","Calculate mean scores","Save to database","Trigger parent notifications"];

  useEffect(()=>{
    if(!school) return;
    supabase.from("students").select("id,name,class,stream,parent_id").eq("school_id",school.id)
      .then(({data})=>{
        const s=data||[];
        setStudents(s);
        const total=s.length;
        const linked=s.filter(x=>x.parent_id).length;
        setSchoolStats({total,linked,unlinked:total-linked});
      });
  },[school?.id]);

  //  Download CSV Template 
  async function downloadTemplate(){
    if(!form.class){showToast("Select a class first","error");return;}
    const {data:students}=await supabase.from("students").select("adm_no,name,class,stream")
      .eq("school_id",school.id)
      .eq("class",form.class)
      .order("name");
    const level=getCurriculumLevel(form.class);
    const subjects=CBC_SUBJECTS[level]||CBC_SUBJECTS["Junior Secondary"];
    // Template only has Adm No, Student Name, Class, Stream + subject columns
    // Position and Out Of are calculated automatically by the system
    const headers=["Adm No","Student Name","Class","Stream",...subjects];
    // Sort students by stream (alphabetical) then by name within each stream
    const sortedStudents=(students||[]).slice().sort((a,b)=>{
      const sa=(a.stream||"").toLowerCase();
      const sb=(b.stream||"").toLowerCase();
      if(sa!==sb) return sa.localeCompare(sb);
      return (a.name||"").localeCompare(b.name||"");
    });
    const rows=sortedStudents.map(s=>[s.adm_no,s.name,s.class,s.stream||"",...subjects.map(()=>"")]);
    const csv=[headers,...rows].map(r=>r.map(v=>`"${v}"`).join(",")).join("\n");
    const blob=new Blob([csv],{type:"text/csv"});
    const url=URL.createObjectURL(blob);
    const a=document.createElement("a");
    a.href=url;
    a.download=`${school.name}_${form.class}_${_termName(form.term).replace(/ /g,'_')}_${form.year}_template.csv`;
    a.click();
    URL.revokeObjectURL(url);
    showToast("Template downloaded! Fill in subject marks only — ranking is automatic.","success");
  }

  //  Parse uploaded CSV file 
  function parseCSV(text){
    const lines=text.trim().split("\n");
    if(lines.length<2) return null;
    const headers=lines[0].split(",").map(h=>h.replace(/"/g,"").trim());
    const rows=lines.slice(1).map(line=>{
      const vals=line.split(",").map(v=>v.replace(/"/g,"").trim());
      const obj={};
      headers.forEach((h,i)=>obj[h]=vals[i]||"");
      return obj;
    }).filter(r=>r["Adm No"]||r["adm_no"]||r["ADM NO"]);
    return{headers,rows};
  }

  function handleFileChange(e){
    const file=e.target.files[0];
    if(!file) return;
    if(!file.name.endsWith(".csv")){showToast("Please upload a CSV file","error");return;}
    setFileName(file.name);
    const reader=new FileReader();
    reader.onload=ev=>{
      const parsed=parseCSV(ev.target.result);
      if(!parsed||parsed.rows.length===0){showToast("Could not read file. Make sure it is a valid CSV.","error");return;}
      setFileData(parsed);
      showToast(`${parsed.rows.length} rows loaded from ${file.name}`,"success");
    };
    reader.readAsText(file);
  }

  //  Process and save to Supabase 
  async function processUpload(){
    if(!form.term||!form.year||!form.class){showToast("Fill in Term, Year and Class first","error");return;}
    if(!fileData){showToast("Please select a CSV file first","error");return;}

    setDone(false);setStep(0);setErrors([]);setStats(null);

    const stepDelay=ms=>new Promise(r=>setTimeout(r,ms));

    try{
      // Step 0: Validate
      await stepDelay(400);setStep(1);

      // Step 1: Read headers — find subject columns
      const level=getCurriculumLevel(form.class);
      const expectedSubjects=CBC_SUBJECTS[level]||CBC_SUBJECTS["Junior Secondary"];
      const headers=fileData.headers;
      const subjectCols=headers.filter(h=>expectedSubjects.includes(h));
      if(subjectCols.length===0){
        showToast("No matching subject columns found. Download the template and use it.","error");
        setStep(-1);return;
      }
      await stepDelay(400);setStep(2);

      // Step 2: Map columns
      await stepDelay(400);setStep(3);

      // Step 3: Fetch students from DB for matching
      const {data:dbStudents}=await supabase.from("students").select("id,adm_no,name,parent_id")
        .eq("school_id",school.id).eq("class",form.class);
      const studentMap={};
      (dbStudents||[]).forEach(s=>studentMap[s.adm_no.toLowerCase().trim()]=s);

      // Step 4: Iterate rows
      await stepDelay(400);setStep(4);
      const matched=[];
      const unmatched=[];
      fileData.rows.forEach(row=>{
        const admKey=(row["Adm No"]||row["adm_no"]||row["ADM NO"]||"").toLowerCase().trim();
        const student=studentMap[admKey];
        if(!student){unmatched.push(row["Adm No"]||admKey);return;}
        const subjects=subjectCols.map(col=>({
          name:col,
          marks:parseInt(row[col])||0,
          cbc:getCBC(parseInt(row[col])||0),
        }));
        matched.push({student,subjects});
      });

      // Step 5: Apply CBC grading (already done in getCBC above)
      await stepDelay(400);setStep(5);

      // Step 6: Calculate means and AUTO-RANK all students
      await stepDelay(400);setStep(6);

      // Calculate mean for each student
      const withMeans=matched.map(m=>{
        const total=m.subjects.reduce((a,b)=>a+b.marks,0);
        const mean=m.subjects.length?total/m.subjects.length:0;
        return{...m,mean};
      });

      // Sort by mean descending to determine rank
      const sorted=[...withMeans].sort((a,b)=>b.mean-a.mean);
      const outOf=sorted.length;

      // Assign position — students with equal mean get the same rank
      let currentRank=1;
      sorted.forEach((s,i)=>{
        if(i>0&&s.mean<sorted[i-1].mean) currentRank=i+1;
        s.position=currentRank;
        s.outOf=outOf;
      });

      // Map positions back to matched array
      const positionMap={};
      sorted.forEach(s=>positionMap[s.student.id]={position:s.position,outOf:s.outOf});

      //  Server-side validation via Edge Function (optional, non-blocking) 
      try{
        const {data:{session}}=await supabase.auth.getSession();
        if(session){
          const validationResponse=await fetch(
            "https://ortqfydrjvjlkttcczdl.supabase.co/functions/v1/validate-results-upload",
            {
              method:"POST",
              headers:{
                "Content-Type":"application/json",
                "Authorization":`Bearer ${session.access_token}`,
              },
              body:JSON.stringify({
                rows:matched.map(m=>({adm_no:m.student.adm_no,subjects:m.subjects})),
                schoolId:school.id,
                term:parseInt(form.term),
                year:parseInt(form.year),
                className:form.class,
              }),
              signal:AbortSignal.timeout(8000), // 8-second timeout
            }
          );
          if(!validationResponse.ok){
            // Parse the actual error from the edge function and show it, but don't block upload
            try{
              const validation=await validationResponse.json();
              if(validation.rowErrors?.length){
                // Row-level errors are real data issues — show them and stop
                showToast(`Validation: ${validation.rowErrors.slice(0,3).join("; ")}${validation.rowErrors.length>3?` (+${validation.rowErrors.length-3} more)`:""}` ,"warning");
              }
              // Other server errors: warn but proceed with upload
              console.warn("Server validation warning:",validation.error||validationResponse.status);
            }catch(_){
              console.warn("Could not parse validation response, continuing upload.");
            }
          }
        }
      }catch(validationErr){
        // Network error, timeout, or edge function unavailable — skip validation silently
        console.warn("Edge Function validation skipped:",validationErr.message);
      }

      // Step 7: Save results to DB
      if(matched.length>0){
        const resultRows=withMeans.map(m=>({
          student_id: m.student.id,
          school_id:  school.id,
          term:       parseInt(form.term),
          year:       parseInt(form.year),
          position:   positionMap[m.student.id]?.position||null,
          out_of:     positionMap[m.student.id]?.outOf||null,
          subjects:   m.subjects,
        }));
        const {error:resErr}=await supabase.from("results").upsert(resultRows,{
          onConflict:"student_id,term,year",
        });
        if(resErr) throw resErr;
      }

      // Save upload record
      await supabase.from("uploads").insert([{
        school_id:      school.id,
        class:          form.class,
        stream:         form.stream||null,
        term:           parseInt(form.term),
        year:           parseInt(form.year),
        uploaded_by:    school.admin_email,
        students_count: matched.length,
        notified:       matched.filter(m=>m.student.parent_id).length,
      }]);
      await stepDelay(400);setStep(7);

      // Step 8: Notify linked parents
      const toNotify=matched.filter(m=>m.student.parent_id);
      if(toNotify.length>0){
        await supabase.from("notifications").insert(
          toNotify.map(m=>({
            parent_id:  m.student.parent_id,
            student_id: m.student.id,
            title:      `${_termName(form.term)} Results Available`,
            body:       `${m.student.name}'s ${_termName(form.term)} ${form.year} results have been uploaded and are ready to view.`,
            type:       "results",
            read:       false,
          }))
        );
      }
      await stepDelay(400);

      setStats({
        total:fileData.rows.length,
        matched:matched.length,
        notified:toNotify.length,
        unmatched:unmatched.length,
        top3:sorted.slice(0,3).map(s=>({name:s.student.name,mean:s.mean.toFixed(1),position:s.position})),
        outOf:outOf,
      });
      setErrors(unmatched);
      setDone(true);setStep(-1);
      refresh();
    }catch(err){
      setStep(-1);
      showToast("Upload failed: "+err.message,"error");
    }
  }

  const uploading=step>=0;

  return(
    <div style={{maxWidth:680}}>
      <h2 style={{margin:"0 0 20px",fontSize:22,fontWeight:800}}>Upload Class Results</h2>

      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:20}}>
        <StatCard icon={<IconStudents size={22} color={T.primary}/>} label="Students" value={schoolStats.total} color={T.primary} bg={T.primaryLight}/>
        <StatCard icon={<IconUser size={22} color={T.teal}/>} label="Linked" value={schoolStats.linked} color={T.teal} bg={T.tealLight}/>
        <StatCard icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={T.amber} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>} label="Unlinked" value={schoolStats.unlinked} color={T.amber} bg={T.amberLight}/>
      </div>

      {/* Step 1 — Configure */}
      <Card style={{marginBottom:16}}>
        <SLabel>Step 1 — Configure Upload</SLabel>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          <div>
            <div style={{fontSize:12,fontWeight:600,color:T.textMid,marginBottom:6}}>Term *</div>
            <select value={form.term} onChange={e=>set("term",e.target.value)}
              style={{width:"100%",background:T.surface,border:`1.5px solid ${T.border}`,borderRadius:8,padding:"9px 10px",color:T.textMid,fontSize:13,fontFamily:"inherit"}}>
              <option value="">Select term…</option>
              <option value="1">Mid-Term 1</option>
              <option value="2">Term 1</option>
              <option value="3">Mid-Term 2</option>
              <option value="4">Term 2</option>
              <option value="5">Mid-Term 3</option>
              <option value="6">Term 3</option>
            </select>
          </div>
          <div>
            <div style={{fontSize:12,fontWeight:600,color:T.textMid,marginBottom:6}}>Year *</div>
            <select value={form.year} onChange={e=>set("year",e.target.value)}
              style={{width:"100%",background:T.surface,border:`1.5px solid ${T.border}`,borderRadius:8,padding:"9px 10px",color:T.textMid,fontSize:13,fontFamily:"inherit"}}>
              <option value="">Select year…</option>
              {[2025,2026,2027,2028].map(y=><option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          <div>
            <div style={{fontSize:12,fontWeight:600,color:T.textMid,marginBottom:6}}>Class *</div>
            <select value={form.class} onChange={e=>set("class",e.target.value)}
              style={{width:"100%",background:T.surface,border:`1.5px solid ${T.border}`,borderRadius:8,padding:"9px 10px",color:T.textMid,fontSize:13,fontFamily:"inherit"}}>
              <option value="">Select class…</option>
              {[...new Set(students.map(s=>s.class))].sort().map(c=><option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <Field label="Stream" value={form.stream} onChange={v=>set("stream",v)} placeholder="Blue, Red… (optional)"/>
        </div>
      </Card>

      {/* Step 2 — Download template */}
      <Card style={{marginBottom:16}}>
        <SLabel>Step 2 — Download Template</SLabel>
        <p style={{color:T.textMuted,fontSize:13,margin:"0 0 8px",lineHeight:1.6}}>
          Download a pre-filled CSV with all students in the selected class. Fill in subject marks only (0–100).
        </p>
        <div style={{background:T.greenLight,border:`1px solid ${T.green}33`,borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:12,color:"#065f46"}}>
           <strong>Auto-ranking:</strong> You do not need to fill in Position or Out Of — the system calculates these automatically based on each student's mean score after upload.
        </div>
        <Btn variant="secondary" onClick={downloadTemplate}> Download CSV Template for {form.class}</Btn>
      </Card>

      {/* Step 3 — Upload filled file */}
      <Card style={{marginBottom:16}}>
        <SLabel>Step 3 — Upload Filled File</SLabel>
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv"
          style={{display:"none"}}
          onChange={handleFileChange}
        />
        <div
          onClick={!uploading?()=>fileInputRef.current.click():undefined}
          style={{border:`2px dashed ${fileData?T.green:uploading?T.primary:T.border}`,borderRadius:14,padding:28,textAlign:"center",background:fileData?T.greenLight:uploading?T.primaryLight:T.surfaceAlt,cursor:uploading?"default":"pointer",transition:"all 0.3s"}}>
          <div style={{fontSize:32,marginBottom:8}}>{fileData?"":""}</div>
          {fileData?(
            <>
              <div style={{color:T.green,fontWeight:700,fontSize:14,marginBottom:4}}>{fileName}</div>
              <div style={{color:T.textMuted,fontSize:13}}>{fileData.rows.length} student rows loaded · Click to change file</div>
            </>
          ):(
            <>
              <div style={{color:T.textMid,fontWeight:700,fontSize:14,marginBottom:4}}>Click to select your filled CSV file</div>
              <div style={{color:T.textMuted,fontSize:13}}>Only .csv files are supported</div>
            </>
          )}
        </div>
        {fileData&&!uploading&&!done&&(
          <Btn full size="lg" style={{marginTop:12}} onClick={processUpload}>
             Process & Save Results
          </Btn>
        )}
      </Card>

      {/* Pipeline progress */}
      {(step>=0||done)&&(
        <Card style={{marginBottom:16}}>
          <SLabel>Processing Pipeline</SLabel>
          {pipeline.map((s,i)=>{
            const isDone=done||(step>i);const isActive=step===i;
            return(
              <div key={i} style={{display:"flex",alignItems:"center",gap:12,marginBottom:10}}>
                <div style={{width:26,height:26,borderRadius:99,flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:isDone||isActive?"#fff":T.textFaint,background:isDone?T.green:isActive?T.primary:T.borderLight,transition:"background 0.3s"}}>
                  {isDone?"":isActive?"…":i+1}
                </div>
                <span style={{fontSize:13,color:isDone?T.text:isActive?T.primary:T.textFaint,fontWeight:isDone||isActive?600:400}}>{s}</span>
                {isActive&&<div style={{marginLeft:"auto"}}><div style={{width:60,height:4,background:T.borderLight,borderRadius:99,overflow:"hidden"}}><div style={{height:"100%",width:"60%",background:T.primary,borderRadius:99,animation:"pulse 1s infinite"}}/></div></div>}
              </div>
            );
          })}
        </Card>
      )}

      {/* Success summary */}
      {done&&stats&&(
        <>
          <div style={{background:T.greenLight,border:"1px solid #6ee7b7",borderRadius:12,padding:"16px 20px",marginBottom:12}}>
            <div style={{color:"#059669",fontWeight:700,fontSize:15,marginBottom:8}}> Upload & Ranking Complete!</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:12}}>
              {[["Rows in file",stats.total,T.primary],["Ranked",stats.matched,T.green],["Parents notified",stats.notified,T.teal],["Unmatched",stats.unmatched,stats.unmatched>0?T.red:T.textFaint]].map(([l,v,c])=>(
                <div key={l} style={{textAlign:"center",background:"rgba(255,255,255,0.6)",borderRadius:8,padding:"8px 4px"}}>
                  <div style={{color:c,fontWeight:800,fontSize:18}}>{v}</div>
                  <div style={{color:T.textMuted,fontSize:11}}>{l}</div>
                </div>
              ))}
            </div>
            {stats.top3?.length>0&&(
              <>
                <div style={{color:"#065f46",fontWeight:700,fontSize:12,marginBottom:8}}> Top Performers (auto-ranked by mean score)</div>
                <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                  {stats.top3.map((s,i)=>(
                    <div key={i} style={{background:"rgba(255,255,255,0.7)",borderRadius:10,padding:"8px 14px",display:"flex",alignItems:"center",gap:8}}>
                      <div style={{width:26,height:26,borderRadius:99,background:[T.amber,"#9ca3af","#cd7f32"][i],display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,fontSize:12}}>#{s.position}</div>
                      <div>
                        <div style={{fontWeight:700,fontSize:13}}>{s.name}</div>
                        <div style={{color:T.textMuted,fontSize:11}}>Mean: {s.mean}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
          {errors.length>0&&(
            <div style={{background:T.amberLight,border:`1px solid ${T.amber}44`,borderRadius:10,padding:"12px 16px",marginBottom:12}}>
              <div style={{color:"#92400e",fontWeight:700,fontSize:13,marginBottom:6}}> {errors.length} unmatched admission number{errors.length>1?"s":""}</div>
              <div style={{color:T.textMuted,fontSize:12}}>These admission numbers were in the file but not found in the students list. Check for typos and re-upload.</div>
              <div style={{marginTop:8,display:"flex",flexWrap:"wrap",gap:6}}>
                {errors.map(e=><Badge key={e} color={T.amber} bg={T.amberLight}>{e}</Badge>)}
              </div>
            </div>
          )}
          <Btn variant="secondary" onClick={()=>{setDone(false);setStep(-1);setStats(null);setFileData(null);setFileName("");}}>Upload Another File</Btn>
        </>
      )}
    </div>
  );
}

function AdminStudents({school,showToast,refresh}){
  const [search,setSearch]=useState("");
  const [classFilter,setClassFilter]=useState("all");
  const [showAdd,setShowAdd]=useState(false);
  const [editS,setEditS]=useState(null);
  const [students,setStudents]=useState([]);
  const [loading,setLoading]=useState(true);
  // Report download state
  const [reportClass,setReportClass]=useState("");
  const [reportTerm,setReportTerm]=useState("1");
  const [reportYear,setReportYear]=useState(new Date().getFullYear().toString());
  const [downloading,setDownloading]=useState(false);
  const [deleting,setDeleting]=useState(null);

  async function load(){
    if(!school) return;
    setLoading(true);
    const {data}=await supabase.from("students").select("*").eq("school_id",school.id).order("name");
    setStudents(data||[]);
    setLoading(false);
  }
  useEffect(()=>{load();},[school?.id]);

  const classes=[...new Set(students.map(s=>s.class))].sort();
  const filtered=students.filter(s=>(classFilter==="all"||s.class===classFilter)&&
    (s.name.toLowerCase().includes(search.toLowerCase())||s.adm_no.toLowerCase().includes(search.toLowerCase())));

  async function del(id){
    if(deleting===id) return;
    setDeleting(id);
    const {error}=await supabase.from("students").delete().eq("id",id).eq("school_id",school.id);
    setDeleting(null);
    if(error){showToast("Failed to remove student. Please try again.","error");return;}
    setStudents(s=>s.filter(x=>x.id!==id));
    showToast("Student removed","info");
  }

  //  Download Ranked Results Report 
  async function downloadReport(){
    if(!reportClass){showToast("Select a class","error");return;}
    if(!reportTerm||!reportYear){showToast("Select term and year","error");return;}
    setDownloading(true);

    // Fetch students in this class
    const {data:classStudents}=await supabase.from("students").select("id,name,adm_no,class,stream")
      .eq("school_id",school.id).eq("class",reportClass).order("name");

    if(!classStudents?.length){showToast("No students found for this class","error");setDownloading(false);return;}

    // Fetch results for this class + term + year
    const studentIds=classStudents.map(s=>s.id);
    const {data:results}=await supabase.from("results").select("*")
      .in("student_id",studentIds)
      .eq("term",parseInt(reportTerm))
      .eq("year",parseInt(reportYear));

    if(!results?.length){showToast(`No results found for ${reportClass} ${_termName(reportTerm)} ${reportYear}. Upload results first.`,"error");setDownloading(false);return;}

    // Build result map
    const resultMap={};
    results.forEach(r=>resultMap[r.student_id]=r);

    // Get all subject names from results
    const allSubjects=[...new Set(results.flatMap(r=>(r.subjects||[]).map(s=>s.name)))];

    // Build ranked rows — calculate mean and sort
    const rows=classStudents.map(s=>{
      const r=resultMap[s.id];
      if(!r) return{student:s,subjects:{},mean:null,position:null,outOf:null,hasResults:false};
      const subMap={};
      (r.subjects||[]).forEach(sub=>subMap[sub.name]=sub.marks);
      const marks=Object.values(subMap).filter(m=>m!=null);
      const mean=marks.length?(marks.reduce((a,b)=>a+b,0)/marks.length):0;
      return{student:s,subjects:subMap,mean,position:r.position,outOf:r.out_of,hasResults:true};
    }).filter(r=>r.hasResults);

    // Sort by position ascending (overall rank, regardless of stream)
    rows.sort((a,b)=>{
     if(a.position!=null&&b.position!=null&&a.position!==b.position) return a.position-b.position;
     return b.mean-a.mean;
    });

    const outOf=rows.length;

    // Build PDF (plain tabular, no graphics)
    const allMeans=rows.map(r=>r.mean);
    const classAvg=(allMeans.reduce((a,b)=>a+b,0)/allMeans.length).toFixed(1);

    const subjectHeaders=allSubjects.map(s=>`<th style="padding:6px 8px;font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.3px;border:1px solid #e8ecf1;white-space:nowrap;background:#f8f9fb;">${s}</th>`).join("");

    const tableRows=rows.map((r,idx)=>{
      const bg=idx%2===0?"#fff":"#f9fafb";
      const subMarks=allSubjects.map(sub=>`<td style="padding:6px 8px;text-align:center;font-size:12px;color:#374151;border:1px solid #e8ecf1;">${r.subjects[sub]??"-"}</td>`).join("");
      const total=allSubjects.reduce((a,sub)=>{const m=r.subjects[sub];return m!=null?a+m:a;},0);
      const cbc=getCBC(Math.round(r.mean));
      return `<tr style="background:${bg};">
        <td style="padding:6px 8px;text-align:center;font-size:12px;font-weight:700;color:#111827;border:1px solid #e8ecf1;">${r.position}</td>
        <td style="padding:6px 8px;font-size:11px;color:#6b7280;border:1px solid #e8ecf1;">${r.student.adm_no}</td>
        <td style="padding:6px 8px;font-size:12px;font-weight:600;color:#111827;border:1px solid #e8ecf1;">${r.student.name}</td>
        <td style="padding:6px 8px;font-size:11px;color:#374151;border:1px solid #e8ecf1;">${r.student.class}</td>
        <td style="padding:6px 8px;font-size:11px;color:#374151;border:1px solid #e8ecf1;">${r.student.stream||"-"}</td>
        ${subMarks}
        <td style="padding:6px 8px;text-align:center;font-size:12px;font-weight:700;color:#111827;border:1px solid #e8ecf1;">${total}</td>
        <td style="padding:6px 8px;text-align:center;font-size:12px;font-weight:700;color:#111827;border:1px solid #e8ecf1;">${r.mean.toFixed(1)}</td>
        <td style="padding:6px 8px;text-align:center;font-size:12px;font-weight:700;color:#111827;border:1px solid #e8ecf1;">${cbc.level}</td>
      </tr>`;
    }).join("");

    const html=`<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8"/>
<title>Results Report</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
  *{box-sizing:border-box;margin:0;padding:0;}
  body{font-family:'Inter',sans-serif;background:#fff;padding:24px;font-size:12px;}
  @media print{body{padding:10px;}@page{size:A4 landscape;margin:10mm;}}
</style>
</head>
<body>

  <!-- Report Header -->
  <div style="margin-bottom:16px;padding-bottom:14px;border-bottom:2px solid #111827;">
    <div style="display:flex;justify-content:space-between;align-items:flex-start;">
      <div>
        <div style="font-size:18px;font-weight:800;color:#111827;">${school.name}</div>
        <div style="font-size:12px;color:#6b7280;margin-top:2px;">${school.county||""} ${school.county&&school.sub_county?"·":""} ${school.sub_county||""} · NEMIS: ${school.nemis||""}</div>
      </div>
      <div style="text-align:right;">
        <div style="font-size:13px;font-weight:700;color:#111827;">Ranked Results Report</div>
        <div style="font-size:11px;color:#6b7280;margin-top:2px;">${reportClass} &nbsp;·&nbsp; ${_termName(reportTerm)} ${reportYear}</div>
      </div>
    </div>
  </div>

  <!-- Summary strip -->
  <div style="display:flex;gap:24px;margin-bottom:14px;padding:10px 16px;background:#f8f9fb;border:1px solid #e8ecf1;border-radius:8px;">
    <div><span style="color:#9ca3af;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;">Students Ranked</span><br/><span style="font-size:15px;font-weight:800;color:#111827;">${outOf}</span></div>
    <div><span style="color:#9ca3af;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;">Class Average</span><br/><span style="font-size:15px;font-weight:800;color:#111827;">${classAvg}</span></div>
    <div><span style="color:#9ca3af;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;">Subjects</span><br/><span style="font-size:15px;font-weight:800;color:#111827;">${allSubjects.length}</span></div>
    <div><span style="color:#9ca3af;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;">Generated</span><br/><span style="font-size:12px;font-weight:700;color:#374151;">${new Date().toLocaleDateString("en-KE",{day:"numeric",month:"short",year:"numeric"})}</span></div>
  </div>

  <!-- Results Table -->
  <table style="width:100%;border-collapse:collapse;font-size:12px;">
    <thead>
      <tr style="background:#f8f9fb;">
        <th style="padding:6px 8px;font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.3px;border:1px solid #e8ecf1;background:#f8f9fb;">Pos</th>
        <th style="padding:6px 8px;font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.3px;border:1px solid #e8ecf1;background:#f8f9fb;">Adm No</th>
        <th style="padding:6px 8px;font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.3px;border:1px solid #e8ecf1;background:#f8f9fb;">Student Name</th>
        <th style="padding:6px 8px;font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.3px;border:1px solid #e8ecf1;background:#f8f9fb;">Class</th>
        <th style="padding:6px 8px;font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.3px;border:1px solid #e8ecf1;background:#f8f9fb;">Stream</th>
        ${subjectHeaders}
        <th style="padding:6px 8px;font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.3px;border:1px solid #e8ecf1;background:#f8f9fb;">Total</th>
        <th style="padding:6px 8px;font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.3px;border:1px solid #e8ecf1;background:#f8f9fb;">Mean</th>
        <th style="padding:6px 8px;font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.3px;border:1px solid #e8ecf1;background:#f8f9fb;">CBC</th>
      </tr>
    </thead>
    <tbody>
      ${tableRows}
    </tbody>
  </table>

  <!-- Footer -->
  <div style="margin-top:16px;padding-top:10px;border-top:1px solid #e8ecf1;display:flex;justify-content:space-between;color:#9ca3af;font-size:10px;">
    <span>EduGrade · Kenya CBC Platform</span>
    <span>${school.name} · ${reportClass} · ${_termName(reportTerm)} ${reportYear}</span>
  </div>

<script>window.onload=function(){window.print();window.onafterprint=function(){window.close();};};</script>
</body>
</html>`;

    const blob=new Blob([html],{type:"text/html"});
    const url=URL.createObjectURL(blob);
    const win=window.open(url,"_blank","width=1200,height=900");
    if(!win){
      const a=document.createElement("a");
      a.href=url;
      a.download=`${school.name}_${reportClass}_${_termName(reportTerm).replace(/ /g,'_')}_${reportYear}_Results_Ranked.html`;
      a.click();
      URL.revokeObjectURL(url);
    }
    showToast(`Results report opened — use Print → Save as PDF`,"success");
    setDownloading(false);
  }

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <h2 style={{margin:0,fontSize:22,fontWeight:800}}>Students ({filtered.length})</h2>
        <Btn size="sm" onClick={()=>setShowAdd(true)}>+ Add Student</Btn>
      </div>

      {/*  Download Ranked Results Report  */}
      <Card style={{marginBottom:20,background:T.primaryLight,border:`1px solid ${T.primaryMid}`}}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
          <span style={{fontSize:20}}></span>
          <div>
            <div style={{fontWeight:700,fontSize:14,color:T.text}}>Download Ranked Results Report</div>
            <div style={{color:T.textMuted,fontSize:12}}>Export a ranked class list with positions, marks and CBC grades as a CSV file</div>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr auto",gap:10,alignItems:"flex-end"}}>
          <div>
            <div style={{fontSize:11,color:T.textMuted,fontWeight:600,marginBottom:4}}>Class</div>
            <select value={reportClass} onChange={e=>setReportClass(e.target.value)}
              style={{width:"100%",background:T.surface,border:`1.5px solid ${T.border}`,borderRadius:8,padding:"8px 10px",color:T.textMid,fontSize:13,fontFamily:"inherit"}}>
              <option value="">Select class…</option>
              {classes.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div>
            <div style={{fontSize:11,color:T.textMuted,fontWeight:600,marginBottom:4}}>Term</div>
            <select value={reportTerm} onChange={e=>setReportTerm(e.target.value)}
              style={{width:"100%",background:T.surface,border:`1.5px solid ${T.border}`,borderRadius:8,padding:"8px 10px",color:T.textMid,fontSize:13,fontFamily:"inherit"}}>
              <option value="1">Mid-Term 1</option>
              <option value="2">Term 1</option>
              <option value="3">Mid-Term 2</option>
              <option value="4">Term 2</option>
              <option value="5">Mid-Term 3</option>
              <option value="6">Term 3</option>
            </select>
          </div>
          <div>
            <div style={{fontSize:11,color:T.textMuted,fontWeight:600,marginBottom:4}}>Year</div>
            <input value={reportYear} onChange={e=>setReportYear(e.target.value)} placeholder="2025"
              style={{width:"100%",background:T.surface,border:`1.5px solid ${T.border}`,borderRadius:8,padding:"8px 10px",color:T.text,fontSize:13,fontFamily:"inherit",boxSizing:"border-box"}}/>
          </div>
          <Btn onClick={downloadReport} disabled={downloading} style={{marginTop:0,whiteSpace:"nowrap"}}>
            {downloading?"Generating…":" Download Report"}
          </Btn>
        </div>
      </Card>
      <div style={{display:"flex",gap:10,marginBottom:16}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search name or adm no…"
          style={{flex:1,background:T.surface,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"9px 14px",color:T.text,fontSize:13,outline:"none",fontFamily:"inherit"}}/>
        <select value={classFilter} onChange={e=>setClassFilter(e.target.value)} style={{background:T.surface,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"9px 12px",color:T.textMid,fontSize:13,fontFamily:"inherit"}}>
          <option value="all">All Classes</option>
          {classes.map(c=><option key={c} value={c}>{c}</option>)}
        </select>
      </div>
      <Card style={{padding:0,overflow:"hidden"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
          <thead><tr style={{background:T.surfaceAlt}}>{["Student","Adm No","Class","Parent","Actions"].map(h=><th key={h} style={{padding:"11px 16px",color:T.textMuted,fontWeight:700,textAlign:"left",borderBottom:`1px solid ${T.border}`,whiteSpace:"nowrap"}}>{h}</th>)}</tr></thead>
          <tbody>
            {loading?<tr><td colSpan={5} style={{padding:"32px",textAlign:"center",color:T.textMuted}}>Loading students…</td></tr>
            :filtered.length===0?<tr><td colSpan={5} style={{padding:"32px",textAlign:"center",color:T.textMuted}}>No students found</td></tr>
            :filtered.map(s=>(
                <tr key={s.id} style={{borderBottom:`1px solid ${T.borderLight}`}}>
                  <td style={{padding:"12px 16px"}}>
                    <div style={{fontWeight:600,color:T.text}}>{s.name}</div>
                    <div style={{color:T.textFaint,fontSize:11,marginTop:2}}>{s.class} {s.stream} · {getCurriculumLevel(s.class)}</div>
                  </td>
                  <td style={{padding:"12px 16px",color:T.textMuted}}>{s.adm_no}</td>
                  <td style={{padding:"12px 16px",color:T.textMid,fontWeight:600}}>{s.class}</td>
                  <td style={{padding:"12px 16px"}}>{s.parent_id?<span style={{color:T.green,fontSize:12,fontWeight:600}}> Linked</span>:<span style={{color:T.textFaint,fontSize:12}}>Not linked</span>}</td>
                  <td style={{padding:"12px 16px"}}>
                    <div style={{display:"flex",gap:6}}>
                      <Btn variant="secondary" size="sm" onClick={()=>setEditS(s)}>Edit</Btn>
                      <Btn variant="danger" size="sm" disabled={deleting===s.id} onClick={()=>del(s.id)}>{deleting===s.id?"…":"×"}</Btn>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </Card>
      {showAdd&&<AddStudentModal school={school} onClose={()=>{setShowAdd(false);load();}} showToast={showToast}/>}
      {editS&&<EditStudentModal student={editS} onClose={()=>{setEditS(null);load();}} showToast={showToast}/>}
    </div>
  );
}

function AddStudentModal({school,onClose,showToast}){
  const [f,setF]=useState({name:"",admNo:"",class:"Grade 8",stream:"Blue",gender:"Female"});
  const [err,setErr]=useState("");
  const [loading,setLoading]=useState(false);
  const set=(k,v)=>setF(p=>({...p,[k]:v}));
  async function submit(){
    if(!f.name.trim()||!f.admNo.trim()){setErr("Name and admission number are required.");return;}
    setLoading(true);
    const {error}=await supabase.from("students").insert([{
      name:      f.name.trim(),
      adm_no:    f.admNo.trim(),
      class:     f.class,
      stream:    f.stream,
      gender:    f.gender,
      dob:       null,
      school_id: school.id,
      parent_id: null,
    }]);
    setLoading(false);
    if(error){setErr(error.message);return;}
    showToast(`${f.name} added`,"success");onClose();
  }
  return(
    <Modal title="Add New Student" onClose={onClose}>
      {err&&<div style={{background:T.redLight,border:`1px solid ${T.red}33`,borderRadius:10,padding:"10px 14px",color:T.red,fontSize:13,marginBottom:14}}>{err}</div>}
      {/* School context banner — NEMIS is the school's identifier */}
      <div style={{background:T.primaryLight,border:`1px solid ${T.primaryMid}`,borderRadius:12,padding:"12px 16px",marginBottom:16}}>
        <div style={{color:T.primary,fontWeight:700,fontSize:12,textTransform:"uppercase",letterSpacing:0.8,marginBottom:4}}>Registering Under</div>
        <div style={{fontWeight:700,fontSize:14,color:T.text}}>{school.name}</div>
        <div style={{display:"flex",gap:8,marginTop:4,flexWrap:"wrap"}}>
          <span style={{background:"rgba(255,255,255,0.7)",border:`1px solid ${T.primaryMid}`,borderRadius:6,padding:"2px 9px",fontSize:11,color:T.primary,fontWeight:600}}> NEMIS: {school.nemis}</span>
          <span style={{background:"rgba(255,255,255,0.7)",border:`1px solid ${T.primaryMid}`,borderRadius:6,padding:"2px 9px",fontSize:11,color:T.textMid}}> {school.location}, {school.county}</span>
        </div>
      </div>
      <Field label="Student Full Name *" value={f.name} onChange={v=>set("name",v)} placeholder="e.g. Jane Achieng Kamau"/>
      <Field label="Admission Number *" value={f.admNo} onChange={v=>set("admNo",v)} placeholder="e.g. GHS/2025/0001" note="This is what parents use to locate this student"/>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <Field label="Class *" value={f.class} onChange={v=>set("class",v)} placeholder="Grade 8"/>
        <Field label="Stream" value={f.stream} onChange={v=>set("stream",v)} placeholder="e.g. Blue"/>
      </div>
      <Select label="Gender" value={f.gender} onChange={v=>set("gender",v)} options={["Female","Male","Other"]}/>

      <div style={{display:"flex",gap:8,marginTop:4}}>
        <Btn onClick={submit} style={{flex:1}} disabled={loading}>{loading?"Adding…":"Add Student"}</Btn>
        <Btn variant="secondary" onClick={onClose} style={{flex:1}}>Cancel</Btn>
      </div>
    </Modal>
  );
}

function EditStudentModal({student,onClose,showToast}){
  const [f,setF]=useState({name:student.name,admNo:student.adm_no,class:student.class,stream:student.stream});
  const set=(k,v)=>setF(p=>({...p,[k]:v}));
  async function submit(){
    await supabase.from("students").update({
      name:   f.name,
      adm_no: f.admNo,
      class:  f.class,
      stream: f.stream,
    }).eq("id",student.id);
    showToast("Student updated","success");onClose();
  }
  return(
    <Modal title="Edit Student" onClose={onClose}>
      <Field label="Full Name" value={f.name} onChange={v=>set("name",v)}/>
      <Field label="Admission Number" value={f.admNo} onChange={v=>set("admNo",v)}/>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <Field label="Class" value={f.class} onChange={v=>set("class",v)}/>
        <Field label="Stream" value={f.stream} onChange={v=>set("stream",v)}/>
      </div>
      <div style={{display:"flex",gap:8}}><Btn onClick={submit} style={{flex:1}}>Save Changes</Btn><Btn variant="secondary" onClick={onClose} style={{flex:1}}>Cancel</Btn></div>
    </Modal>
  );
}

function AdminClasses({school}){
  const [students,setStudents]=useState([]);
  useEffect(()=>{
    if(!school) return;
    supabase.from("students").select("*").eq("school_id",school.id)
      .then(({data})=>setStudents(data||[]));
  },[school?.id]);
  const classes=[...new Set(students.map(s=>s.class))].sort();

  return(
    <div>
      <h2 style={{margin:"0 0 20px",fontSize:22,fontWeight:800}}>Classes Overview</h2>
      {classes.length===0&&<Card style={{textAlign:"center",padding:40,color:T.textMuted}}>No students added yet</Card>}
      {classes.map(cls=>{
        const cs=students.filter(s=>s.class===cls);
        const streams=[...new Set(cs.map(s=>s.stream).filter(Boolean))];
        const linked=cs.filter(s=>s.parent_id).length;
        return(
          <Card key={cls} style={{marginBottom:16}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
              <div>
                <div style={{fontWeight:800,fontSize:18,marginBottom:6}}>{cls}</div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  <Badge>{cs.length} students</Badge>
                  {streams.map(s=><span key={s} style={{fontSize:11,color:T.textMuted,fontWeight:500}}>{s||"No stream"}</span>)}
                  <Badge color={T.teal} bg={T.tealLight}>{getCurriculumLevel(cls)}</Badge>
                </div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{color:T.textMuted,fontSize:11,marginBottom:2}}>Parent Coverage</div>
                <div style={{color:T.primary,fontWeight:800,fontSize:22}}>{Math.round(linked/Math.max(1,cs.length)*100)}%</div>
                <div style={{color:T.textFaint,fontSize:11}}>{linked}/{cs.length} linked</div>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))",gap:8,marginTop:8}}>
              {cs.slice(0,8).map(s=>(
                <div key={s.id} style={{background:T.surfaceAlt,borderRadius:8,padding:"8px 10px",display:"flex",alignItems:"center",gap:8}}>
                  <div style={{width:28,height:28,borderRadius:99,background:`linear-gradient(135deg,${T.primary},${T.secondary})`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:12,flexShrink:0}}>{s.name.charAt(0)}</div>
                  <div style={{overflow:"hidden"}}>
                    <div style={{fontWeight:600,fontSize:12,color:T.text,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{s.name.split(" ")[0]}</div>
                    <div style={{color:T.textFaint,fontSize:10}}>{s.adm_no}</div>
                  </div>
                </div>
              ))}
              {cs.length>8&&<div style={{background:T.surfaceAlt,borderRadius:8,padding:"8px 10px",display:"flex",alignItems:"center",justifyContent:"center",color:T.textMuted,fontSize:12}}>+{cs.length-8} more</div>}
            </div>
          </Card>
        );
      })}
    </div>
  );
}

function AdminAnalytics({school}){
  const [results,setResults]=useState([]);
  const [students,setStudents]=useState([]);
  const [loading,setLoading]=useState(true);
  const [classFilter,setClassFilter]=useState("all");
  const [termFilter,setTermFilter]=useState("all");
  const [yearFilter,setYearFilter]=useState("all");
  const [view,setView]=useState("subjects"); // subjects | trends | comparison

  useEffect(()=>{
    if(!school) return;
    Promise.all([
      supabase.from("results").select("*").eq("school_id",school.id),
      supabase.from("students").select("id,name,class,stream,adm_no").eq("school_id",school.id),
    ]).then(([{data:r},{data:s}])=>{
      setResults(r||[]);
      setStudents(s||[]);
      setLoading(false);
    });
  },[school?.id]);

  if(!school) return null;

  const classes=["all",...new Set(students.map(s=>s.class)).values()].sort();
  const terms=["all",1,2,3,4,5,6]; // Always show all 6 terms statically
  const years=["all",...new Set(results.map(r=>r.year)).values()].sort((a,b)=>b-a);

  // Build student→class map
  const studentMap={};
  students.forEach(s=>studentMap[s.id]=s);

  // Filter results
  const filtered=results.filter(r=>{
    const s=studentMap[r.student_id];
    if(!s) return false;
    if(classFilter!=="all"&&s.class!==classFilter) return false;
    if(termFilter!=="all"&&r.term!==parseInt(termFilter)) return false;
    if(yearFilter!=="all"&&r.year!==parseInt(yearFilter)) return false;
    return true;
  });

  const tt={background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,fontSize:12};

  //  Subject Difficulty Analysis 
  function SubjectDifficulty(){
    if(filtered.length===0) return <EmptyState/>;
    const subjectMap={};
    filtered.forEach(r=>{
      (r.subjects||[]).forEach(s=>{
        if(!subjectMap[s.name]) subjectMap[s.name]={name:s.name,total:0,count:0};
        subjectMap[s.name].total+=s.marks;
        subjectMap[s.name].count+=1;
      });
    });
    const subjectData=Object.values(subjectMap)
      .map(s=>({name:SUBJECT_ABBR[s.name]||s.name.slice(0,8),fullName:s.name,avg:parseFloat((s.total/s.count).toFixed(1)),count:s.count,cbc:getCBC(Math.round(s.total/s.count))}))
      .sort((a,b)=>b.avg-a.avg);
    const hardest=subjectData[subjectData.length-1];
    const easiest=subjectData[0];
    return(
      <div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
          <Card style={{background:T.greenLight,border:`1px solid ${T.green}22`,padding:14}}>
            <div style={{fontSize:10,color:T.green,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:4}}>Highest Average</div>
            <div style={{fontWeight:800,fontSize:15}}>{easiest?.fullName}</div>
            <div style={{color:T.textMuted,fontSize:13,marginTop:2}}>{easiest?.avg} avg · {easiest?.count} results</div>
          </Card>
          <Card style={{background:T.redLight,border:`1px solid ${T.red}22`,padding:14}}>
            <div style={{fontSize:10,color:T.red,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:4}}>Needs Most Support</div>
            <div style={{fontWeight:800,fontSize:15}}>{hardest?.fullName}</div>
            <div style={{color:T.textMuted,fontSize:13,marginTop:2}}>{hardest?.avg} avg · {hardest?.count} results</div>
          </Card>
        </div>
        <Card style={{padding:"18px 8px 10px",marginBottom:16}}>
          <SLabel style={{paddingLeft:12}}>Average Mark Per Subject</SLabel>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={subjectData} barCategoryGap="20%">
              <CartesianGrid strokeDasharray="3 3" stroke={T.borderLight} vertical={false}/>
              <XAxis dataKey="name" tick={{fill:T.textMuted,fontSize:9}} axisLine={false} tickLine={false}/>
              <YAxis domain={[0,100]} tick={{fill:T.textMuted,fontSize:10}} axisLine={false} tickLine={false}/>
              <Tooltip contentStyle={tt} formatter={(v,n,p)=>[`${v} marks`,p.payload.fullName]}/>
              <Bar dataKey="avg" radius={[5,5,0,0]} name="Average">
                {subjectData.map((e,i)=><Cell key={i} fill={e.cbc.color}/>)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Card>
        <Card style={{padding:0,overflow:"hidden"}}>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
            <thead><tr style={{background:T.surfaceAlt}}>
              {["Subject","Avg Mark","CBC Level","Results Count","Difficulty"].map(h=><th key={h} style={{padding:"10px 14px",color:T.textMuted,fontWeight:700,textAlign:"left",borderBottom:`1px solid ${T.border}`,whiteSpace:"nowrap"}}>{h}</th>)}
            </tr></thead>
            <tbody>
              {subjectData.map((s,i)=>{
                const difficulty=s.avg>=75?"Easy":s.avg>=58?"Moderate":s.avg>=41?"Hard":"Very Hard";
                const dc=s.avg>=75?T.green:s.avg>=58?T.teal:s.avg>=41?T.amber:T.red;
                return(
                  <tr key={s.name} style={{borderBottom:`1px solid ${T.borderLight}`,background:i%2===0?"#fff":T.surfaceAlt}}>
                    <td style={{padding:"11px 14px",fontWeight:600}}>{s.fullName}</td>
                    <td style={{padding:"11px 14px"}}><span style={{fontWeight:700,color:s.cbc.color}}>{s.avg}</span></td>
                    <td style={{padding:"11px 14px"}}><CBCBadge level={s.cbc.level}/></td>
                    <td style={{padding:"11px 14px",color:T.textMuted}}>{s.count}</td>
                    <td style={{padding:"11px 14px"}}><Badge color={dc} bg={`${dc}22`}>{difficulty}</Badge></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Card>
      </div>
    );
  }

  //  Class Performance Trends 
  function ClassTrends(){
    const baseResults=yearFilter==="all"?results:results.filter(r=>r.year===parseInt(yearFilter));
    const classResults={};
    baseResults.forEach(r=>{
      const s=studentMap[r.student_id];
      if(!s) return;
      const cls=s.class;
      if(!classResults[cls]) classResults[cls]=[];
      const mean=r.subjects?.length?(r.subjects.reduce((a,b)=>a+b.marks,0)/r.subjects.length):0;
      const label=`${_termName(r.term)} ${r.year}`;
      const sortKey=r.year*10+r.term;
      classResults[cls].push({term:r.term,year:r.year,mean,key:label,sortKey});
    });
    const allClassNames=Object.keys(classResults).sort();
    if(allClassNames.length===0) return <EmptyState/>;
    // Sort term keys chronologically (by year then term number) so all class lines align correctly
    const termKeySet={};
    baseResults.forEach(r=>{termKeySet[`${_termName(r.term)} ${r.year}`]=r.year*10+r.term;});
    const termKeys=Object.keys(termKeySet).sort((a,b)=>termKeySet[a]-termKeySet[b]);
    const lineData=termKeys.map(k=>{
      const point={name:k};
      allClassNames.forEach(cls=>{
        const matching=classResults[cls]?.filter(r=>r.key===k)||[];
        point[cls]=matching.length?(matching.reduce((a,b)=>a+b.mean,0)/matching.length).toFixed(1):null;
      });
      return point;
    });
    const COLORS=[T.primary,T.secondary,T.teal,T.green,T.amber,T.purple];
    return(
      <div>
        <Card style={{marginBottom:12,padding:"12px 16px"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
            <span style={{fontSize:12,color:T.textMuted,fontWeight:600}}>Filter by class:</span>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              <button onClick={()=>setClassFilter("all")}
                style={{padding:"5px 12px",borderRadius:8,border:`1.5px solid ${classFilter==="all"?T.primary:T.border}`,background:classFilter==="all"?T.primary:"#fff",color:classFilter==="all"?"#fff":T.textMid,fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>
                All Classes
              </button>
              {allClassNames.map((cls,i)=>(
                <button key={cls} onClick={()=>setClassFilter(cls)}
                  style={{padding:"5px 12px",borderRadius:8,border:`1.5px solid ${classFilter===cls?COLORS[i%COLORS.length]:T.border}`,background:classFilter===cls?COLORS[i%COLORS.length]:"#fff",color:classFilter===cls?"#fff":T.textMid,fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>
                  {cls}
                </button>
              ))}
            </div>
          </div>
        </Card>
        <Card style={{padding:"18px 8px 10px",marginBottom:16}}>
          <SLabel style={{paddingLeft:12}}>Mean Score by Class Over Time</SLabel>
          <ResponsiveContainer width="100%" height={240}>
            <LineChart data={lineData}>
              <CartesianGrid strokeDasharray="3 3" stroke={T.borderLight}/>
              <XAxis dataKey="name" tick={{fill:T.textMuted,fontSize:10}} axisLine={false} tickLine={false}/>
              <YAxis domain={[0,100]} tick={{fill:T.textMuted,fontSize:10}} axisLine={false} tickLine={false}/>
              <Tooltip contentStyle={tt}/>
              <Legend/>
              {allClassNames.map((cls,i)=>(
                <Line key={cls} type="monotone" dataKey={cls}
                  stroke={COLORS[i%COLORS.length]}
                  strokeWidth={classFilter==="all"||classFilter===cls?2.5:1}
                  strokeOpacity={classFilter==="all"||classFilter===cls?1:0.2}
                  dot={{r:classFilter==="all"||classFilter===cls?4:2}}
                  connectNulls/>
              ))}
            </LineChart>
          </ResponsiveContainer>
        </Card>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:10}}>
          {(classFilter==="all"?allClassNames:[classFilter]).filter(c=>classResults[c]).map((cls,i)=>{
            const idx=allClassNames.indexOf(cls);
            const clsData=classResults[cls];
            const avg=(clsData.reduce((a,b)=>a+b.mean,0)/clsData.length).toFixed(1);
            const latest=clsData[clsData.length-1];
            const prev=clsData[clsData.length-2];
            const trend=prev?parseFloat(latest.mean)-parseFloat(prev.mean):null;
            return(
              <Card key={cls} style={{borderLeft:`4px solid ${COLORS[idx%COLORS.length]}`}}>
                <div style={{fontWeight:800,fontSize:15,marginBottom:4}}>{cls}</div>
                <div style={{fontSize:24,fontWeight:800,color:COLORS[idx%COLORS.length],marginBottom:4}}>{avg}</div>
                <div style={{color:T.textMuted,fontSize:12}}>Overall average</div>
                {trend!==null&&<div style={{color:trend>=0?T.green:T.red,fontSize:12,fontWeight:600,marginTop:4}}>{trend>=0?"↑":"↓"} {Math.abs(trend).toFixed(1)} from last term</div>}
              </Card>
            );
          })}
        </div>
      </div>
    );
  }


  //  Term Comparison 
  function TermComparison(){
    // Filter by class and year — term filter not applied here (we want to see all terms)
    const baseResults=results.filter(r=>{
      const s=studentMap[r.student_id];
      if(!s) return false;
      if(classFilter!=="all"&&s.class!==classFilter) return false;
      if(yearFilter!=="all"&&r.year!==parseInt(yearFilter)) return false;
      return true;
    });
    const termData={};
    baseResults.forEach(r=>{
      const key=`${_termName(r.term)}, ${r.year}`;
      if(!termData[key]) termData[key]={label:key,term:r.term,year:r.year,means:[],count:0};
      const mean=r.subjects?.length?(r.subjects.reduce((a,b)=>a+b.marks,0)/r.subjects.length):0;
      termData[key].means.push(mean);
      termData[key].count+=1;
    });
    const termList=Object.values(termData)
      .sort((a,b)=>a.year!==b.year?a.year-b.year:a.term-b.term)
      .map(t=>({...t,avg:parseFloat((t.means.reduce((a,b)=>a+b,0)/t.means.length).toFixed(1))}));
    if(termList.length===0) return <EmptyState/>;

    const allClassNames=[...new Set(students.map(s=>s.class))].sort();
    const COLORS=[T.primary,T.secondary,T.teal,T.green,T.amber,T.purple];

    return(
      <div>
        {/* Class filter for this view */}
        <Card style={{marginBottom:12,padding:"12px 16px"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
            <span style={{fontSize:12,color:T.textMuted,fontWeight:600}}>Filter by class:</span>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              <button onClick={()=>setClassFilter("all")}
                style={{padding:"5px 12px",borderRadius:8,border:`1.5px solid ${classFilter==="all"?T.primary:T.border}`,background:classFilter==="all"?T.primary:"#fff",color:classFilter==="all"?"#fff":T.textMid,fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>
                All Classes
              </button>
              {allClassNames.map((cls,i)=>(
                <button key={cls} onClick={()=>setClassFilter(cls)}
                  style={{padding:"5px 12px",borderRadius:8,border:`1.5px solid ${classFilter===cls?COLORS[i%COLORS.length]:T.border}`,background:classFilter===cls?COLORS[i%COLORS.length]:"#fff",color:classFilter===cls?"#fff":T.textMid,fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>
                  {cls}
                </button>
              ))}
            </div>
          </div>
        </Card>
        <Card style={{padding:"18px 8px 10px",marginBottom:16}}>
          <SLabel style={{paddingLeft:12}}>
            {classFilter==="all"?"School Average Per Term":`${classFilter} Average Per Term`}
          </SLabel>
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={termList} barCategoryGap="30%">
              <CartesianGrid strokeDasharray="3 3" stroke={T.borderLight} vertical={false}/>
              <XAxis dataKey="label" tick={{fill:T.textMuted,fontSize:10}} axisLine={false} tickLine={false}/>
              <YAxis domain={[0,100]} tick={{fill:T.textMuted,fontSize:10}} axisLine={false} tickLine={false}/>
              <Tooltip contentStyle={tt}/>
              <Bar dataKey="avg" radius={[6,6,0,0]} name="Average">
                {termList.map((e,i)=><Cell key={i} fill={[T.primary,T.secondary,T.teal,T.green][i%4]}/>)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Card>
        <Card style={{padding:0,overflow:"hidden"}}>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
            <thead><tr style={{background:T.surfaceAlt}}>
              {["Term","Year","Avg Mark","Students","Change"].map(h=><th key={h} style={{padding:"10px 14px",color:T.textMuted,fontWeight:700,textAlign:"left",borderBottom:`1px solid ${T.border}`}}>{h}</th>)}
            </tr></thead>
            <tbody>
              {termList.map((t,i)=>{
                const prev=termList[i-1];
                const change=prev?t.avg-prev.avg:null;
                return(
                  <tr key={t.label} style={{borderBottom:`1px solid ${T.borderLight}`,background:i%2===0?"#fff":T.surfaceAlt}}>
                    <td style={{padding:"11px 14px",fontWeight:700}}>{_termName(t.term)}</td>
                    <td style={{padding:"11px 14px",color:T.textMuted}}>{t.year}</td>
                    <td style={{padding:"11px 14px"}}><span style={{fontWeight:800,color:T.primary,fontSize:15}}>{t.avg}</span></td>
                    <td style={{padding:"11px 14px",color:T.textMuted}}>{t.count}</td>
                    <td style={{padding:"11px 14px"}}>
                      {change===null?<span style={{color:T.textFaint}}>—</span>
                      :<span style={{color:change>=0?T.green:T.red,fontWeight:600}}>{change>=0?"↑":"↓"} {Math.abs(change).toFixed(1)}</span>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Card>
      </div>
    );
  }


  function EmptyState(){
    return(
      <Card style={{textAlign:"center",padding:48,color:T.textMuted}}>
        <div style={{fontSize:40,marginBottom:12}}></div>
        <div style={{fontWeight:700,fontSize:15,marginBottom:6}}>No results data yet</div>
        <div style={{fontSize:13}}>Upload results via the Upload tab to see analytics here.</div>
      </Card>
    );
  }

  return(
    <div>
      <h2 style={{margin:"0 0 4px",fontSize:22,fontWeight:800}}>School Analytics</h2>
      <p style={{color:T.textMuted,fontSize:13,margin:"0 0 20px"}}>Performance insights based on uploaded results</p>

      {/* Filters */}
      <Card style={{marginBottom:20,padding:"14px 16px"}}>
        <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"center"}}>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontSize:12,color:T.textMuted,fontWeight:600}}>Class:</span>
            <select value={classFilter} onChange={e=>setClassFilter(e.target.value)} style={{background:T.surfaceAlt,border:`1px solid ${T.border}`,borderRadius:8,padding:"5px 10px",color:T.textMid,fontSize:12,fontFamily:"inherit"}}>
              {classes.map(c=><option key={c} value={c}>{c==="all"?"All Classes":c}</option>)}
            </select>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontSize:12,color:T.textMuted,fontWeight:600}}>Term:</span>
            <select value={termFilter} onChange={e=>setTermFilter(e.target.value)} style={{background:T.surfaceAlt,border:`1px solid ${T.border}`,borderRadius:8,padding:"5px 10px",color:T.textMid,fontSize:12,fontFamily:"inherit"}}>
              {terms.map(t=><option key={t} value={t}>{t==="all"?"All Terms":_termName(t)}</option>)}
            </select>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontSize:12,color:T.textMuted,fontWeight:600}}>Year:</span>
            <select value={yearFilter} onChange={e=>setYearFilter(e.target.value)} style={{background:T.surfaceAlt,border:`1px solid ${T.border}`,borderRadius:8,padding:"5px 10px",color:T.textMid,fontSize:12,fontFamily:"inherit"}}>
              {years.map(y=><option key={y} value={y}>{y==="all"?"All Years":y}</option>)}
            </select>
          </div>
        </div>
      </Card>

      {/* View switcher */}
      <div style={{display:"flex",gap:8,marginBottom:20}}>
        {[["subjects",<><IconAnalytics size={14}/> Subject Difficulty</>],["trends",<><IconTrends size={14}/> Class Trends</>],["comparison",<><IconDashboard size={14}/> Term Comparison</>]].map(([id,label])=>(
          <button key={id} onClick={()=>setView(id)} style={{padding:"8px 16px",borderRadius:10,border:`1.5px solid ${view===id?T.primary:T.border}`,background:view===id?T.primary:"#fff",color:view===id?"#fff":T.textMid,fontWeight:view===id?700:500,fontSize:13,cursor:"pointer",fontFamily:"inherit",transition:"all 0.2s"}}>
            {label}
          </button>
        ))}
      </div>

      {loading&&<Card style={{textAlign:"center",padding:48,color:T.textMuted}}>Loading analytics…</Card>}
      {!loading&&view==="subjects"&&<SubjectDifficulty/>}
      {!loading&&view==="trends"&&<ClassTrends/>}
      {!loading&&view==="comparison"&&<TermComparison/>}
    </div>
  );
}

function AdminSettings({user,school,showToast}){
  const [sf,setSf]=useState({name:school?.name||"",location:school?.location||"",phone:school?.phone||"",county:school?.county||""});
  const [pf,setPf]=useState({name:user.name,email:user.email});
  async function saveSchool(){
    await supabase.from("schools").update({
      name:      sf.name,
      location:  sf.location,
      phone:     sf.phone,
      county:    sf.county,
    }).eq("id",school.id);
    showToast("School settings saved","success");
  }
  async function saveProfile(){
    await supabase.from("accounts").update({name:pf.name}).eq("id",user.id);
    showToast("Profile updated","success");
  }

  return(
    <div style={{maxWidth:560}}>
      <h2 style={{margin:"0 0 20px",fontSize:22,fontWeight:800}}>Settings</h2>
      <Card style={{marginBottom:16}}>
        <SLabel>School Information</SLabel>
        {/* NEMIS is read-only — it's the school's official government identifier */}
        <div style={{background:T.amberLight,border:`1px solid ${T.amber}44`,borderRadius:12,padding:"12px 16px",marginBottom:16,display:"flex",gap:12,alignItems:"center"}}>
          <span style={{fontSize:22}}></span>
          <div>
            <div style={{color:"#92400e",fontWeight:700,fontSize:12,textTransform:"uppercase",letterSpacing:0.8,marginBottom:2}}>School NEMIS Code (Official — Read Only)</div>
            <div style={{fontWeight:800,fontSize:18,color:T.text,letterSpacing:1}}>{school?.nemis}</div>
            <div style={{color:T.textMuted,fontSize:11,marginTop:2}}>This code is assigned by the Ministry of Education. Parents use it to locate and link to your school. Contact MoE to update.</div>
          </div>
        </div>
        <Field label="School Name" value={sf.name} onChange={v=>setSf(f=>({...f,name:v}))}/>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <Field label="Location / Town" value={sf.location} onChange={v=>setSf(f=>({...f,location:v}))}/>
          <Field label="County" value={sf.county} onChange={v=>setSf(f=>({...f,county:v}))}/>
        </div>
        <Field label="School Phone" value={sf.phone} onChange={v=>setSf(f=>({...f,phone:v}))} placeholder="+254…"/>
        <Btn onClick={saveSchool}>Save School Info</Btn>
      </Card>
      <Card style={{marginBottom:16}}>
        <SLabel>Admin Account</SLabel>
        <Field label="Your Name" value={pf.name} onChange={v=>setPf(f=>({...f,name:v}))}/>
        <Field label="Email (read-only)" value={pf.email} onChange={()=>{}} note="Email cannot be changed. Contact support if needed."/>
        <Btn onClick={saveProfile}>Save Profile</Btn>
      </Card>
      <Card>
        <SLabel>CBC Grade Reference</SLabel>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
          {CBC_GRADES.map(g=>(
            <div key={g.level} style={{background:g.bg,border:`1px solid ${g.color}22`,borderRadius:10,padding:"8px 12px",display:"flex",alignItems:"center",gap:8}}>
              <CBCBadge level={g.level}/><div><div style={{color:T.textMid,fontSize:11,fontWeight:600}}>{g.min}–{g.max}%</div><div style={{color:T.textFaint,fontSize:10}}>{g.points} pts · {g.label}</div></div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}

// 
// RESET PASSWORD SCREEN
// 
function ResetPasswordScreen({onDone}){
  const [pass,setPass]=useState("");
  const [confirm,setConfirm]=useState("");
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState("");
  const [done,setDone]=useState(false);
  const [expired,setExpired]=useState(false);
  // Countdown: Supabase recovery tokens are valid for 1 hour by default.
  // We show a 10-minute UI timer to encourage prompt action.
  const TIMER_SECONDS = 10 * 60;
  const [secondsLeft,setSecondsLeft]=useState(TIMER_SECONDS);

  useEffect(()=>{
    const interval=setInterval(()=>{
      setSecondsLeft(s=>{
        if(s<=1){ clearInterval(interval); setExpired(true); return 0; }
        return s-1;
      });
    },1000);
    return()=>clearInterval(interval);
  },[]);

  const mins=String(Math.floor(secondsLeft/60)).padStart(2,"0");
  const secs=String(secondsLeft%60).padStart(2,"0");
  const urgentColor=secondsLeft<60?T.red:secondsLeft<180?T.amber:T.green;

  async function submit(){
    setError("");
    if(!pass||!confirm){setError("Please fill all fields.");return;}
    if(pass!==confirm){setError("Passwords do not match.");return;}
    const strength=checkPasswordStrength(pass);
    if(!strength.valid){setError("Password is too weak. Please meet all requirements.");return;}
    setLoading(true);
    const {error:err}=await supabase.auth.updateUser({password:pass});
    setLoading(false);
    if(err){
      // Token expired or invalid session
      if(err.message?.toLowerCase().includes("expired")||err.message?.toLowerCase().includes("invalid")||err.status===401){
        setExpired(true);
      } else {
        setError(err.message||"Failed to update password. Please try again.");
      }
      return;
    }
    setDone(true);
    setTimeout(()=>onDone(),2500);
  }

  return(
    <div style={{minHeight:"100vh",background:T.bg,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Inter',sans-serif",padding:24}}>
      <div style={{width:"100%",maxWidth:400}}>
        <div style={{textAlign:"center",marginBottom:32}}>
          <div style={{fontSize:30,fontWeight:800,color:T.text,letterSpacing:"-0.5px",lineHeight:1}}>EduGrade</div>
          <div style={{fontSize:11,color:T.textFaint,letterSpacing:0.5,marginTop:4}}>CBC ACADEMIC PORTAL</div>
        </div>
        <Card style={{padding:32}}>
          {done?(
            <div style={{textAlign:"center",padding:"16px 0"}}>
              <div style={{fontSize:40,marginBottom:12}}>✅</div>
              <h2 style={{margin:"0 0 8px",fontSize:20,fontWeight:800,color:T.text}}>Password Updated!</h2>
              <p style={{color:T.textMuted,fontSize:14,margin:0}}>Redirecting you to sign in…</p>
            </div>
          ):expired?(
            <div style={{textAlign:"center",padding:"16px 0"}}>
              <div style={{width:64,height:64,borderRadius:99,background:T.redLight,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 16px"}}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={T.red} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              </div>
              <h2 style={{margin:"0 0 8px",fontSize:20,fontWeight:800,color:T.text}}>Link Expired</h2>
              <p style={{color:T.textMuted,fontSize:13,margin:"0 0 24px",lineHeight:1.6}}>
                This password reset link has expired. Reset links are only valid for a limited time for your security.
              </p>
              <Btn full onClick={onDone}>← Back to Sign In</Btn>
              <p style={{color:T.textFaint,fontSize:12,marginTop:12}}>Request a new reset link from the sign in page.</p>
            </div>
          ):(
            <>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                <h2 style={{margin:0,fontSize:20,fontWeight:800,color:T.text}}>Set New Password</h2>
                <div style={{background:urgentColor+"22",border:`1px solid ${urgentColor}44`,borderRadius:8,padding:"4px 10px",display:"flex",alignItems:"center",gap:5}}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={urgentColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  <span style={{fontSize:12,fontWeight:700,color:urgentColor,fontVariantNumeric:"tabular-nums"}}>{mins}:{secs}</span>
                </div>
              </div>
              <p style={{margin:"0 0 22px",color:T.textMuted,fontSize:13}}>Choose a strong password for your account</p>
              {error&&<div style={{background:T.redLight,border:`1px solid ${T.red}33`,borderRadius:10,padding:"10px 14px",color:T.red,fontSize:13,marginBottom:16}}>{error}</div>}
              <Field label="New Password" value={pass} onChange={setPass} type="password"/>
              <PasswordStrengthBar password={pass}/>
              <div style={{marginTop:10}}>
                <Field label="Confirm Password" value={confirm} onChange={setConfirm} type="password"/>
              </div>
              <Btn onClick={submit} disabled={loading} full size="lg" style={{marginTop:8}}>{loading?"Updating…":"Update Password"}</Btn>
            </>
          )}
        </Card>
      </div>
    </div>
  );
}

// 
// ROOT
// 
export default function App(){
  // Supabase appends #access_token=...&type=recovery to the redirectTo URL.
  // Since we redirect to the root, this hash lands on the home page and we
  // detect it here before any auth state fires, jumping straight to the reset form.
  const isRecoveryUrl = typeof window !== "undefined" &&
    window.location.hash.includes("type=recovery");

  const [screen,setScreen]=useState(isRecoveryUrl ? "reset-password" : "login");
  const [currentUser,setCurrentUser]=useState(null);
  const [sessionChecked,setSessionChecked]=useState(isRecoveryUrl ? true : false);

  function login(acc){setCurrentUser(acc);setScreen("app");}
  function logout(){setCurrentUser(null);setScreen("login");}

  useEffect(()=>{
    // onAuthStateChange fires synchronously for the current session on mount.
    // We use it as the single source of truth — getSession() is NOT called
    // separately to avoid the race condition where a recovery session gets
    // treated as a normal login before PASSWORD_RECOVERY fires.
    const sub = onAuthStateChange(async (event, session) => {
      if (event === "PASSWORD_RECOVERY") {
        // User clicked the reset link — show the reset form, do NOT log them in.
        setScreen("reset-password");
        setSessionChecked(true);
        return;
      }
      if (event === "SIGNED_OUT") {
        logout();
        return;
      }
      if (event === "SIGNED_IN" || event === "TOKEN_REFRESHED") {
        // If we already detected a recovery URL on load, ignore the SIGNED_IN
        // event that Supabase fires alongside PASSWORD_RECOVERY.
        if (isRecoveryUrl) return;
        // Normal login or session restore — fetch profile and log in.
        if (session?.user) {
          const { data } = await supabase.from("accounts").select("*").eq("id", session.user.id).single();
          if (data) {
            login(data);
          } else {
            await supabase.auth.signOut();
          }
        }
        setSessionChecked(true);
        return;
      }
      // Any other event (USER_UPDATED etc.) — just mark as checked.
      setSessionChecked(true);
    });
    return () => sub.unsubscribe();
  },[]);

  if(!sessionChecked) return(
    <div style={{minHeight:"100vh",background:"#f4f6f9",display:"flex",alignItems:"center",
      justifyContent:"center",fontFamily:"'Inter',sans-serif"}}>
      <div style={{textAlign:"center"}}>
        <div style={{fontSize:26,fontWeight:800,color:"#111827",letterSpacing:"-0.5px",lineHeight:1,marginBottom:4}}>EduGrade</div>
        <div style={{fontSize:11,color:"#9ca3af",letterSpacing:0.5,marginBottom:16}}>CBC ACADEMIC PORTAL</div>
        <div style={{fontSize:14,color:"#6b7280",fontWeight:600}}>Loading…</div>
      </div>
    </div>
  );

  return(
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        *{box-sizing:border-box;}
        body{margin:0;background:#f4f6f9;font-family:'Inter',sans-serif;}
        @keyframes slideIn{from{opacity:0;transform:translateX(30px);}to{opacity:1;transform:translateX(0);}}
        @keyframes scaleIn{from{opacity:0;transform:scale(0.94);}to{opacity:1;transform:scale(1);}}
        @keyframes pulse{0%,100%{opacity:1;}50%{opacity:0.4;}}
        input:focus,textarea:focus,select:focus{border-color:#3b82f6!important;box-shadow:0 0 0 3px rgba(59,130,246,0.12)!important;outline:none!important;}
        button:active{opacity:0.82;}
        ::-webkit-scrollbar{width:4px;height:4px;}
        ::-webkit-scrollbar-track{background:transparent;}
        ::-webkit-scrollbar-thumb{background:#d1d5db;border-radius:99px;}
      `}</style>
      {screen==="reset-password"&&<ResetPasswordScreen onDone={()=>{setCurrentUser(null);setScreen("login");}}/>}
      {screen==="login"         &&<LoginScreen         onLogin={login} onRegister={()=>setScreen("register")} onSchoolRegister={()=>setScreen("school-register")}/>}
      {screen==="register"      &&<RegisterScreen      onLogin={login} onBack={()=>setScreen("login")}/>}
      {screen==="school-register"&&<SchoolRegisterScreen onLogin={login} onBack={()=>setScreen("login")}/>}
      {screen==="app"&&currentUser&&(
        currentUser.role==="admin"
          ?<AdminApp  user={currentUser} onLogout={logout}/>
          :<ParentApp user={currentUser} onLogout={logout}/>
      )}
    </>
  );
}
// Term name helper
function _termName(t){
  const n=parseInt(t);
  const names={1:"Mid-Term 1",2:"Term 1",3:"Mid-Term 2",4:"Term 2",5:"Mid-Term 3",6:"Term 3"};
  return names[n]||("Term "+n);
}

